<template>
    <div >
        <!-- @contextmenu.prevent="handleContextMenu" -->
    <v-overlay :value="loader">
        <v-progress-circular
            indeterminate
            :size="120"
            :width="3"
        ></v-progress-circular>Loading, please wait...
    </v-overlay>
    <v-overlay :value="cmLoader"> <!-- EDIT AND CANCEL BUTTON FOR PLANNER -->
        <v-progress-circular
            indeterminate
            :size="120"
            :width="3"
        ></v-progress-circular>Gathering data, please wait...
    </v-overlay>
        <div>
            <v-row class="ml-5">
                    <v-col>
                        <div>
                            <!-- <span class="justify-right">{{ cadRequestBasicInformation.construction_code }} {{ cadRequestBasicInformation.customer_name }} 様邸 <span v-if="$store.state.authorityResponse == 1" style="color:red">(参照権限のみ)</span> </span> -->
                            <span class="justify-right">{{ cadRequestBasicInformation.construction_code }} {{ cadRequestBasicInformation.customer_name }} 様邸 </span>
                        </div>
                            
                    </v-col>
                </v-row>
                <!-- <v-row no-gutters> -->
                    <!-- <v-col cols="2" class="text-center"> -->
                        <!-- <div> -->
                            <!-- ACTUAL PLANS -->
                            <!-- <a :disabled="actualButton == false" style="font-size: 13px;" href='#target1' id='target1' class='target' @click="getCadActualData()">  新規CAD依頼及び送信済みデータ  </a>  -->
                        <!-- </div>  -->
                        <!-- :disabled="actualButton == false" -->
                    <!-- </v-col> -->
                    <!-- <v-col cols="1"> -->
                        <!-- <div> -->
                            <!-- DRAFT PLANS -->
                            <!-- <a :disabled="draftButton == false" style="font-size: 13px;text-align: left !important" href='#target2' id='target2' class='target' @click="getCadDraftData()">  下書き保存データ  </a>     -->
                        <!-- </div>  -->
                        <!-- :disabled="draftButton == false" -->
                    <!-- </v-col> -->
                    <!-- <v-col cols="1"> -->
                        <!-- <div> -->
                            <!-- DELETED PLANS -->
                            <!-- <a :disabled="deleteButton == false" style="font-size: 13px;text-align: left !important" href='#target3' id='target3' class='target' @click="getDeletedData()">  削除済みデータ  </a>  -->
                        <!-- </div>  -->
                        <!-- :disabled="deleteButton == false" -->
                    <!-- </v-col> -->
                <!-- </v-row> -->
                <!-- <v-row class="ml-2" no-gutters>
                    <v-col>
                        <v-radio
                            label="Try">
                        </v-radio>
                    </v-col>
                </v-row> -->

                <v-row class="ml-2" no-gutters>
                    <v-col>
                        <template>
                            <!-- :disabled="actualButton == false" -->
                            <v-tabs v-model="activeBtn" height="20px" hide-slider>
                                <v-tab
                                    @click="getCadActualData()"
                                    :class="{'black-tab': activeBtn, 'blue-tab': btnSelection === 'ACTUAL'}"
                                >新規CAD依頼及び送信済みデータ</v-tab>
                                <v-tab
                                    :disabled="draftButton == false"
                                    @click="getCadDraftData()"
                                    :class="{'black-tab': $store.state.draftButton, 'gray-tab': !$store.state.draftButton, 'blue-tab': btnSelection === 'DRAFT'}"
                                >下書き保存データ</v-tab>
                                <v-tab
                                    :disabled="deleteButton == false"
                                    @click="getDeletedData()"
                                    :class="{ 'black-tab': $store.state.deleteButton, 'gray-tab': !$store.state.deleteButton, 'blue-tab': btnSelection === 'DELETED'}"
                                >削除済みデータ</v-tab>
                            </v-tabs>
                        </template>
                    </v-col>
                </v-row>
        </div>
        <div>
            <!-- <section ref="el" style="overflow:auto;" :style="{cursor: isDragging ? 'grabbing' : 'grab', scrollSnapType : isDragging ? '' : ''}" @mousedown="onMouseDown" @mouseup="onMouseUp"> -->
            <v-simple-table class="plannersTable mx-2" height="82vh" fixed-header ref="myTable" style="overflow-y: auto;">
                <!-- <section ref="el" style="overflow:auto;" :style="{cursor: isDragging ? 'grabbing' : 'grab', scrollSnapType : isDragging ? '' : ''}" @mousedown="onMouseDown" @mouseup="onMouseUp"> -->
                <div class="pang prevent ng expand ng columns :)"> <!-- dont remove this div! -->
                <!-- <section ref="el" :style="{cursor: isDragging ? 'grabbing' : 'grab', scrollSnapType : isDragging ? '' : ''}" @mousedown="onMouseDown" @mouseup="onMouseUp"> -->
                    <thead>
                        <tr>
                            <th class="top-left-sticky" style="min-width: 150px !important;  text-align: left !important; height: 110px !important;" >
                                <h2 class="ml-2">依頼日</h2>
                            </th>
                            <!-- SECTION Recent Revisions -->
                            <th class="top-sticky" style="min-width: 150px !important;" v-for="(i, ii) in existingRevisions" :key="ii">
                                <div style="text-align: center !important;">
                                    <span class="h1 font-weight-black ml-2" v-if="existingRevisions[ii].updated_at == null || existingRevisions[ii].updated_at != null && (loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1)">
                                        {{ existingRevisions[ii].created_at }}</span>
                                    <span class="h1 font-weight-black ml-2" v-else-if="existingRevisions[ii].created_at != null && loggedInUser.is_gc_user == '1' || loggedInUser.is_ichijo_user == '1' || loggedInUser.is_rulebook_user == '1' || loggedInUser.is_special_account == '1' || loggedInUser.is_hrd_requestor == '1' || loggedInUser.japan_admin == '1'">
                                        {{ existingRevisions[ii].created_at }}</span>
                                    <span class="h1 font-weight-black ml-2" v-else-if="existingRevisions[ii].created_at != null || existingRevisions[ii].updated_at != null && loggedInUser.is_gc_user == '1' || loggedInUser.is_ichijo_user == '1' || loggedInUser.is_rulebook_user == '1' || loggedInUser.is_special_account == '1' || loggedInUser.japan_admin == '1'">
                                        {{ existingRevisions[ii].updated_at }}</span><br>    
                                    <span class="h1 font-weight-black ml-2">{{ existingRevisions[ii].time }}</span><br>
                                    <span class="h1 font-weight-black ml-2" v-if="editMode && ii == editIndex">{{ editCadRequestRevisionContent.house_type_name }}</span>
                                    <span class="h1 font-weight-black ml-2" v-else>{{ existingRevisions[ii].house_type_name }}</span><br>
                                    <span class="h1 font-weight-black red--text" v-if="btnSelection == 'DELETED'" small>
                                        Deleted By:&nbsp;
                                        <template v-if="isJapanese(existingRevisions[ii].deletedByName)">
                                            {{ existingRevisions[ii].deletedByName }}
                                        </template>
                                        <template v-else>
                                            <!-- {{ existingRevisions[ii].deletedByName.split(' ')[0] }} --> 
                                            <!-- IF DELETED BY SOMEONE THAT STARTS WITH HRD IT WILL NOT INCLUDE IN THE TABLE -->
                                            <!-- {{ existingRevisions[ii].deletedByName.startsWith('HRD') ? existingRevisions[ii].deletedByName.replace('HRD ', '') : existingRevisions[ii].deletedByName.split(' ')[0] }} -->
                                            {{ existingRevisions[ii].deletedByName ? (existingRevisions[ii].deletedByName.startsWith('HRD') ? existingRevisions[ii].deletedByName.replace('HRD ', '') : existingRevisions[ii].deletedByName.split(' ')[0]) : '' }}
                                        </template>
                                    </span>
                                    <div v-if="editMode && ii == editIndex">
                                        <br>
                                            <!-- <v-btn :disabled="cadRequestBasicInformation.house_type_id != 3 && cadRequestBasicInformation.house_type_id != 29 && cadRequestBasicInformation.house_type_id != 37"  @click="openSRS()" class="mb-3" dense color="primary">SRS</v-btn> -->
                                        
                                            <v-btn :disabled="!(($store.state.loggedInUser.isHokkaidou_planner == 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.house_type_category_id == '2')) || ($store.state.loggedInUser.isHokkaidou_planner != 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.hokkaidou == '2')) || ($store.state.loggedInUser.isHokkaidou_planner == null && $store.state.loggedInUser.can_use_srs == 1)) || disabledSelectedShio" @click="openSRS()" class="mb-3" v-if="cadRequestLatestRevision" dense color="primary">SRS</v-btn><br>
                                    </div>
                                </div> 
                                <div style="text-align: center !important;">
                                    <v-btn @click="restorePlan(ii)" v-show="btnSelection == 'DELETED'" class="mb-5" color="blue-grey" dark small id="cancel">  RESTORE  </v-btn>
                                    <v-btn @click="restoreDraft(i,ii)" v-show="btnSelection == 'DRAFT'" class="mb-5" color="blue-grey" dark small id="draft">  SUBMIT  </v-btn>
                                    <span v-show="existingRevisions[ii].hrd_accept == 1 && btnSelection != 'DELETED'" class="caption font-weight-black blue--text ml-2">受付処理中<br></span>
                                    <span v-show="existingRevisions[ii].express == 1 && btnSelection != 'DELETED'" class="caption font-weight-black red--text ml-2">EXPRESS<br></span>
                                    <!-- <span v-show="existingRevisions[ii].hrd_process == 1 && btnSelection != 'DELETED'" class="caption font-weight-black blue--text ml-2">HRD PROCESS<br></span> -->
                                    <span v-show="existingRevisions[ii].revision_type == '8' && btnSelection != 'DELETED'" class="caption font-weight-black blue--text ml-2">HRD PROCESS<br></span>
                                    <span v-show="existingRevisions[ii].revision_type == '9' && btnSelection != 'DELETED'" class="caption font-weight-black blue--text ml-2">CPN<br></span>
                                    <span v-show="existingRevisions[ii].revision_type == '10'" style="font-size:10px;" class="font-weight-black red--text ml-2 mr-2">Apply in Next CAD Request</span>
                                </div>

                            </th>
                            <!--!SECTION Recent Revisions -->

                            <!-- SECTION Current Revision -->
                            <th class="top-sticky" style="min-width: 150px !important;" v-if="editMode == false && btnSelection != 'DRAFT' && btnSelection != 'DELETED' && $store.state.authorityResponse != 1">
                                <div style="text-align: center !important;">
                                    <p class="h1 font-weight-black ml-2">{{ today }}</p>
                                    <!-- <v-btn :disabled="cadRequestBasicInformation.house_type_id != 3 && cadRequestBasicInformation.house_type_id != 29 && cadRequestBasicInformation.house_type_id != 37" @click="openSRS()" class="mb-3" v-if="cadRequestLatestRevision" dense color="primary">SRS</v-btn><br> -->
                                    <v-btn :disabled="!(($store.state.loggedInUser.isHokkaidou_planner == 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.house_type_category_id == '2')) || ($store.state.loggedInUser.isHokkaidou_planner != 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.hokkaidou == '2')) || ($store.state.loggedInUser.isHokkaidou_planner == null && $store.state.loggedInUser.can_use_srs == 1)) || disabledSelectedShio" @click="openSRS()" class="mb-3" v-if="cadRequestLatestRevision" dense color="primary">SRS</v-btn><br>
                                    <v-btn
                                        v-if="existingRevisions.length > 0 && cadRequestLatestRevision"
                                        @click="copyPrevious()"
                                        color="info"
                                        x-small
                                        outlined>
                                        前回の依内容頼をコピー
                                    </v-btn><br>

                                    <span v-show="hrd_process_stamp" class="caption font-weight-black blue--text ml-2">HRD PROCESS</span>
                                    <!-- <p class="caption font-weight-black blue--text ml-2">受付処理中</p> -->
                                </div>
                            </th>
                            <!-- !SECTION Current Revision -->
                            <!-- <th class="top-sticky" style="min-width: 150px !important;">
                                <div style="text-align: center !important;">
                                    <p class="h1 font-weight-black ml-2">{{ today }}</p>
                                    <p class="caption font-weight-black blue--text ml-2">受付処理中</p>
                                </div>
                            </th> -->
                        </tr>
                    </thead>
                    <tbody style="scroll-snap-align: start !important;">
                        <tr v-for="(vHeader, i) in verticalHeaders" :key="i" class="text-center">
                            <th v-if="vHeader.header == 'actions'" style="width: 50px !important; text-align: left !important; background-color: white !important; border:none !important;"> </th>
                            <th v-else style="width: 50px !important; text-align: left !important" :class="checkHeader(vHeader.header)" > 
                                <p class="font-weight-black mx-2" style="font-size:19px">{{ vHeader.header }}</p> 
                                <p class="caption font-weight-light red--text mx-2 mt-n1" v-for="(subheader, ii) in vHeader.subheaders" :key="ii + subheader">{{ subheader }}</p>
                            </th>
                            
    
                            <!-- SECTION Recent -->
                            <template v-for="(exist, ii) in existingRevisions" >
                                <!-- <template v-if="i != dataCount"> Sample 1 -->
                                <template v-if="!editMode || ii != editIndex" >
                                    <!-- CAD依頼送信者 -->
                                    <td 
                                        id="B1"
                                        ref="B1"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'CAD依頼送信者'" 
                                        class="second2-top-left-sticky font-weight-black" 
                                
                                    > {{exist.plannersName.toUpperCase() }} </td>

                                    <!-- 図面番号 -->
                                    <td 
                                        id="B2"
                                        ref="B2"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '図面番号'" 
                                        class="third2-top-left-sticky font-weight-black"
                                    >
                                    <span class="overline font-weight-black">
                                        {{exist.revision_number}}
                                    </span>
                                    <!-- <span v-else>
                                        <v-btn @click="toggleDialogRevision(true)" icon>
                                            <v-icon>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn> 
                                    </span> -->
                                    </td>

                                    <!-- 設計受託契約 -->
                                    <td 
                                        id="B3"
                                        ref="B3"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '設計受託契約'" 
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    >
                                        <v-container>
                                            <v-icon v-show="exist.design_contract == 1" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                    </td>

                                    <!-- 最高高さ・見付面積・平均GL計算根拠 -->
                                    <td 
                                        id="B4"
                                        ref="B4"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '最高高さ・見付面積・平均GL計算根拠'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    >  
                                        <v-container>
                                            <v-icon  v-show="exist.calculation_basis == 1" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                    </td>

                                    <!-- カラー配置図 -->
                                    <td 
                                        id="B5"
                                        ref="B5"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'カラー配置図'"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    >
                                        <v-container>
                                            <v-btn-toggle dense group class="btn-toggle" style="cursor:pointer;">
                                                <v-btn 
                                                    readonly
                                                    v-for="(siteLayout, iii) in siteLayouts"
                                                    :key="iii + 'siteLayout'"
                                                    :value="siteLayout" 
                                                    text 
                                                    small 
                                                    class="mt-n1"
                                                    > 
                                                    <span class="font-weight-black selected" v-if="exist.site_layout == siteLayout">{{siteLayout}}</span> 
                                                    <span class="font-weight-black" v-else>{{siteLayout}}</span> 
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-container>
                                    </td>

                                    <!-- スペック依頼 -->
                                    <td 
                                        id="B6"
                                        ref="B6"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'スペック依頼'"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                    <div>
                                        <v-container v-if="exist.specs_irai">
                                            <div id="toggleB6_1">
                                                <v-btn-toggle  dense group style="cursor:pointer;">
                                                    <v-btn 
                                                        v-for="(sashType, iii) in SASH_TYPE"
                                                        :key="iii + 'sashType'"
                                                        :value="sashType.sash_spec" 
                                                        text 
                                                        small 
                                                        class="mt-n1"
                                                        > 
                                                        <span class="font-weight-black selected" v-if="exist.specs_irai.sash_type == sashType.sash_spec"> {{sashType.sash_spec}} </span> 
                                                        <span class="font-weight-black" v-else> {{sashType.sash_spec}} </span> 
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                            <div id="toggleB6_2">
                                                <v-btn-toggle dense group>
                                                    強化:<v-btn 
                                                        v-for="(spec, iii) in specs"
                                                        :key="iii + 'spec'"
                                                        :value="spec" 
                                                        text 
                                                        small 
                                                        class="mt-n1"
                                                        > 
                                                        <span class="font-weight-black selected" v-if="exist.specs_irai.specs == spec"> {{ spec }} </span>
                                                        <span class="font-weight-black" v-else> {{ spec }} </span>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                            <div id="toggleB6_3">
                                                <v-btn-toggle dense group multiple>
                                                    <v-btn 
                                                        v-for="(acce, iii) in SASH_ACCESSORIES"
                                                        :key="iii"
                                                        :value="acce.accessory_name" 
                                                        text 
                                                        small 
                                                        class="mt-n1"
                                                        > 
                                                            <!-- <div v-for="(acc, iiii) in exist.specs_irai.accessories" :key="iiii + 'acc'"> -->
                                                            <!-- {{exist.specs_irai.accessories.value, acce}} -->
                                                                <span class="selected" v-if="exist.specs_irai.accessories.find(item => item.value === acce.accessory_name)">{{ acce.accessory_name }}</span>
                                                                <span class="font-weight-black" v-else>{{ acce.accessory_name }}</span>   
                                                            <!-- </div> -->
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                            <div id="toggleB6_4">
                                                <v-btn-toggle dense group class="specific-toggle">
                                                    <v-btn
                                                        v-for="(hc, iii) in honeycomb"
                                                        :key="iii + 'hc'"
                                                        :value="hc"
                                                        text
                                                        small
                                                        class="mt-n1"
                                                        >
                                                        <span class="font-weight-black selected" v-if="exist.specs_irai.honeycomb == hc">{{ hc }}</span> 
                                                        <span class="font-weight-black" v-else> {{ hc }} </span>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                        </v-container>

                                        <v-container v-else>
                                            <div id="toggleB6_1">
                                                <v-btn-toggle  dense group >
                                                    <v-btn 
                                                        readonly
                                                        v-for="(sashType, iii) in SASH_TYPE"
                                                        :key="iii + 'sashType'"
                                                        :value="sashType.sash_spec" 
                                                        text 
                                                        small 
                                                        class="mt-n1"
                                                        > 
                                                        <span class="font-weight-black"> {{sashType.sash_spec}} </span> 
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                            <div id="toggleB6_2">
                                                <v-btn-toggle dense group>
                                                    強化:<v-btn 
                                                        readonly
                                                        v-for="(spec, iii) in specs"
                                                        :key="iii + 'spec'"
                                                        :value="spec" 
                                                        text 
                                                        small 
                                                        class="mt-n1"
                                                        > 
                                                        <span class="font-weight-black" > {{ spec }} </span>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                            <div>
                                                <v-btn-toggle dense group multiple>
                                                    <v-btn 
                                                        readonly
                                                        v-for="(acce, iii) in SASH_ACCESSORIES"
                                                        :key="iii + 'acce'"
                                                        :value="acce.accessory_name" 
                                                        text 
                                                        small 
                                                        class="mt-n1"
                                                        > 
                                                        <span class="font-weight-black" >{{ acce.accessory_name }}</span>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                            <div id="toggleB6_4">
                                                <v-btn-toggle dense group class="specific-toggle">
                                                    <v-btn
                                                        readonly
                                                        v-for="(hc, iii) in honeycomb"
                                                        :key="iii + 'hc'"
                                                        :value="hc"
                                                        text
                                                        small
                                                        class="mt-n1"
                                                        >
                                                        <span class="font-weight-black"> {{ hc }} </span>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                        </v-container>
                                    </div>
                                    </td>

                                    <!-- DXFデータ依頼 -->
                                    <td 
                                        id="B7"
                                        ref="B7"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'DXFデータ依頼'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container>
                                            <v-icon v-show="exist.dxf_data_request == 1" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                    </td>

                                    <!-- カラーパース -->
                                    <td 
                                        id="B8"
                                        ref="B8"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'カラーパース'"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    >
                                    <div> 
                                        <v-container style="cursor:pointer;">
                                                <!-- {{ii}} -->
                                            <v-icon color="red" v-show="exist.color_perspective.length > 0">mdi-checkbox-blank-circle-outline</v-icon>
                                            <div v-if="exist.color_perspective.length > 0">
                                                <v-simple-table v-if="exist.color_perspective[0].is_request_color_info != 1">
                                                    <thead>
                                                        <tr>
                                                            <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                            <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点方向</th>
                                                            <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点高さ</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in exist.color_perspective" :key="index">
                                                            <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                            <td style="font-size: 10px !important; height: 10% !important">{{ item.perspective_direction }}</td>
                                                            <td style="font-size: 10px !important; height: 10% !important">{{ item.viewpoint_height }}</td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </div>
                                        </v-container>
                                    </div>
                                    </td>

                                    <!-- ハウス プレゼンテーション -->
                                    <td 
                                        id="B9"
                                        ref="B9"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'ハウス プレゼンテーション'"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container v-show="exist.house_presentation == 1" style="cursor:pointer;">

                                            <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                            <div v-if="exist.hp.length > 0">
                                                <!-- {{exist.hp[0].is_request_color_info}} -->

                                                <v-simple-table v-if="exist.hp[0].is_request_color_info != 1">
                                                    <thead>
                                                        <tr>
                                                            <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                            <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点方向</th>
                                                            <!-- <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点高さ</th> -->
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in exist.hp" :key="index">
                                                            <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                            <td style="font-size: 10px !important; height: 10% !important">{{ item.perspective_direction }}</td>
                                                            <!-- <td style="font-size: 10px !important; height: 10% !important">{{ item.viewpoint_height }}</td> -->
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </div>
                                        </v-container>
                                        <!-- <v-container v-if="exist.house_presentation == 'INT'">
                                            <span style="font-size:18px;color:red;">{{ exist.house_presentation }}</span>
                                        </v-container> -->
                                    </td>

                                    <!-- インテリアパース /  house_presentation_int -->
                                    <td
                                        id="B22"
                                        ref="B22"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'インテリアパース【トライアル】'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    >
                                        <v-container>
                                            <v-icon v-show="exist.house_presentation_int" color="red">mdi-checkbox-blank-circle-outline</v-icon><br>
                                                <span v-show="exist.house_presentation_int">パターン : <b>{{ exist.house_presentation_int }}</b></span>
                                        </v-container>

                                    <!-- <v-container v-if="exist.hp_int.length > 0">
                                        <v-icon color="red">mdi-checkbox-blank-circle-outline</v-icon>
                                        <div>
                                            <v-simple-table>
                                                <thead>
                                                    <tr>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">階</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">部屋</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in exist.hp_int" :key="index">
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.floor }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.layout }}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>
                                    </v-container> -->
                                    </td>

                                    <!-- 仕様検討ツール -->
                                    <td 
                                        id="B10"
                                        ref="B10"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '仕様検討ツール'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container v-if="editMode && ii == editIndex">
                                            <v-icon v-show="editCadRequestRevisionContent.shio_request" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                        <v-container v-else >
                                            <div v-show="exist.shio_request == 1">
                                                <v-icon v-if="exist.srs_shio && exist.srs_shio.shio_selection !== '2'" color="red">mdi-checkbox-blank-circle-outline</v-icon><br>
                                                <span v-if="exist.srs_shio && exist.srs_shio.shio_selection == '1'" style="color:blue !important;"><b>SRS</b><br></span>
                                                <span v-if="exist.srs_shio && exist.srs_shio.shio_selection == '2'" style="color:red !important;"><b>PEL only</b><br></span>
                                                <span v-if="exist.srs_shio && exist.srs_shio.shio_selection == '3'" style="color:blue !important;"><b>SRS+PDF</b><br></span>
                                               
                                                <!-- <span v-if="exist.srs_shio && exist.srs_shio.shio_selection == '1'">仕様書番号 : {{exist.srs_shio.SRS_data}}</span> -->
                                            </div>
                                        </v-container>
                                        
                                        <!-- <v-container v-if="editMode && ii == editIndex">
                                            <v-icon v-show="editCadRequestRevisionContent.shio_request" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                        <v-container v-else >
                                            <v-icon v-show="exist.shio_request == 1" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container> -->
                                    </td>

                                    <!-- WEB打ち合わせ用提案資料 -->
                                    <td 
                                        id="B11"
                                        ref="B11"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'WEB打ち合わせ用提案資料'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                    <!-- {{exist.web_documents}} -->
                                    <div>
                                        <span v-for="(item, index) in exist.web_documents" :key="index">
                                            <v-icon color="red" v-if="item.value != 0">
                                                mdi-numeric-{{item.value}}-circle-outline
                                                <!-- {{ isNaN(item.value) ? `mdi-alpha-${item.value.toLowerCase()}-circle-outline` : `mdi-numeric-${item.value}-circle-outline` }} -->
                                            </v-icon>
                                        </span>
                                    </div>
                                    </td>

                                    <!-- カラー配置図 (測定点入) -->
                                    <td 
                                        id="B12"
                                        ref="B12"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'カラー配置図 (測定点入)'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container v-show="exist.jiban_plan == 1">
                                            <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                    </td>

                                    <!-- ALVS検討依頼 -->
                                    <td 
                                        id="B13"
                                        ref="B13"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'ALVS検討依頼'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container>
                                            <v-icon color="red" v-if="exist.alvs == '1'">mdi-checkbox-blank-circle-outline</v-icon>
                                            <p v-else class="font-weight-bold red--text">{{exist.alvs}}</p>
                                        </v-container>
                                    </td>

                                    <!-- 構造事前検討依頼 -->
                                    <td 
                                        id="B14"
                                        ref="B14"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '構造事前検討依頼'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container v-if="exist.SR_OPTION_1 == 'あり'" style="cursor:pointer;">
                                            <div v-if="exist.SR_OPTION_ZEH == 1">
                                                <span class="red--text font-weight-black">ZEH</span>
                                            </div>
                                            <div v-if="exist.SR_OPTION_GX == 1">
                                                <span class="red--text font-weight-black">GX</span>
                                            </div>
                                            <div>
                                                <v-icon color="red" v-if="exist.SR_OPTION_1 == 'あり'">mdi-checkbox-blank-circle-outline</v-icon>
                                            </div>
                                            <div>
                                                <span class="">ダクト指示 </span>
                                                <div v-if="exist.SR_OPTION_2 == 'あり'">
                                                    <span class="mx-2 selected">あり</span>
                                                    <span class="mx-2">なし</span>
                                                </div>
                                                <div v-else-if="exist.SR_OPTION_2 == 'なし'">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2 selected">なし</span>
                                                </div>
                                                <div v-else-if="exist.SR_OPTION_2 == null">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2">なし</span>
                                                </div>
                                                <div>
                                                    <span>等級</span>
                                                </div>
                                                <div>
                                                    <span class="red--text font-weight-black">{{exist.SR_OPTION_W}}</span>
                                                    <span class="red--text font-weight-black">{{exist.SR_OPTION_S}}</span>
                                                </div>
                                            </div>
                                        </v-container>

                                        <v-container  v-else-if="exist.SR_OPTION_1 == 'なし'" style="cursor:pointer;">
                                            <div v-if="exist.SR_OPTION_W || exist.SR_OPTION_S">
                                                <span class="">ダクト指示 </span>
                                                <div v-if="exist.SR_OPTION_1 == 'なし'">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2 selected">なし</span>
                                                </div>
                                                <div v-else-if="exist.SR_OPTION_1 == null">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2">なし</span>
                                                </div>
                                                <div>
                                                    <span>等級</span>
                                                </div>
                                            </div>
                                            <div>
                                                <span class="red--text font-weight-black">{{exist.SR_OPTION_W}}</span>
                                                <span class="red--text font-weight-black">{{exist.SR_OPTION_S}}</span>
                                            </div>
                                        </v-container>
                                    </td>

                                    <!-- 提案電気図面依頼 -->
                                    <!-- <td 
                                        id="B15"
                                        ref="B15"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '提案電気図面依頼'"
                                    > 
                                        <v-container>
                                            <v-icon v-show="exist.pdr == '1' && exist.denki_plan_gravity != null" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                    </td> -->

                                    <!-- 電気図面依頼（提案電気図面依頼含む） -->
                                    <td 
                                        id="B16"
                                        ref="B16"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '電気図面依頼（提案電気図面依頼含む）'"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container v-if="exist.ED_OPTION_1 == 'あり'">
                                            <div v-if="exist.ED_OPTION_1 == 'あり'">
                                                <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                <!-- <span class="red--text font-weight-black">ZEH</span> -->
                                            </div>
                                            <div>
                                                <span class="">E更新</span>
                                                <div v-if="exist.ED_OPTION_2 == 'なし'">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2 selected">なし</span>
                                                </div>
                                                <div v-else-if="exist.ED_OPTION_2 == 'あり'">
                                                    <span class="mx-2 selected">あり</span>
                                                    <span class="mx-2">なし</span>
                                                </div>
                                                <div v-else-if="exist.ED_OPTION_2 == null">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2">なし</span>
                                                </div>
                                                <!-- <div>
                                                    <span>等級</span>
                                                </div> -->
                                            </div>
                                            <!-- <div v-if="exist.ED_ELECTRICAL_REQUEST != null"> -->
                                            <div v-if="exist.ED_ELECTRICAL_REQUEST !== null && exist.ED_ELECTRICAL_REQUEST !== undefined">
                                                <v-simple-table class="mt-2">
                                                    <thead>
                                                        <tr>
                                                            <!-- <th colspan="3" style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">追加依頼</th> -->
                                                            <th colspan="2" style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">追加依頼</th>
                                                        </tr>
                                                        <tr>
                                                            <th style="font-size: 10px !important; height: 10% !important;width: 10% !important; padding:0px !important; text-align:center !important;">LED</th>
                                                            <th style="font-size: 10px !important; height: 10% !important;width: 10% !important; padding:0px !important; text-align:center !important;">チェック</th>
                                                            <!-- <th style="font-size: 10px !important; height: 10% !important;width: 10% !important; padding:0px !important; text-align:center !important;">盤図</th> -->
                                                        </tr>
                                                        <tr>
                                                            <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                <div v-if="exist.ED_ELECTRICAL_REQUEST.includes('1')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                            </td>
                                                            <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                <div v-if="exist.ED_ELECTRICAL_REQUEST.includes('2')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                            </td>
                                                            <!-- <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                <div v-if="exist.ED_ELECTRICAL_REQUEST.includes('3')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                            </td> -->
                                                        </tr>
                                                    </thead>
                                                </v-simple-table>
                                            </div>
                                            <div v-else>
                                                <span></span>
                                            </div>
                                        </v-container>

                                        <v-container v-else-if="exist.ED_OPTION_1 == null">
                                            <div v-if="exist.ED_DENKI_PLAN_1 != null && exist.ED_PDR_TITLE != null">
                                                <div>
                                                    <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                </div>
                                                <span style="font-size:14px;color:red;">PDR</span>
                                            </div>
                                            <div v-else>
                                                <span></span>
                                            </div>
                                            <!-- <div v-else-if="exist.ED_DENKI_PLAN_1 == 'なし' && exist.ED_PDR_TITLE != null">
                                                <span></span>
                                            </div> -->
                                        </v-container>

                                    </td>

                                    <!-- 断面図/申請用立面図依頼 -->
                                    <td
                                        id="B17"
                                        ref="B17"
                                        :key="ii+ 'B'"
                                        v-if="vHeader.header == '断面図/申請用立面図依頼'"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''">

                                        <v-container>
                                            <div v-if="exist.cross_section != null && exist.elevation_section != null">
                                                <span style="font-size:20px;font-weight:bold;color:red;">D・R</span>
                                            </div>

                                            <div v-else-if="exist.cross_section != null">
                                                <span style="font-size:20px;font-weight:bold;color:red;">D</span>
                                            </div>

                                            <div v-else-if="exist.elevation_section != null">
                                                <span style="font-size:20px;font-weight:bold;color:red;">R</span>
                                            </div>

                                            <div v-else-if="exist.cross_section == null && exist.elevation_section == null">
                                                <span> </span>
                                            </div>
                                        </v-container>
                                    </td>

                                    <!-- STOP -->
                                    <td 
                                        id="B18"
                                        ref="B18"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'STOP'"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container>
                                            <v-icon v-if="exist.stop == '1' && exist.stop_list.length == 0" color="red" >mdi-checkbox-blank-circle-outline</v-icon>

                                            <div v-else-if="exist.stop == '1' && exist.stop_list.length > 0">
                                                <v-icon v-if="exist.stop_list[0].OPTION_1 == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon><br>
                                                    <span v-if="exist.stop_list[0].OPTION_1 == '1'">施工連絡</span><br>
                                                    <template v-if="exist.stop_list[0].OPTION_2 == '1'">
                                                        <span class="mx-2 selected">あり</span>
                                                        <span class="mx-2 ">なし</span>
                                                    </template>
                                                    <template v-if="exist.stop_list[0].OPTION_2 == '0'">
                                                        <span class="mx-2">あり</span>
                                                        <span class="mx-2 selected">なし</span>
                                                    </template>
                                            </div>

                                            <span v-else-if="exist.stop == '2'" class="red--text text-h6">QG</span>
                                        </v-container>

                                        <!-- <v-container v-else-if="exist && exist.stop_list != []">
                                            test
                                            <v-icon v-if="exist.stop_list[0].OPTION_1 == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon><br>
                                            <span>施工連絡</span><br>
                                            <template v-if="exist.stop_list[0].OPTION_2 == '1'">
                                                <span class="mx-2 selected">あり</span>
                                                <span class="mx-2 ">なし</span>
                                            </template>
                                            <template v-if="exist.stop_list[0].OPTION_2 == '0'">
                                                <span class="mx-2">あり</span>
                                                <span class="mx-2 selected">なし</span>
                                            </template>
                                        </v-container> -->
                                    </td>

                                    <!-- op -->
                                    <td 
                                        id="B19"
                                        ref="B19"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '着手準備'"
                                        @click="toggleCadRequest('final_plan')"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container v-if="exist.final_plan == '1'">
                                            <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                        <v-container v-else-if="exist.final_plan == '2'">
                                            <v-icon color="red" >mdi-numeric-1-circle-outline</v-icon>
                                        </v-container>
                                        <v-container v-else-if="exist.final_plan == '3'">
                                            <v-icon color="red" >mdi-numeric-2-circle-outline</v-icon>
                                        </v-container>

                                    </td>

                                    <!-- 即日依頼 -->
                                    <td 
                                        id="B20"
                                        ref="B20"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '即日依頼'"
                                        style="cursor:pointer;"
                                        :class="exist.gravity == 4 ? 'disabled-cell' : ''"
                                    > 
                                        <v-container>
                                            <v-icon v-if="exist.express == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                    </td>

                                    <!-- 依頼書添付 -->
                                    <td 
                                        id="B21"
                                        ref="B21"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == '依頼書添付'"
                                        @click="toggleCadRequest('request_attach_form_previous',{attachments : exist.attachments, existing: exist, index: ii})"
                                        style="cursor:pointer;"
                                    > 
                                        <v-container>
                                            <v-icon v-if="exist.request_attach_from == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                    </td> 

                                    <!-- NOTE: actions FOR ADMIN -->
                                    <td 
                                        style="border-bottom : none; border-left: none; border-right: none;"
                                        id="B22"
                                        ref="B22"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'actions' && btnSelection != 'DELETED' && loggedInUser.is_admin == 1 && $store.state.mainCloseStore != '1' && $store.state.authorityResponse != 1"
                                    > 
                                    
                                        <div class="my-2">
                                            <v-btn v-if="exist.status == 'SAVED'"  @click="editCadRequest(exist, ii)" color="blue-grey" dark small id="corrected" width="150px"> 修正  </v-btn> 
                                        </div> 
                                        <!-- || exist.status == 'DRAFT' -->
                                        <div class="my-2">
                                            <v-btn v-if="exist.status == 'SAVED'" color="#FF3131" @click="cancelRequest(ii)" dark small id="cancel" width="150px">  キャンセル (依頼済み)  </v-btn> 
                                        </div> 
                                        <v-btn v-if="exist.hrd_accept == 1 && (loggedInUser.id == 1 || loggedInUser.id == 2 || loggedInUser.id == 15) && exist.revision_type != '10'" dark color="#1B5E20" small @click="openBossSched(ii)">図面仕上がり予定表</v-btn>
                                        <div class="my-2">
                                            <!-- <v-btn color="indigo" dark v-if="exist.hrd_accept != 1" @click="hrdAcceptFunction(ii, '357')" small width="150px">  HRD ACCEPT </v-btn>  -->
                                            <div v-if="exist.status == 'SAVED'">
                                                <v-btn color="indigo" dark v-if="exist.hrd_accept != 1" @click="openDialogForRegistration(exist, ii, false)" small width="150px">  HRD ACCEPT </v-btn> 
                                            </div>
                                            <div v-else></div>
                                        </div> 
                                        <div  class="my-2">
                                            <!-- <v-btn width="150px" v-if="exist.hrd_accept != 1 && (loggedInUser.id == 1 || loggedInUser.id == 15)" @click="hrdAcceptFunction(ii, 'dynamic')" small dark color="success"> REGISTER </v-btn> -->
                                            <div v-if="exist.status == 'SAVED'">
                                                <v-btn width="150px" v-if="(exist.hrd_accept == 1 && exist.sent_to_boss == 0 && exist.revision_type != '10') || exist.hrd_accept == null" @click="openDialogForRegistration(exist, ii, true)" small dark color="success"> REGISTER </v-btn>
                                            </div>
                                            <div v-else></div>
                                            <!-- && (loggedInUser.id == 1 || loggedInUser.id == 15) -->
                                        </div>
                                    </td> 
                                    <!-- NOTE: actions for PLAN CONTROL -->
                                    <td 
                                        style="border-bottom : none; border-left: none; border-right: none;"
                                        id="B23"
                                        ref="B23"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'actions' && btnSelection != 'DELETED' && loggedInUser.plan_control == 1 && $store.state.mainCloseStore != '1'"
                                    > 
                                    
                                        <div class="my-2">
                                            <v-btn v-if="exist.status == 'SAVED'"  @click="editCadRequest(exist, ii)" color="blue-grey" dark small id="corrected" width="150px"> 修正  </v-btn> 
                                        </div> 
                                        <!-- || exist.status == 'DRAFT' -->
                                        <div class="my-2">
                                            <v-btn v-if="exist.status == 'SAVED'" color="#FF3131" @click="cancelRequest(ii)" dark small id="cancel" width="150px">  キャンセル (依頼済み)  </v-btn> 
                                        </div> 
                                        <v-btn v-if="exist.hrd_accept == 1 && (loggedInUser.id == 1 || loggedInUser.id == 2 || loggedInUser.id == 15 || loggedInUser.plan_control == 1 )" dark color="#1B5E20" small @click="openBossSched(ii)">図面仕上がり予定表</v-btn>
                                        <div class="my-2">
                                            <!-- <v-btn color="indigo" dark v-if="exist.hrd_accept != 1" @click="hrdAcceptFunction(ii, '357')" small width="150px">  HRD ACCEPT </v-btn>  -->
                                            <div v-if="exist.status == 'SAVED'">
                                                <v-btn color="indigo" dark v-if="exist.hrd_accept != 1" @click="openDialogForRegistration(exist, ii, false)" small width="150px">  HRD ACCEPT </v-btn> 
                                            </div>
                                            <div v-else></div>
                                        </div> 
                                        <div  class="my-2">
                                            <!-- <v-btn width="150px" v-if="exist.hrd_accept != 1 && (loggedInUser.id == 1 || loggedInUser.id == 15)" @click="hrdAcceptFunction(ii, 'dynamic')" small dark color="success"> REGISTER </v-btn> -->
                                            <div v-if="exist.status == 'SAVED'">
                                                <v-btn width="150px" v-if="exist.hrd_accept != 1" @click="openDialogForRegistration(exist, ii, true)" small dark color="success"> REGISTER </v-btn>
                                            </div>
                                            <div v-else></div>
                                            <!-- && (loggedInUser.id == 1 || loggedInUser.id == 15) -->
                                        </div>
                                    </td> 
                                    <!-- NOTE: actions FOR PLANNER -->  
                                    <td 
                                        style="border-bottom : none; border-left: none; border-right: none;"
                                        id="B24"
                                        ref="B24"
                                        :key="ii + 'B'" 
                                        v-if="vHeader.header == 'actions' && btnSelection != 'DELETED' && (loggedInUser.is_admin != 1 && loggedInUser.plan_control != 1) && $store.state.mainCloseStore != '1' && $store.state.authorityResponse != 1"
                                    > 
                                        <div class="my-2">
                                            <!-- ETO YUNG GAGAMITIN -->
                                            <v-btn v-show="exist.hrd_accept != 1 && loggedInUser.type == 'Planner' || (loggedInUser.id.toString() == exist.created_by)" @click="editCadRequest(exist, ii)" color="blue-grey" dark small id="corrected" width="150px"> 修正  </v-btn>  
                                            <!-- <v-btn v-show="exist.hrd_accept !== 1 && ((loggedInUser.is_admin === 1 && loggedInUser.is_hrd_requestor === 1) || loggedInUser.id.toString() === exist.created_by)" @click="editCadRequest(exist, ii)" color="blue-grey" dark small id="corrected" width="150px"> 修正 </v-btn> -->
                                        </div>
                                        <div class="my-2">
                                            <v-btn v-show="exist.hrd_accept != 1 &&  loggedInUser.type == 'Planner' || (loggedInUser.id.toString() == exist.created_by)" color="#FF3131" @click="plannerCancelRequest(ii)" dark small id="cancel" width="150px">  キャンセル (依頼済み)  </v-btn> 
                                            <!-- <v-btn v-show="exist.hrd_accept != 1 && (loggedInUser.is_admin == 1 && loggedInUser.is_hrd_requestor == 1) || loggedInUser.id.toString() == exist.created_by" color="#FF3131" @click="cancelRequest(ii)" dark small id="cancel" width="150px">  キャンセル (依頼済み)  </v-btn>  -->
                                        </div> 
                                        <!-- <div class="my-2">
                                            <v-btn v-if="exist.hrd_accept == 1" dark color="#1B5E20" small @click="openBossSched(ii)">図面仕上がり予定表</v-btn>
                                        </div>  -->
                                    </td> 
                                </template>

                                <!-- EDIT CAD REVISION -->
                                <template v-if="editMode && ii == editIndex"> 
                                    <!-- CAD依頼送信者 -->
                                        <td 
                                            id="B1"
                                            ref="B1"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'CAD依頼送信者'" 
                                            class="second2-top-left-sticky font-weight-black" 
                                        
                                        > {{loggedInUser.name.toUpperCase()}} </td>

                                        <!-- 図面番号 -->
                                        <td 
                                            id="B2"
                                            ref="B2"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == '図面番号'" 
                                            class="third2-top-left-sticky font-weight-black custom-cell"
                                            :class="{ 'highlight-bg': isHighlighted }"
                                            @click="toggleDialogRevision(true)"
                                            >
                                            <span class="overline font-weight-black" @click="toggleDialogRevision(true)">
                                                {{editCadRequestRevisionContent.revision_number}}
                                            </span>
                                        </td>

                                        <!-- Start --> 

                                        <!-- 設計受託契約 / design_contract-->
                                        <td 
                                            id="design_contract"
                                            ref="design_contract"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == '設計受託契約'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('design_contract')"
                                        > 
                                            <v-container>
                                                <v-icon 
                                                    color="red" 
                                                    v-show="editCadRequestRevisionContent.design_contract"
                                                >mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container>
                                        </td>

                                        <!-- 最高高さ・見付面積・平均GL計算根拠 / calculation_basis -->
                                        <td 
                                            id="calculation_basis"
                                            ref="calculation_basis"
                                            :key="ii + 'B'" 
                                            @click="toggleCadRequest('calculation_basis')"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            v-if="vHeader.header == '最高高さ・見付面積・平均GL計算根拠'" 
                                        > 
                                            <v-container>
                                                <v-icon 
                                                    color="red" 
                                                    v-show="editCadRequestRevisionContent.calculation_basis"
                                                >mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container>
                                        </td>

                                        <!-- カラー配置図 / site_layout-->
                                        <td 
                                            id="site_layout"
                                            ref="site_layout"
                                            :key="ii + 'B'" 
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            v-if="vHeader.header == 'カラー配置図'"
                                        >
                                            <!--  @click="toggleCadRequest('site_layout')" -->
                                            <v-container>
                                                <v-btn-toggle v-model="editToggleB5" dense group class="btn-toggle">
                                                    <v-btn 
                                                        v-for="(siteLayout, iii) in siteLayouts"
                                                        :key="iii + 'siteLayout'"
                                                        :value="siteLayout" 
                                                        text 
                                                        small 
                                                        :class="editToggleB5 == siteLayout || editCadRequestRevisionContent.site_layout == siteLayout ? 'selected mt-n1' : 'mt-n1'"
                                                        @click="toggleCadRequest('site_layout', {text : siteLayout})"
                                                        > 
                                                        <span class="font-weight-black">{{siteLayout}}</span> 
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </v-container>
                                        </td>

                                        <!-- スペック依頼 / specs_irai -->
                                        <td 
                                            id="specs_irai"
                                            ref="specs_irai"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'スペック依頼'"
                                            :class="editCadRequestRevisionContent.gravity == 4 ? ' disabled-cell' : ''"
                                        > 
                                            <v-container>
                                                <div id="toggleB6_1">
                                                    <v-btn-toggle v-model="editToggleB6_1" dense group>
                                                        <v-btn 
                                                            v-for="(sashType, iii) in SASH_TYPE"
                                                            :key="iii + 'sashType'"
                                                            :value="sashType.sash_spec" 
                                                            text 
                                                            small 
                                                            @click="toggleCadRequest('specs_irai', {selection: 'sash_type',text : sashType.sash_spec})"
                                                            :class="editToggleB6_1 == sashType.sash_spec || editCadRequestRevisionContent.specs_irai.sash_type == sashType.sash_spec ? 'selected' : ''"
                                                            > <span class="font-weight-black"> {{sashType.sash_spec}} </span> 
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>
                                                <div id="ToggleB6_2">
                                                    <v-btn-toggle v-model="editToggleB6_2" dense group>
                                                            <span class="font-weight-black mt-2" >強化: </span>
                                                        <v-btn 
                                                            v-for="(spec, iii) in specs"
                                                            :key="iii + 'spec'"
                                                            :value="spec" 
                                                            text 
                                                            small 
                                                            :class="editToggleB6_2 == spec || editCadRequestRevisionContent.specs_irai.specs == spec ? 'selected ' : 'mt-n1'"
                                                            @click="toggleCadRequest('specs_irai', {selection: 'specs',text : spec})"
                                                            > 
                                                            <span class="font-weight-black"> {{ spec }} </span>
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>

                                                <!-- :class="toggleB6_3.includes(acce) || editCadRequestRevisionContent.specs_irai.accessories[iii].value == acce ? 'selected ' : ''" -->

                                                <div id="editToggleB6_3">
                                                    <v-btn-toggle v-model="editToggleB6_3" dense group multiple>
                                                        <!-- {{ editToggleB6_3 }} -->
                                                        <v-btn 
                                                            v-for="(acce, iii) in accessories"
                                                            :key="iii + 'acce'"
                                                            :value="acce" 
                                                            text 
                                                            small 
                                                            :class="editToggleB6_3.includes(acce) ? 'selected ' : ''"
                                                            @click="toggleCadRequest('specs_irai', {selection: 'accessories'})"
                                                            > 
                                                                <span class="font-weight-black">{{ acce }}</span> 
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>

                                                <div id="editToggleB6_4">
                                                    <v-btn-toggle v-model="editToggleB6_4" dense group class="specific-toggle">
                                                        <v-btn
                                                            v-for="(hc, iii) in honeycomb"
                                                            :key="iii + 'hc'"
                                                            :value="hc"
                                                            text
                                                            small
                                                            :class="editToggleB6_4 == hc || editCadRequestRevisionContent.specs_irai.honeycomb == hc ? 'selected ' : 'mt-n1'"
                                                            @click="toggleCadRequest('specs_irai', {selection : 'honeycomb', text : hc})"
                                                            >
                                                                <span class="font-weight-black">{{ hc }}</span> 
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>
                                            </v-container>

                                            <!-- <v-container v-else>
                                                <div id="toggleB6_1">
                                                    <v-btn-toggle v-model="editToggleB6_1" dense group>
                                                        <v-btn 
                                                            v-for="(sashType, iii) in sashTypes"
                                                            :key="iii + 'sashType'"
                                                            :value="sashType" 
                                                            text 
                                                            small 
                                                            :class="editToggleB6_1 == sashType ? 'selected mt-n1' : 'mt-n1'"
                                                            @click="toggleCadRequest('specs_irai', {selection: 'sash_type',text : sashType})"
                                                            > <span class="font-weight-black"> {{sashType}} </span> 
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>
                                                <div id="toggleB6_2">
                                                    <v-btn-toggle v-model="editToggleB6_2" dense group>
                                                            <span class="font-weight-black mt-2" >強化: </span>
                                                        <v-btn 
                                                            v-for="(spec, iii) in specs"
                                                            :key="iii + 'spec'"
                                                            :value="spec" 
                                                            text 
                                                            small 
                                                            :class="editToggleB6_2 == spec ? 'selected ' : 'mt-n1'"
                                                            @click="toggleCadRequest('specs_irai', {selection: 'specs',text : spec})"
                                                            > 
                                                            <span class="font-weight-black"> {{ spec }} </span>
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>

                                            :class="toggleB6_3.includes(acce) || editCadRequestRevisionContent.specs_irai.accessories[iii].value == acce ? 'selected ' : ''" -->
    <!-- 
                                                <div id="toggleB6_3">
                                                    <v-btn-toggle v-model="editToggleB6_3" dense group multiple>
                                                        <v-btn 
                                                            v-for="(acce, iii) in accessories"
                                                            :key="iii + 'acce'"
                                                            :value="acce" 
                                                            text 
                                                            small 
                                                            :class="editToggleB6_3.includes(acce) ? 'selected ' : ''"
                                                            @click="toggleCadRequest('specs_irai', {selection: 'accessories'})"
                                                            > 
                                                                <span class="font-weight-black">{{ acce }}</span> 
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>
                                            </v-container>  -->
                                        </td>

                                        <!-- DXFデータ依頼 / dxf_data_request -->
                                        <td 
                                            id="dxf_data_request"
                                            ref="dxf_data_request"
                                            :key="ii + 'B'" 
                                            @click="toggleCadRequest('dxf_data_request')"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            v-if="vHeader.header == 'DXFデータ依頼'"
                                        > 
                                            <v-container>
                                                <v-icon color="red" v-show="editCadRequestRevisionContent.dxf_data_request">mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container>
                                        </td>

                                        <!-- カラーパース / colors perspective -->
                                        <td 
                                            id="color_pers"
                                            ref="color_pers"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'カラーパース'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('color_pers')"

                                        > 
                                            <v-container v-show="editCadRequestRevisionContent.color_pers == 1">
                                                <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                <div v-if="hideColorPersTable == 0">
                                                    <v-simple-table>
                                                        <thead>
                                                            <tr>
                                                                <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                                <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点方向</th>
                                                                <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点高さ</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in editCadRequestColorPers" :key="index">
                                                                <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                                <td style="font-size: 10px !important; height: 10% !important">{{ item.perspective_direction }}</td>
                                                                <td style="font-size: 10px !important; height: 10% !important">{{ item.viewpoint_height }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </div>
                                            </v-container>
                                            <!-- {{cadRequestRevisionContent.color_pers}} -->
                                        </td>

                                        <!-- ハウス プレゼンテーション / house presentation-->
                                        <td 
                                            id="house_presentation"
                                            ref="house_presentation"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'ハウス プレゼンテーション'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('house_presentation')"
                                        > 
                                        <v-container  v-show="editCadRequestRevisionContent.house_presentation == 1">
                                                <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                <div v-if="hideHpTable == 0">
                                                    <v-simple-table>
                                                        <thead>
                                                            <tr>
                                                                <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                                <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点方向</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in edit_cad_request_house_presentation" :key="index">
                                                                <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                                <td style="font-size: 10px !important; height: 10% !important">{{ item.perspective_direction }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </div>
                                            </v-container>
                                        </td>

                                        <!-- インテリアパース /  house_presentation_int -->
                                        <!-- :class="$store.state.intRadio != '0009999' ? 'custom-cell disabled-cell' : 'custom-cell'" -->
                                        <td
                                            id="house_presentation_int"
                                            ref="house_presentation_int"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'インテリアパース【トライアル】'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('house_presentation_int')"
                                        >
                                            <v-container>
                                                <v-icon color="red" v-show="editCadRequestRevisionContent.house_presentation_int">mdi-checkbox-blank-circle-outline</v-icon><br>
                                                    <span v-show="editCadRequestRevisionContent.house_presentation_int">パターン : <b>{{ editCadRequestRevisionContent.house_presentation_int }}</b></span>
                                            </v-container>

                                        <!-- <v-container v-if="edit_cad_request_house_presentation_int.length > 0">
                                        <v-icon color="red">mdi-checkbox-blank-circle-outline</v-icon>
                                        <div>
                                            <v-simple-table>
                                                <thead>
                                                    <tr>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">階</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">部屋</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in edit_cad_request_house_presentation_int" :key="index">
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.floor }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.layout }}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>
                                </v-container> -->
                                        </td>

                                        <!-- 仕様検討ツール / shio_request-->
                                        <td 
                                            id="shio_request"
                                            ref="shio_request"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == '仕様検討ツール'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('shio_request')"
                                        > 
                                        <v-container v-if="editCadRequestRevisionContent.shio_request">
                                            <div v-if="editCadRequestRevisionContent.SRS_request">
                                                <v-icon  v-if="editCadRequestRevisionContent.SRS_request.shio_selection !== '2'" color="red">mdi-checkbox-blank-circle-outline</v-icon><br>
                                                <span v-if="editCadRequestRevisionContent.SRS_request.shio_selection == '1'" style="color:blue !important;"><b>SRS</b><br></span>
                                                <span v-if="editCadRequestRevisionContent.SRS_request.shio_selection == '2'" style="color:red !important;"><b>PEL only</b><br></span>
                                                <!-- <span v-if="editCadRequestRevisionContent.SRS_request.shio_selection == '1'">仕様書番号 : {{editCadRequestRevisionContent.SRS_request.shio_number}}</span> -->
                                            </div>
                                        </v-container>
                                            <!-- <v-container v-if="editCadRequestRevisionContent.shio_request">
                                                <div v-if="editCadRequestRevisionContent.SRS_request">
                                                    <v-icon color="red">mdi-checkbox-blank-circle-outline</v-icon><br>
                                                    <span v-if="editCadRequestRevisionContent.SRS_request.shio_selection == '1'" style="color:blue !important;"><b>SRS</b><br></span>
                                                    <span v-if="editCadRequestRevisionContent.SRS_request.shio_selection == '1'">仕様書番号 : {{editCadRequestRevisionContent.SRS_request.shio_number}}</span>
                                                </div>
                                            </v-container> -->
                                            <!-- <v-container v-if="editMode && ii == editIndex">
                                                <v-icon v-show="editCadRequestRevisionContent.shio_request" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container>
                                            <v-container v-else >
                                                <v-icon v-show="exist.shio_request == 1" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container> -->
                                        </td>

                                        <!-- WEB打ち合わせ用提案資料 /web_documents -->
                                        <td 
                                            id="web_documents"
                                            ref="web_documents"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'WEB打ち合わせ用提案資料'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('web_documents')"
                                        > 
                                            <v-container>
                                                <span v-for="(webDoc, ii) in editCadRequestRevisionContent.web_documents" :key="ii+'webDocs'">
                                                    <v-icon color="red">
                                                        <!-- {{ `mdi-alpha-${webDoc.value.toLowerCase()}-circle-outline` }} -->
                                                        {{`mdi-numeric-${webDoc.value}-circle-outline`}}
                                                        <!-- {{ isNaN(webDoc.value) ? `mdi-alpha-${webDoc.value.toLowerCase()}-circle-outline` : `mdi-numeric-${webDoc.value}-circle-outline` }} -->
                                                    </v-icon>
                                                </span>
                                            </v-container>
                                        </td>

                                        <!-- カラー配置図 (測定点入) / jiban_plan -->
                                        <td 
                                            id="jiban_plan"
                                            ref="jiban_plan"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'カラー配置図 (測定点入)'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('jiban_plan')"
                                        > 
                                            <v-container>
                                                <v-icon color="red" v-show="editCadRequestRevisionContent.jiban_plan">mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container>
                                        </td>

                                        <!-- ALVS検討依頼 / alvs-->
                                        <td 
                                            id="alvs"
                                            ref="alvs"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'ALVS検討依頼'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('alvs')"
                                        > 
                                            <v-container>
                                                <v-icon color="red" v-if="editCadRequestRevisionContent.alvs == '1' || editCadRequestRevisionContent.stop == '1'">mdi-checkbox-blank-circle-outline</v-icon>
                                                <p v-else class="font-weight-bold red--text">{{editCadRequestRevisionContent.alvs}}</p>
                                            </v-container>
                                        </td>

                                        <!-- 構造事前検討依頼 / structural_request -->
                                        <td 
                                            id="structural_request"
                                            ref="structural_request"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == '構造事前検討依頼'"
                                            @click="toggleCadRequest('structural_request')"
                                            :class="editCadRequestRevisionContent.gravity == 4 ? ' disabled-cell' : ''"
                                        > 
                                            <v-container v-if="editCadRequestRevisionContent.structural_request">
                                                <div v-if="editCadRequestRevisionContent.structural_request.OPTION_1 == 'あり'">
                                                    <div v-if="editCadRequestRevisionContent.structural_request.OPTION_ZEH">
                                                        <span class="red--text font-weight-black">ZEH</span>
                                                    </div>

                                                    <div v-if="editCadRequestRevisionContent.structural_request.OPTION_GX">
                                                        <span class="red--text font-weight-black">GX</span>
                                                    </div>

                                                    <div>
                                                        <v-icon color="red">mdi-checkbox-blank-circle-outline</v-icon>
                                                    </div>

                                                    <div>
                                                        <span class="">ダクト指示 </span>
                                                    </div>

                                                    <div>
                                                        <template v-if="editCadRequestRevisionContent.structural_request.OPTION_2 == 'あり'">
                                                            <span class="mx-2 selected">あり</span>
                                                            <span class="mx-2">なし</span>
                                                        </template>

                                                        <template v-else-if="editCadRequestRevisionContent.structural_request.OPTION_2 == 'なし'">
                                                            <span class="mx-2 ">あり</span>
                                                            <span class="mx-2 selected">なし</span>
                                                        </template>

                                                        <template v-else>
                                                            <span class="mx-2">あり</span>
                                                            <span class="mx-2">なし</span>
                                                        </template>
                                                    </div>

                                                    <div>
                                                        <span>等級</span>
                                                    </div>

                                                    <div>
                                                        <span class="red--text font-weight-black">{{ editCadRequestRevisionContent.structural_request.OPTION_W }}</span>
                                                        <span class="red--text font-weight-black">{{ editCadRequestRevisionContent.structural_request.OPTION_S }}</span>
                                                    </div>
                                                </div>

                                                <div v-else-if="editCadRequestRevisionContent.structural_request.OPTION_1 == 'なし'">
                                                    <div v-if="editCadRequestRevisionContent.structural_request.OPTION_W || editCadRequestRevisionContent.structural_request.OPTION_S">
                                                        <span class="">ダクト指示 </span>
                                                        <div v-if="editCadRequestRevisionContent.structural_request.OPTION_1 == 'なし'">
                                                            <span class="mx-2">あり</span>
                                                            <span class="mx-2 selected">なし</span>
                                                        </div>
                                                        <div v-else-if="editCadRequestRevisionContent.structural_request.OPTION_1 == null">
                                                            <span class="mx-2">あり</span>
                                                            <span class="mx-2">なし</span>
                                                        </div>
                                                        <div>
                                                            <span>等級</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="red--text font-weight-black">{{ editCadRequestRevisionContent.structural_request.OPTION_W }}</span>
                                                        <span class="red--text font-weight-black">{{ editCadRequestRevisionContent.structural_request.OPTION_S }}</span>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </td>

                                        <!-- 提案電気図面依頼 / pdr -->
                                        <!-- <td 
                                            id="pdr"
                                            ref="pdr"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == '提案電気図面依頼'"
                                            @click="toggleCadRequest('pdr')"
                                            :class=" disableSelections || (editCadRequestRevisionContent.electrical_drawing && editCadRequestRevisionContent.electrical_drawing.radioGravity != null) 
                                            ? 'custom-cell disabled-cell' : 'custom-cell'"
                                        > 
                                            <v-container>
                                                <v-icon color="red" v-show="editCadRequestRevisionContent.pdr == '1' && editCadRequestRevisionContent.denki_gravity != null">mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container>
                                        </td> -->

                                        <!-- 電気図面依頼（提案電気図面依頼含む） / electrical_drawing -->
                                        <td 
                                            id="electrical_drawing"
                                            ref="electrical_drawing"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == '電気図面依頼（提案電気図面依頼含む）'"
                                            @click="toggleCadRequest('electrical_drawing')"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.denki_gravity != null || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                        > 
                                            <v-container v-if="editCadRequestRevisionContent.electrical_drawing">
                                                <div v-if="editCadRequestRevisionContent.electrical_drawing.OPTION_1 == 'あり'">
                                                    <div>
                                                        <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                    </div>
                                                    <span class="">E更新</span>
                                                    <div>
                                                        <template v-if="editCadRequestRevisionContent.electrical_drawing.OPTION_2 == 'あり'">
                                                            <span class="mx-2 selected">あり</span>
                                                            <span class="mx-2">なし</span>
                                                        </template>
                                                        
                                                        <template v-else-if="editCadRequestRevisionContent.electrical_drawing.OPTION_2 == 'なし'">
                                                            <span class="mx-2 ">あり</span>
                                                            <span class="mx-2 selected">なし</span>
                                                        </template>

                                                        <template v-else>
                                                            <span class="mx-2">あり</span>
                                                            <span class="mx-2">なし</span>
                                                        </template>
                                                    </div>
                                                    <!-- <div>
                                                        <span>等級</span>
                                                    </div> -->
                                                </div>
                                                <!-- <div v-if="editCadRequestRevisionContent && editCadRequestRevisionContent.electrical_drawing && 
                                                            (Array.isArray(editCadRequestRevisionContent.electrical_drawing.selectedDrawing) &&
                                                            editCadRequestRevisionContent.electrical_drawing.selectedDrawing.length > 0)"> -->
                                                    <div v-if="editCadRequestRevisionContent.electrical_drawing.selectedDrawing &&
                                                                editCadRequestRevisionContent.electrical_drawing.selectedDrawing.length > 0">
                                                    <v-simple-table class="mt-2">
                                                        <thead>
                                                            <tr>
                                                                <!-- <th colspan="3" style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">追加依頼</th> -->
                                                                <th colspan="2" style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">追加依頼</th>
                                                            </tr>
                                                            <tr>
                                                                <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">LED</th>
                                                                <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">チェック</th>
                                                                <!-- <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">盤図</th> -->
                                                            </tr>
                                                            <tr>
                                                                <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                    <div v-if="editCadRequestRevisionContent.electrical_drawing.selectedDrawing.includes('1')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                </td>
                                                                <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                    <div v-if="editCadRequestRevisionContent.electrical_drawing.selectedDrawing.includes('2')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                </td>
                                                                <!-- <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                    <div v-if="editCadRequestRevisionContent.electrical_drawing.selectedDrawing.includes('3')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                </td> -->
                                                            </tr>
                                                        </thead>
                                                    </v-simple-table>
                                                </div>
                                                <div v-else>
                                                    <span></span>
                                                </div>

                                                <div v-if="editCadRequestRevisionContent.electrical_drawing.pdr_title != null && editCadRequestRevisionContent.electrical_drawing.radioPdr != null">
                                                    <div>
                                                        <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                    </div>
                                                    <span style="font-size:14px;color:red;">PDR</span>
                                                </div>
                                                <div v-else>
                                                    <span></span>
                                                </div>
                                                <!-- <div v-else-if="editCadRequestRevisionContent.electrical_drawing.pdr_title != null && editCadRequestRevisionContent.electrical_drawing.radioPdr == 'なし'">
                                                    <span></span>
                                                </div> -->
                                                
                                            </v-container>
                                        </td>

                                        <!-- 断面図/申請用立面図依頼 -->
                                        <td
                                            id="elevation_request"
                                            ref="elevation_request"
                                            :key="ii + 'B'"
                                            v-if="vHeader.header == '断面図/申請用立面図依頼'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('elevation_request')">
                                            <!-- class="custom-cell disabled-cell" -->
                                            <v-container>
                                                <div v-if="editCadRequestRevisionContent.cross_section != null && editCadRequestRevisionContent.elevation_section != null">
                                                    <span style="font-size:20px;font-weight:bold;color:red;">D・R</span>
                                                </div>

                                                <div v-else-if="editCadRequestRevisionContent.cross_section != null">
                                                    <span style="font-size:20px;font-weight:bold;color:red;">D</span>
                                                </div>

                                                <div v-else-if="editCadRequestRevisionContent.elevation_section != null">
                                                    <span style="font-size:20px;font-weight:bold;color:red;">R</span>
                                                </div>

                                                <div v-else-if="editCadRequestRevisionContent.cross_section == null && editCadRequestRevisionContent.elevation_section == null">
                                                    <span> </span>
                                                </div>
                                            </v-container>

                                        </td>

                                        <!-- STOP / stop -->
                                        <td 
                                            id="stop"
                                            ref="stop"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == 'STOP'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('stop')"
                                        > 
                                            <!-- <v-container>
                                                <v-icon v-show="editCadRequestRevisionContent.stop == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container> -->
                                            <!-- <v-container v-if="editCadRequestRevisionContent.stop == '1' && editCadRequestRevisionContent.stopListSelection.length > 0">
                                                <v-icon v-if="editCadRequestRevisionContent.stopListSelection[0].option1 == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon><br>
                                                <span v-if="editCadRequestRevisionContent.stopListSelection[0].option1 == '1'">施工連絡</span><br>
                                                <template v-if="editCadRequestRevisionContent.stopListSelection[0].option2 == '1'">
                                                    <span class="mx-2 selected">あり</span>
                                                    <span class="mx-2 ">なし</span>
                                                </template>
                                                <template v-if="editCadRequestRevisionContent.stopListSelection[0].option2 == '0'">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2 selected">なし</span>
                                                </template>
                                            </v-container>

                                            <v-container v-else-if="editCadRequestRevisionContent.stop == '1' && editCadRequestRevisionContent.stopListSelection.length== 0">
                                                <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container> -->

                                            <v-container>
                                                <v-icon v-if="editCadRequestRevisionContent.stop == '1' && editCadRequestRevisionContent.stopListSelection.length == 0" color="red" >mdi-checkbox-blank-circle-outline</v-icon>

                                                <div v-else-if="editCadRequestRevisionContent.stop == '1' && editCadRequestRevisionContent.stopListSelection.length > 0">
                                                    <v-icon v-if="editCadRequestRevisionContent.stopListSelection[0].option1 == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon><br>
                                                        <span v-if="editCadRequestRevisionContent.stopListSelection[0].option1 == '1'">施工連絡</span><br>
                                                        <template v-if="editCadRequestRevisionContent.stopListSelection[0].option2 == '1'">
                                                            <span class="mx-2 selected">あり</span>
                                                            <span class="mx-2 ">なし</span>
                                                        </template>
                                                        <template v-if="editCadRequestRevisionContent.stopListSelection[0].option2 == '0'">
                                                            <span class="mx-2">あり</span>
                                                            <span class="mx-2 selected">なし</span>
                                                        </template>
                                                </div>

                                                <span v-else-if="editCadRequestRevisionContent.stop == '2'" class="red--text text-h6">QG</span>
                                            </v-container>
                                        </td>

                                        <!-- 着手準備 / drawing_request - final_plan -->
                                        
                                        <td 
                                            id="final_plan"
                                            ref="final_plan"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == '着手準備'"
                                            :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                            @click="toggleCadRequest('final_plan')"
                                        > 
                                            <v-container >
                                                <v-icon v-if="editCadRequestRevisionContent.final_plan == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                <v-icon  v-if="editCadRequestRevisionContent.final_plan == '2'" color="red" >mdi-numeric-1-circle-outline</v-icon>
                                                <v-icon v-if="editCadRequestRevisionContent.final_plan == '3'" color="red" >mdi-numeric-2-circle-outline</v-icon>
                                            </v-container>
                                        </td>

                                        <!-- 即日依頼 / express -->
                                        <template>
                                             <td 
                                                id="express"
                                                ref="express"
                                                :key="ii + 'B'" 
                                                v-if="vHeader.header == '即日依頼' && (editCadRequestRevisionContent.final_plan || editCadRequestRevisionContent.hrd_process)"
                                                :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                                @click="toggleCadRequest('express')"
                                            >    
                                            
                                                <v-container>
                                                    <v-icon color="red" v-if="editCadRequestRevisionContent.express == '1'">mdi-checkbox-blank-circle-outline</v-icon>
                                                </v-container>
                                            </td>

                                            <td 
                                                id="express"
                                                ref="express"
                                                :key="ii + 'B'" 
                                                v-if="vHeader.header == '即日依頼' && !editCadRequestRevisionContent.final_plan"
                                                :class="disableSelections || disableReform || disableOtherSelections || editCadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                                style="cursor:pointer;"
                                            >    
                                            <!--                                             
                                                <v-container>
                                                    <v-icon color="red" v-if="editCadRequestRevisionContent.express == '1'">mdi-checkbox-blank-circle-outline</v-icon>
                                                </v-container> -->
                                            </td>
                                        </template>

                                        <!-- 依頼書添付 -->
                                        <td 
                                            id="request_attach_from"
                                            ref="request_attach_from"
                                            :key="ii + 'B'" 
                                            v-if="vHeader.header == '依頼書添付'"
                                            @click="toggleCadRequest('request_attach_from', {attachments : editCadRequestRevisionContent.attachments})"
                                        > 
                                            <v-container v-if="editCadRequestRevisionContent.request_attach_from == '1'">
                                                <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-container>
                                        </td> 
                                        <!-- actions -->
                                            <td 
                                                style="border-bottom : none; border-left: none; border-right: none;"
                                                id="B21"
                                                ref="B21"
                                                :key="ii + 'B'" 
                                                v-if="vHeader.header == 'actions'"
                                            > 
                                                <div class="my-2">
                                                    <v-btn color="red" dark @click="cancelUpdate()" small id="save-draft" width="100px"> キャンセル </v-btn> 
                                                </div> 
                                                <div class="my-2">
                                                    <!-- NOTE - OLD CHARACTERS IN SAVE BUTTON 11/21/25 UARY -->
                                                    <!-- <v-btn color="success" @click="updateCadRequest(exist), overlay = !overlay" dark small id="save" width="100px"> 保存 </v-btn>  -->
                                                    
                                                    <!-- NOTE - NEW CHARACTERS IN SAVE BUTTON 11/21/25 UARY -->
                                                    <v-btn color="success" @click="updateCadRequest(exist), overlay = !overlay" dark small id="save" width="100px"> 送信 </v-btn>

                                                </div> 
                                                <!-- <div class="my-2">
                                                    <v-btn v-show="cadRequestRevisionContent.status == 'SAVED'" color="blue-grey" dark @click="saveCadRequest" small id="save" width="100px"> 送信 </v-btn> 
                                                </div>  -->
                                                <!-- <div class="my-2"> -->
                                                    <!-- <v-btn v-show="cadRequestRevisionContent.status == 'SAVED'" color="indigo" dark @click="HRDAcceptCadRequest" small id="hrdaccept" width="150px"> HRD ACCEPT </v-btn>  -->
                                                <!-- </div>  -->
                                            </td> 
                                </template>
                            </template>
                            <!--!SECTION Recent -->

                            <!--SECTION Latest - Main Transaction Table -->
                            <template v-if="editMode == false && btnSelection != 'DRAFT' && btnSelection != 'DELETED' && $store.state.authorityResponse != 1"> 
                                <!-- CAD依頼送信者 -->
                                <td 
                                    id="B1"
                                    ref="B1"
                                    v-if="vHeader.header == 'CAD依頼送信者'" 
                                    class="second2-top-left-sticky font-weight-black" 
                                
                                > {{loggedInUser.name.toUpperCase()}} </td>

                                <!-- 図面番号 -->
                                <td 
                                    id="B2"
                                    ref="B2"
                                    v-if="vHeader.header == '図面番号'" 
                                    class="third2-top-left-sticky font-weight-black custom-cell"
                                    :class="{ 'highlight-bg': isHighlighted }"
                                    @click="$store.state.mainCloseStore == '1' ? toggleDialogRevision(false) : toggleDialogRevision(true)"
                                    >
                                <span v-if="cadRequestLatestRevision" class="overline font-weight-black" >
                                    {{cadRequestLatestRevision}}
                                </span>
                                <span v-else>
                                    <v-btn icon :disabled="$store.state.mainCloseStore == '1'">
                                        <v-icon>
                                            mdi-plus
                                        </v-icon>
                                    </v-btn> 
                                </span>
                                </td>

                                <!-- Start --> 

                                <!-- 設計受託契約 / design_contract-->
                                <td 
                                    id="design_contract"
                                    ref="design_contract"
                                    v-if="vHeader.header == '設計受託契約'" 
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container @click="toggleCadRequest('design_contract')">
                                        <v-icon 
                                            color="red" 
                                            v-show="cadRequestRevisionContent.design_contract"
                                        >mdi-checkbox-blank-circle-outline</v-icon>
                                    </v-container>
                                </td>

                                <!-- 最高高さ・見付面積・平均GL計算根拠 / calculation_basis -->
                                <td 
                                    id="calculation_basis"
                                    ref="calculation_basis"
                                    v-if="vHeader.header == '最高高さ・見付面積・平均GL計算根拠'" 
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    
                                    <v-container @click="toggleCadRequest('calculation_basis')">
                                        <v-icon 
                                            color="red" 
                                            v-show="cadRequestRevisionContent.calculation_basis"
                                        >mdi-checkbox-blank-circle-outline</v-icon>
                                    </v-container>
                                </td>

                                <!-- カラー配置図 / site_layout-->
                                <td 
                                    id="site_layout"
                                    ref="site_layout"
                                    v-if="vHeader.header == 'カラー配置図'"
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || cadRequestRevisionContent.gravity == 4 ? ' disabled-cell' : ''"
                                    
                                >
                                <!-- @click="toggleCadRequest('site_layout')"  -->
                                    <v-container>
                                        <v-btn-toggle v-model="toggleB5" dense group class="btn-toggle">
                                            <v-btn 
                                                v-for="(siteLayout, iii) in siteLayouts"
                                                :key="iii + 'siteLayout'"
                                                :value="siteLayout" 
                                                text 
                                                small 
                                                :class="toggleB5 == siteLayout ? 'selected mt-n1' : 'mt-n1'"
                                                @click="toggleCadRequest('site_layout', {text : siteLayout})"
                                                :disabled="!cadRequestLatestRevision || disableSelections"
                                                > 
                                                <span class="font-weight-black">{{siteLayout}}</span> 
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-container>
                                </td>

                                <!-- スペック依頼 / specs_irai -->
                                <td 
                                    id="specs_irai"
                                    ref="specs_irai"
                                    v-if="vHeader.header == 'スペック依頼'"
                                    :class="!cadRequestLatestRevision || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? ' disabled-cell' : ''"
                                > 
                                    <v-container>
                                        <div id="toggleB6_1">
                                            <v-btn-toggle v-model="toggleB6_1" dense group>
                                                <v-btn
                                                    v-for="(sashType, iii) in SASH_TYPE"
                                                    :key="iii + 'sashType'"
                                                    :value="sashType.sash_spec" 
                                                    text 
                                                    small 
                                                    :class="toggleB6_1 == sashType.sash_spec || cadRequestRevisionContent.specs_irai.sash_type == sashType.sash_spec ? 'selected mt-n1' : 'mt-n1'"
                                                    :disabled="!cadRequestLatestRevision"
                                                    @click="toggleCadRequest('specs_irai', {selection: 'sash_type',text : sashType.sash_spec})"
                                                    > <span class="font-weight-black"> {{sashType.sash_spec}} </span> 
                                                </v-btn>
                                            </v-btn-toggle>
                                        </div>
                                        <div id="toggleB6_2">
                                            <v-btn-toggle v-model="toggleB6_2" dense group>
                                                    <span class="font-weight-black mt-2" >強化: </span>
                                                <v-btn 
                                                    v-for="(spec, iii) in specs"
                                                    :key="iii + 'spec'"
                                                    :value="spec" 
                                                    text 
                                                    small 
                                                    :class="toggleB6_2 == spec || cadRequestRevisionContent.specs_irai.specs == spec ? 'selected ' : ''"
                                                    :disabled="!cadRequestLatestRevision"
                                                    @click="toggleCadRequest('specs_irai', {selection: 'specs',text : spec})"
                                                    > 
                                                    <span class="font-weight-black"> {{ spec }} </span>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </div>

                                        <div id="toggleB6_3">
                                            <v-btn-toggle v-model="toggleB6_3" dense group multiple>
                                                <v-btn 
                                                    v-for="(acce, iii) in accessories"
                                                    :key="iii + 'acce'"
                                                    :value="acce" 
                                                    text 
                                                    small 
                                                    :disabled="!cadRequestLatestRevision"
                                                    :class="toggleB6_3.includes(acce) ? 'selected ' : ''"
                                                    @click="toggleCadRequest('specs_irai', {selection: 'accessories'})"
                                                    > 
                                                        <span class="font-weight-black">{{ acce }}</span> 
                                                </v-btn>
                                            </v-btn-toggle>
                                        </div>

                                        <div id="toggleB6_4">
                                            <v-btn-toggle v-model="toggleB6_4" dense group class="specific-toggle">
                                                <v-btn
                                                    v-for="(hc, iii) in honeycomb"
                                                    :key="iii + 'hc'"
                                                    :value="hc"
                                                    text
                                                    small
                                                    :disabled="!cadRequestLatestRevision"
                                                    :class="toggleB6_4 == hc || cadRequestRevisionContent.specs_irai.honeycomb == hc ? 'selected ' : ''"
                                                    @click="toggleCadRequest('specs_irai', {selection : 'honeycomb', text : hc})"
                                                    >
                                                        <span class="font-weight-black">{{ hc }}</span> 
                                                </v-btn>
                                            </v-btn-toggle>
                                        </div>
                                    </v-container>
                                </td>

                                <!-- DXFデータ依頼 / dxf_data_request -->
                                <td 
                                    id="dxf_data_request"
                                    ref="dxf_data_request"
                                    @click="toggleCadRequest('dxf_data_request')"
                                    v-if="vHeader.header == 'DXFデータ依頼'"
                                    :class="!cadRequestLatestRevision || disableSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container>
                                        <v-icon color="red" v-show="cadRequestRevisionContent.dxf_data_request">mdi-checkbox-blank-circle-outline</v-icon>
                                    </v-container>
                                </td>

                                <!-- カラーパース / colors perspective -->
                                <td 
                                    id="color_pers"
                                    ref="color_pers"
                                    v-if="vHeader.header == 'カラーパース'"
                                    @click="toggleCadRequest('color_pers')"
                                    :class="!cadRequestLatestRevision || disableSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"

                                > 
                                    <v-container v-show="cadRequestRevisionContent.color_pers == 1">
                                        <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        <div v-if="hideColorPersTable == 0">
                                            <v-simple-table>
                                                <thead>
                                                    <tr>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点方向</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点高さ</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in cadRequestColorPers" :key="index">
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.perspective_direction }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.viewpoint_height }}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>
                                    </v-container>
                                    <!-- {{cadRequestRevisionContent.color_pers}} -->
                                </td>

                                <!-- ハウス プレゼンテーション / house presentation-->
                                <td 
                                    id="house_presentation"
                                    ref="house_presentation"
                                    v-if="vHeader.header == 'ハウス プレゼンテーション'"
                                    @click="toggleCadRequest('house_presentation')"
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                <v-container >
                                        <v-icon v-if="cadRequestRevisionContent.house_presentation == 1" color="red">mdi-checkbox-blank-circle-outline</v-icon>
                                        <!-- <span v-else-if="cadRequestRevisionContent.house_presentation == 'INT'" style="font-size:18px;color:red;">INT</span> -->
                                        <div v-if="hideHpTable == 0">
                                            <v-simple-table>
                                                <thead>
                                                    <tr>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">視点方向</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in cad_request_house_presentation" :key="index">
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.perspective_direction }}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>
                                    </v-container>
                                </td>

                                <!-- インテリアパース /  house_presentation_int -->
                                <td
                                    id="house_presentation_int"
                                    ref="house_presentation_int"
                                    v-if="vHeader.header == 'インテリアパース【トライアル】'"
                                    @click="toggleCadRequest('house_presentation_int')"
                                    :class="!cadRequestLatestRevision || disableSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                >
                                    <v-container>
                                        <v-icon color="red" v-show="cadRequestRevisionContent.house_presentation_int">mdi-checkbox-blank-circle-outline</v-icon><br>
                                        <span v-show="cadRequestRevisionContent.house_presentation_int">パターン : <b>{{ cadRequestRevisionContent.house_presentation_int }}</b></span>
                                    </v-container>

                                <!-- <v-container v-if="cad_request_house_presentation_int.length > 0">
                                    <v-icon color="red">mdi-checkbox-blank-circle-outline</v-icon>
                                        <div>
                                            <v-simple-table>
                                                <thead>
                                                    <tr>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">パ一タン</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">階</th>
                                                        <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">部屋</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in cad_request_house_presentation_int" :key="index">
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ index + 1 }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.floor }}</td>
                                                        <td style="font-size: 10px !important; height: 10% !important">{{ item.layout }}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>
                                </v-container> -->
                                </td>
                                
                                <!-- 仕様検討ツール / shio_request-->
                                <td 
                                    id="shio_request"
                                    ref="shio_request"
                                    v-if="vHeader.header == '仕様検討ツール'"
                                    @click="toggleCadRequest('shio_request')"
                                    :class="!cadRequestLatestRevision || disableSelections || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                <v-container v-if="cadRequestRevisionContent.shio_request">
                                    <div v-if="cadRequestRevisionContent.SRS_request">
                                        <v-icon  v-if="cadRequestRevisionContent.SRS_request.shio_selection !== '2'" color="red">mdi-checkbox-blank-circle-outline</v-icon><br>
                                        <span v-if="cadRequestRevisionContent.SRS_request.shio_selection == '1'" style="color:blue !important;"><b>SRS</b><br></span>
                                        <span v-if="cadRequestRevisionContent.SRS_request.shio_selection == '2'" style="color:red !important;"><b>PEL only</b><br></span>
                                        <span v-if="cadRequestRevisionContent.SRS_request.shio_selection == '3'" style="color:blue !important;"><b>SRS+PDF</b><br></span>
                                        <!-- <span v-if="cadRequestRevisionContent.SRS_request.shio_selection == '1'">仕様書番号 : {{cadRequestRevisionContent.SRS_request.shio_number}}</span>  // NAKACOMMENT NA TLAGA-->
                                    </div>
                                </v-container>
                                </td>

                                <!-- WEB打ち合わせ用提案資料 /web_documents -->
                                <td 
                                    id="web_documents"
                                    ref="web_documents"
                                    v-if="vHeader.header == 'WEB打ち合わせ用提案資料'"
                                    @click="toggleCadRequest('web_documents')"
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container>
                                        <span v-for="(webDoc, ii) in cadRequestRevisionContent.web_documents" :key="ii+'webDocs'">
                                            <v-icon color="red">
                                                {{`mdi-numeric-${webDoc.value}-circle-outline`}}
                                                <!-- {{`mdi-alpha-${webDoc.value.toLowerCase()}-circle-outline`}} -->
                                            </v-icon>
                                        </span>
                                    </v-container>
                                </td>

                                <!-- カラー配置図 (測定点入) / jiban_plan -->
                                <td 
                                    id="jiban_plan"
                                    ref="jiban_plan"
                                    v-if="vHeader.header == 'カラー配置図 (測定点入)'"
                                    @click="toggleCadRequest('jiban_plan')"
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container>
                                        <v-icon color="red" v-show="cadRequestRevisionContent.jiban_plan">mdi-checkbox-blank-circle-outline</v-icon>
                                    </v-container>
                                </td>

                                <!-- ALVS検討依頼 / alvs-->
                                <td 
                                    id="alvs"
                                    ref="alvs"
                                    v-if="vHeader.header == 'ALVS検討依頼'"
                                    @click="toggleCadRequest('alvs')"
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container>
                                        <v-icon color="red" v-if="typeof cadRequestRevisionContent.alvs == 'boolean' || cadRequestRevisionContent.alvs == '1'">mdi-checkbox-blank-circle-outline</v-icon>
                                        <p v-else class="font-weight-bold red--text">{{cadRequestRevisionContent.alvs}}</p>
                                    </v-container>
                                </td>

                                <!-- 構造事前検討依頼 / structural_request -->
                                <td 
                                    id="structural_request"
                                    ref="structural_request"
                                    v-if="vHeader.header == '構造事前検討依頼'"
                                    @click="toggleCadRequest('structural_request')"
                                    :class="!cadRequestLatestRevision || disableReform || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container v-if="cadRequestRevisionContent.structural_request">
                                        <div v-if="cadRequestRevisionContent.structural_request.OPTION_1 == 'あり'">
                                            <div v-if="cadRequestRevisionContent.structural_request.OPTION_ZEH">
                                                <span class="red--text font-weight-black">ZEH</span>
                                            </div>

                                            <div v-if="cadRequestRevisionContent.structural_request.OPTION_GX">
                                                <span class="red--text font-weight-black">GX</span>
                                            </div>

                                            <div>
                                                <v-icon color="red">mdi-checkbox-blank-circle-outline</v-icon>
                                            </div>

                                            <div>
                                                <span class="">ダクト指示 </span>
                                            </div>

                                            <div>
                                                <template v-if="cadRequestRevisionContent.structural_request.OPTION_2 == 'あり'">
                                                    <span class="mx-2 selected">あり</span>
                                                    <span class="mx-2">なし</span>
                                                </template>

                                                <template v-else-if="cadRequestRevisionContent.structural_request.OPTION_2 == 'なし'">
                                                    <span class="mx-2 ">あり</span>
                                                    <span class="mx-2 selected">なし</span>
                                                </template>

                                                <template v-else>
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2">なし</span>
                                                </template>
                                            </div>

                                            <div>
                                                <span>等級</span>
                                            </div>

                                            <div>
                                                <span class="red--text font-weight-black">{{ cadRequestRevisionContent.structural_request.OPTION_W }}</span>
                                                <span class="red--text font-weight-black">{{ cadRequestRevisionContent.structural_request.OPTION_S }}</span>
                                            </div>
                                        </div>
                                        <!-- {{ cadRequestRevisionContent.structural_request }} -->
                                        <div v-else-if="cadRequestRevisionContent.structural_request.OPTION_1 == 'なし'">
                                            <div v-if="cadRequestRevisionContent.structural_request.OPTION_W || cadRequestRevisionContent.structural_request.OPTION_S">
                                                <span class="">ダクト指示 </span>
                                                <div v-if="cadRequestRevisionContent.structural_request.OPTION_1 == 'なし'">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2 selected">なし</span>
                                                </div>
                                                <div v-else-if="cadRequestRevisionContent.structural_request.OPTION_1 == null">
                                                    <span class="mx-2">あり</span>
                                                    <span class="mx-2">なし</span>
                                                </div>
                                                <div>
                                                    <span>等級</span>
                                                </div>
                                            </div>
                                            <div>
                                                <span class="red--text font-weight-black">{{ cadRequestRevisionContent.structural_request.OPTION_W }}</span>
                                                <span class="red--text font-weight-black">{{ cadRequestRevisionContent.structural_request.OPTION_S }}</span>
                                            </div>
                                        </div>
                                    </v-container>
                                </td>

                                <!-- 提案電気図面依頼 / pdr -->
                                <!-- <td 
                                    id="pdr"
                                    ref="pdr"
                                    v-if="vHeader.header == '提案電気図面依頼'"
                                    @click="toggleCadRequest('pdr')"
                                    :class="!cadRequestLatestRevision || disableReform || disableSelections || disableOtherSelections || (cadRequestRevisionContent.electrical_drawing && cadRequestRevisionContent.electrical_drawing.radioGravity != null) 
                                            ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container>
                                        <v-icon color="red" v-show=" cadRequestRevisionContent.pdr != '0' && cadRequestRevisionContent.pdr != null">mdi-checkbox-blank-circle-outline</v-icon>
                                    </v-container>
                                </td> -->

                                <!-- 電気図面依頼（提案電気図面依頼含む） / electrical_drawing -->
                                <template>
                                    <td 
                                        id="electrical_drawing"
                                        ref="electrical_drawing"
                                        v-if="vHeader.header == '電気図面依頼（提案電気図面依頼含む）'"
                                        @click="toggleCadRequest('electrical_drawing')"
                                        :class="!cadRequestLatestRevision || disableSelections || cadRequestRevisionContent.denki_gravity != null || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                    >
                                        <v-container v-if="cadRequestRevisionContent.electrical_drawing">
                                            <div v-if="cadRequestRevisionContent.electrical_drawing.OPTION_1 == 'あり'">
                                                <div>
                                                    <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                </div>
                                                <span class="">E更新</span>
                                                <div>
                                                    <template v-if="cadRequestRevisionContent.electrical_drawing.OPTION_2 == 'あり'">
                                                        <span class="mx-2 selected">あり</span>
                                                        <span class="mx-2">なし</span>
                                                    </template>
                                                    
                                                    <template v-else-if="cadRequestRevisionContent.electrical_drawing.OPTION_2 == 'なし'">
                                                        <span class="mx-2 ">あり</span>
                                                        <span class="mx-2 selected">なし</span>
                                                    </template>

                                                    <template v-else>
                                                        <span class="mx-2">あり</span>
                                                        <span class="mx-2">なし</span>
                                                    </template>
                                                </div>
                                                <!-- <div>
                                                    <span>等級</span>
                                                </div> -->
                                            </div>
                                            <!-- <div v-if="$store.state.getDrawingRequest != 0"> -->
                                            <!-- <div v-if="cadRequestRevisionContent.electrical_drawing.selectedDrawing != 0"> -->
                                            <div v-if="cadRequestRevisionContent && cadRequestRevisionContent.electrical_drawing && 
                                                        (Array.isArray(cadRequestRevisionContent.electrical_drawing.selectedDrawing) &&
                                                        cadRequestRevisionContent.electrical_drawing.selectedDrawing.length > 0)">
                                                <v-simple-table class="mt-2">
                                                    <thead>
                                                        <tr>
                                                            <!-- <th colspan="3" style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">追加依頼</th> -->
                                                            <th colspan="2" style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">追加依頼</th>
                                                        </tr>
                                                        <tr>
                                                            <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">LED</th>
                                                            <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">チェック</th>
                                                            <!-- <th style="font-size: 10px !important; height: 10% !important;padding:0px !important; text-align:center !important;">盤図</th> -->
                                                        </tr>
                                                        <tr>
                                                            <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                <div v-if="cadRequestRevisionContent.electrical_drawing.selectedDrawing.includes('1')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                            </td>
                                                            <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                <div v-if="cadRequestRevisionContent.electrical_drawing.selectedDrawing.includes('2')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                            </td>
                                                            <!-- <td style="font-size: 10px !important; height: 20% !important;padding:0px !important; text-align:center !important;">
                                                                <div v-if="cadRequestRevisionContent.electrical_drawing.selectedDrawing.includes('3')" style="border: 0.5px solid black; background-color: black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                                    <div v-else style="border: 0.5px solid black; height: 8px; width: 8px; margin: 1px auto;"></div>
                                                            </td> -->
                                                        </tr>
                                                    </thead>
                                                </v-simple-table>
                                            </div>
                                            <div v-else>
                                                <span></span>
                                            </div>

                                            <div v-if="cadRequestRevisionContent.electrical_drawing.radioPdr != null && cadRequestRevisionContent.electrical_drawing.pdr_title != null">
                                                <div>
                                                    <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                                </div>
                                                <span style="font-size:14px;color:red;">PDR</span>
                                            </div>
                                            <div v-else>
                                                <span></span>
                                            </div>
                                            <!-- <div v-else-if="cadRequestRevisionContent.electrical_drawing.pdr_title != null">
                                                <span></span>
                                            </div> -->

                                        </v-container>
                                    </td>
                                </template>

                                <!-- 断面図/申請用立面図依頼 / Section drawing/elevation request for application -->
                                <td
                                    id="elevation_request"
                                    ref="elevation_request"
                                    v-if="vHeader.header == '断面図/申請用立面図依頼'"
                                    @click="toggleCadRequest('elevation_request')"
                                    :class="!cadRequestLatestRevision || disableReform || disableSelections || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                    >
                                    <!-- :class="!cadRequestLatestRevision || disableReform || disableOtherSelections ? 'custom-cell disabled-cell' : 'custom-cell'" -->

                                    <v-container>
                                        <div v-if="cadRequestRevisionContent.cross_section != null && cadRequestRevisionContent.elevation_section != null">
                                            <span style="font-size:20px;font-weight:bold;color:red;">D・R</span>
                                        </div>

                                        <div v-else-if="cadRequestRevisionContent.cross_section != null">
                                            <span style="font-size:20px;font-weight:bold;color:red;">D</span>
                                        </div>

                                        <div v-else-if="cadRequestRevisionContent.elevation_section != null">
                                            <span style="font-size:20px;font-weight:bold;color:red;">R</span>
                                        </div>

                                        <div v-else-if="cadRequestRevisionContent.cross_section == null && cadRequestRevisionContent.elevation_section == null">
                                            <span> </span>
                                        </div>
                                    </v-container>
                                </td>
                                
                                <!-- STOP / stop -->
                                <td 
                                    id="stop"
                                    ref="stop"
                                    v-if="vHeader.header == 'STOP'"
                                    @click="toggleCadRequest('stop')"
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container v-if="cadRequestRevisionContent && cadRequestRevisionContent.stopListSelection != null">
                                        <v-icon v-if="cadRequestRevisionContent.stopListSelection[0].option1 == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon><br>
                                        <span v-if="cadRequestRevisionContent.stopListSelection[0].option1 == '1'">施工連絡</span><br>
                                        <template v-if="cadRequestRevisionContent.stopListSelection[0].option2 == '1'">
                                            <span class="mx-2 selected">あり</span>
                                            <span class="mx-2 ">なし</span>
                                        </template>
                                        <template v-if="cadRequestRevisionContent.stopListSelection[0].option2 == '0'">
                                            <span class="mx-2">あり</span>
                                            <span class="mx-2 selected">なし</span>
                                        </template>
                                    </v-container>

                                    <v-container v-else>
                                        <v-icon v-if="cadRequestRevisionContent.stop == '1'" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                        <span v-if="cadRequestRevisionContent.stop == '2'" class="red--text text-h6">QG</span>
                                    </v-container>
                                </td>

                                <!-- 着手準備 / drawing_request - final_plan -->
                                
                                <td 
                                    id="final_plan"
                                    ref="final_plan"
                                    v-if="vHeader.header == '着手準備'"
                                    @click="toggleCadRequest('final_plan')"
                                    :class="!cadRequestLatestRevision || disableSelections || disableReform || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                > 
                                    <v-container v-if="cadRequestRevisionContent.final_plan == '1'">
                                        <v-icon v-show="cadRequestRevisionContent.final_plan" color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                    </v-container>
                                    <v-container v-if="cadRequestRevisionContent.final_plan == '2'">
                                        <v-icon v-show="cadRequestRevisionContent.final_plan" color="red" >mdi-numeric-1-circle-outline</v-icon>
                                    </v-container>
                                    <v-container v-if="cadRequestRevisionContent.final_plan == '3'">
                                        <v-icon v-show="cadRequestRevisionContent.final_plan" color="red" >mdi-numeric-2-circle-outline</v-icon>
                                    </v-container>
                                </td>

                                <!-- 即日依頼 / express -->
                                <template>
                                    <td 
                                        id="express"
                                        ref="express"
                                        v-if="vHeader.header == '即日依頼' && cadRequestRevisionContent.final_plan"
                                        @click="toggleCadRequest('express')"
                                        :class="!cadRequestLatestRevision || disableSelections || disableOtherSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                        style="cursor:pointer;"
                                    >    
                                    
                                        <v-container>
                                            <v-icon color="red" v-show="cadRequestRevisionContent.express">mdi-checkbox-blank-circle-outline</v-icon>
                                        </v-container>
                                    </td>
                                    <td 
                                        id="express"
                                        ref="express"
                                        v-else-if="vHeader.header == '即日依頼' && !cadRequestRevisionContent.final_plan"
                                        :class="!cadRequestLatestRevision || disableSelections || cadRequestRevisionContent.gravity == 4 ? 'custom-cell disabled-cell' : 'custom-cell'"
                                        style="cursor:pointer;"
                                    >    
                                    </td>
                                </template>
                                <!-- :class="!cadRequestLatestRevision ? ' disabled-cell' : ''" -->

                                <!-- 依頼書添付 -->
                                <td 
                                    id="request_attach_from"
                                    ref="request_attach_from"
                                    v-if="vHeader.header == '依頼書添付'"
                                    @click="toggleCadRequest('request_attach_from')"
                                    :class="!cadRequestLatestRevision ? ' disabled-cell' : ''"
                                    style="cursor:pointer;"
                                > 
                                    <v-container v-if="cadRequestRevisionContent.request_attach_from == '1'">
                                        <v-icon color="red" >mdi-checkbox-blank-circle-outline</v-icon>
                                    </v-container>
                                </td> 
                                <!-- actions -->
                                    <td 
                                        style="border-bottom : none; border-left: none; border-right: none;"
                                        id="B21"
                                        ref="B21"
                                        v-if="vHeader.header == 'actions'"
                                    > 
                                        <!-- SAVE AS DRAFT 下書き保存 -->
                                        <div class="my-2">
                                            <!-- NOTE - OLD CHARACTER IN SAVE AS DRAFT BUTTON - 11/21/25 UARY -->
                                            <v-btn :disabled="!cadRequestLatestRevision || cadRequestRevisionContent.status == 'DRAFT'" color="blue-grey" dark @click="draftSaveCadRequest()" small id="save-draft" width="100px"> 保存(下書き) </v-btn> 
                                            
                                            <!-- NOTE - NEW CHARACTER IN SAVE AS DRAFT BUTTON - 11/21/25 UARY -->
                                            <!-- <v-btn :disabled="!cadRequestLatestRevision || cadRequestRevisionContent.status == 'DRAFT'" color="blue-grey" dark @click="draftSaveCadRequest()" small id="save-draft" width="100px"> 送信(下書き) </v-btn>  -->
                                        </div> 
                                        <div class="my-2">
                                            <!-- <v-btn :loading="loading" :disabled="!cadRequestLatestRevision || cadRequestRevisionContent.status == 'SAVED'" color="success" dark @click="saveCadRequest()" small id="save" width="100px"> 送信 </v-btn>  -->
                                            
                                            <!-- NOTE - OLD CHARACTER IN SAVE BUTTON - 11/21/25 UARY -->
                                            <!-- <v-btn :disabled="!cadRequestLatestRevision || cadRequestRevisionContent.status == 'SAVED'" color="success" dark @click="saveCadRequest()" small id="save" width="100px"> 保存 </v-btn>  -->
                                            
                                            <!-- NOTE - NEW CHARACTER IN SAVE BUTTON - 11/21/25 -->
                                            <v-btn :disabled="!cadRequestLatestRevision || cadRequestRevisionContent.status == 'SAVED'" color="success" dark @click="saveCadRequest()" small id="save" width="100px"> 送信 </v-btn> 
                                            
                                            <!-- <v-btn :disabled="!cadRequestLatestRevision || cadRequestRevisionContent.status == 'SAVED'" color="success" dark @click="testMerging" small id="save" width="100px"> 送信 </v-btn>  -->
                                        </div> 
                                        <div class="my-2">
                                            <v-btn :disabled="!cadRequestLatestRevision" color="red" dark @click="cancelNewPlan()" small id="save-draft" width="100px"> キャンセル </v-btn> 
                                        </div> 
                                        <!-- <div class="my-2"> -->
                                            <!-- <v-btn v-show="cadRequestRevisionContent.status == 'SAVED'" color="indigo" dark @click="HRDAcceptCadRequest" small id="hrdaccept" width="150px"> HRD ACCEPT </v-btn>  -->
                                        <!-- </div>  -->
                                    </td> 
                            </template>
                            <!--!SECTION Latest - Main Transaction Table -->
                        </tr>
                    </tbody>
                <!-- </section> -->
                </div>
            <!-- </section> -->
            </v-simple-table>
        <!-- </section> -->
        </div>

        <!-- Dialogs  -->
            <dialog-revision 
                @toggleDialogRevision="toggleDialogRevision"
                @toggleDialogShioRequest="toggleDialogShioRequest"
                @sendDialogRevisionData="GetDialogRevisionData"
                :dialog="dialogRevision"
            ></dialog-revision>
            
            <dialog-color-perspective v-if="$store.state.getNumber == 1 || $store.state.customerCodeFromView != null"
                @toggleDialogColorPerspective="toggleDialogColorPerspective"
                @closeDialog="closeDialog"
                @emmitedColor="emmitedColor"
                @proceedToNext="proceedToNext"
                :colorPers="colorPers"
                :dialog="dialogColorPerspective"
            ></dialog-color-perspective>

            <dialog-house-presentation  v-if="$store.state.forMounHp != null || editColor != null"
                @toggleDialogHousePresentation="toggleDialogHousePresentation"
                @emmitedHp="emmitedHp"
                :housePresentation="housePresentation"
                :dialog="dialogHousePresentation"
            ></dialog-house-presentation>

            <dialog-house-presentation-int
                @toggleDialogHousePresentationInt="toggleDialogHousePresentationInt"
                @storeInt="storeInt"
                :dialog="dialogHousePresentationInt"
                @closeInt="closeInt"
            ></dialog-house-presentation-int>
            <!-- @proceedNext="proceedNext" -->
            

            <dialog-web-documents
                @toggleDialogWebDocuments="toggleDialogWebDocuments"
                @submitWebDocumentSelection="submitWebDocumentSelection"
                :dialog="dialogWebDocuments"
            ></dialog-web-documents>

            <!-- <dialog-web-documents
                @toggleDialogWebDocuments="toggleDialogWebDocuments"
                :dialog="dialogWebDocuments"
            ></dialog-web-documents> -->

            <dialog-confirmation-items
                @toggleDialogConfirmationItems="toggleDialogConfirmationItems"
                @confirmJibanPlan="confirmJibanPlan"
                :dialog="dialogConfirmationItems"
            ></dialog-confirmation-items>

            <dialog-alvs
                @toggleDialogAlvs="toggleDialogAlvs"
                @confirmAlvs="confirmAlvs"
                :dialog="dialogAlvs"
            ></dialog-alvs>

            <dialog-structural-request
                @toggleDialogStructuralRequest="toggleDialogStructuralRequest"
                @confirmStructuralRequest="confirmStructuralRequest"
                :dialog="dialogStructuralRequest"
            ></dialog-structural-request>

            <dialog-electrical-drawing
                @toggleDialogElectricalDrawing="toggleDialogElectricalDrawing"
                @confirmElectricalDrawing="confirmElectricalDrawing"
                :dialog="dialogElectricalDrawing"
                ref="dialogElectricalDrawing"
            ></dialog-electrical-drawing>
                <!-- @closetoggleDialogElectricalDrawing="closetoggleDialogElectricalDrawing" -->


            <dialog-drawing-request
                @toggleDialogDrawingRequest="toggleDialogDrawingRequest"
                @confirmDrawingRequest="confirmDrawingRequest"
                :dialog="dialogDrawingRequest"
            ></dialog-drawing-request>
            
            <dialog-attachment-form
                @toggleDialogAttachmentForm="toggleDialogAttachmentForm"
                :dialog="dialogAttachmentForm"
                @getCadActualData="getCadActualData"
                ref="dialogAttachmentForm"
            ></dialog-attachment-form>
            
            <dialog-previous-attachment-form
                @toggleDialogPreviousAttachmentForm="toggleDialogPreviousAttachmentForm"
                :dialog="dialogPreviousAttachmentForm"
                @updateMerging="updateMerging"
                @getCadActualData="getCadActualData"
            ></dialog-previous-attachment-form>

            <dialog-site-layout
                @toggleDialogSiteLayout="toggleDialogSiteLayout"
                @submitSiteLayout="submitSiteLayout"
                @cancelSubmit="cancelSubmit"
                :dialog="dialogSiteLayout"
            ></dialog-site-layout>

            <dialog-new-site-layout
                @toggleDialogNewSiteLayout="toggleDialogNewSiteLayout"
                @submitNewSiteLayout="submitNewSiteLayout"
                @cancelNewSubmit="cancelNewSubmit"
                :dialog="dialogNewSiteLayout"
            ></dialog-new-site-layout>
            
            <!-- <dialog-pdr
                @toggleDialogPdr="toggleDialogPdr"
                @submitPdr="submitPdr"
                @cancelPdr="cancelPdr"
                :dialog="dialogPdr">
            </dialog-pdr> -->

            <dialog-elevation-request
                @toggleDialogElevationRequest="toggleDialogElevationRequest"
                @submitElevation="submitElevation"
                @cancelElevation="cancelElevation"
                :dialog="dialogElevation">
            </dialog-elevation-request>
            
            <dialog-stop
                @toggleDialogStop="toggleDialogStop"
                @submitStop="submitStop"
                :dialog="dialogStop">
            </dialog-stop>
            
            <dialog-boss-schedule
                @toggleDialogBossSchedule="toggleDialogBossSchedule"
                @triggerSocketBossSending="triggerSocketBossSending"
                :dialog="dialogBossSchedule">
            </dialog-boss-schedule>
            
            <dialog-shio-request
                @toggleDialogShioRequest="toggleDialogShioRequest"
                @submitShioRequest="submitShioRequest"
                :dialog="dialogShioRequest">
            </dialog-shio-request>
                <!-- @submitShioRequest="submitShioRequest" -->

            
            <dialog-boss-list
                v-if="$store.state.getNumber == 1 || $store.state.customerCodeFromView != null || $store.state.getBossiCad != null" 
                @toggleBossListDialog="toggleBossListDialog"
                @confirmBoss="confirmBoss"
                :dialog="dialogBossList">
            </dialog-boss-list>

            <!-- <dialog-electrical-request
                @toggleDialogElectricalRequest="toggleDialogElectricalRequest"
                @submitElectricalRequest="submitElectricalRequest"
                @closetoggleDialogElectricalRequest="closetoggleDialogElectricalRequest"
                :dialog="dialogElectricalRequest">
            </dialog-electrical-request> -->
    
            <home-view
                
                v-show="homeView"
                @editCadRequest="editCadRequest"
                @updateCadRequest="updateCadRequest"
            ></home-view>

            <dialog-denki-request
                @toggleDialogDenkiRequest="toggleDialogDenkiRequest"
                @submitProposal="submitProposal"
                @cancelProposal="cancelProposal"
                :dialog="dialogDenkiRequest">
            </dialog-denki-request>

            <v-dialog v-model="dialogStop2" persistent  max-width="400">
                <v-card>
                    <v-card-title><span class="headline">【STOPチェック依頼】</span></v-card-title>
                    <v-container>
                        <v-card-text>
                            <v-container>
                                <v-radio-group v-model="stop2_selection" dense>
                                    <v-radio value="1" style="align-items: flex-start;" :disabled="stopPlan >= 2 && loggedInUser.is_admin != 1 && loggedInUser.plan_control != 1">
                                        <template v-slot:label>
                                            <div>
                                                <div class="font-weight-medium">STOPチェック依頼</div>
                                                <div class="text-caption red--text">※着手準備以前に１回だけ依頼可能</div>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="2" style="align-items: flex-start;">
                                        <template v-slot:label>
                                            <div>
                                                <div class="font-weight-medium">STOPチェック依頼【QualityGateトライアル】</div>
                                                <div class="text-caption red--text">※QualityGateトライアルは複数回依頼可能</div>
                                            </div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                            </v-container>
                        </v-card-text>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="red" @click="dialogStop2 = false">キャンセル</v-btn>
                        <v-btn dark color="green" @click="confirmStop2()">保存</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

    <app-snackbar :snackbar="snackbar" @toggleSnackBar="toggleSnackBar"></app-snackbar>
    <app-loader></app-loader>

        <!-- <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay> -->
    </div>
</template>

<script src="path/to/vue-dragscroll.min.js"></script>

<script >
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';

// ? DIALOGS
    import DialogRevision from '../components/main-page-modules/DialogRevision';
    import DialogColorPerspective from '../components/main-page-modules/DialogColorPerspective';
    import DialogHousePresentation from '../components/main-page-modules/DialogHousePresentation';
    import DialogWebDocuments from '../components/main-page-modules/DialogWebDocuments';
    import DialogConfirmationItems from '../components/main-page-modules/DialogConfirmationItems';
    import DialogAlvs from '../components/main-page-modules/DialogAlvs';
    import DialogStructuralRequest from '../components/main-page-modules/DialogStructuralRequest';
    import DialogElectricalDrawing from '../components/main-page-modules/DialogElectricalDrawing';
    import DialogDrawingRequest from '../components/main-page-modules/DialogDrawingRequest';
    import DialogAttachmentForm from '../components/main-page-modules/DialogAttachmentForm';
    import PreviousDialogAttachmentForm from '../components/main-page-modules/DialogPreviousAttachment';
    import DialogSiteLayout from '../components/main-page-modules/DialogSiteLayout';
    import DialogPdr from '../components/main-page-modules/DialogPdr';
    // import DialogElectricalRequest from '../components/main-page-modules/DialogElectricalRequest';
    import DialogElevationRequest from '../components/main-page-modules/DialogElevationRequest'
    import DialogStop from '../components/main-page-modules/DialogStop';
    import DialogNewSiteLayout from '../components/main-page-modules/DialogNewSiteLayout';
    import DialogBossSchedule from '../components/main-page-modules/DialogBossSchedule';
    import DialogHousePresentationInt from '../components/main-page-modules/DialogHousePresentationInt';
    import DialogShioRequest from '../components/main-page-modules/DialogShioRequest';
    import DialogBossList from '../components/main-page-modules/DialogBossList';
    import DialogDenkiRequest from '../components/main-page-modules/DialogDenkiRequest';
    import Home from './Home.vue';
    import Snackbar from '../modules/SnackBar.vue' 
    import Loader from '../modules/Loader.vue';
    import Swal from 'sweetalert2';
// ? END OF DIALOGS

// ? EXTERNAL JS for boss uploading and registration
    import { 
        generateHRDID, 
        getZumenType, 
        getZumenTypeMultiple,
        getBundleSchedule, 
        saveToXML, 
        updateXML, 
        sendToBoss, 
        updateBossCadRequest, 
        removeHrdAccept
    } from './ExternalJS/BossCodeUploading.js'

    import {
        getAllBossCode,
        newBossRegister,
        json_remarks
    } from './ExternalJS/BossRegister.js'
// ? end of external JS

import { PDFDocument, PDFPage } from 'pdf-lib'; // ? for merging of pdf in front-end
import AWS from 'aws-sdk';
// import { dragscroll } from 'vue-dragscroll'
import VueDragscroll from 'vue-dragscroll'
import { mapState, mapActions } from 'vuex';

export default {
    props : {
        overlayPlanner: {
            type: Boolean
        }
    },
    directives: {
        'Dragscroll' : VueDragscroll
    },
    components: {
        DialogAttachmentForm,
        'dialog-revision': DialogRevision,
        'dialog-color-perspective': DialogColorPerspective,
        'dialog-house-presentation': DialogHousePresentation,
        'dialog-house-presentation-int': DialogHousePresentationInt,
        'dialog-web-documents': DialogWebDocuments,
        'dialog-confirmation-items': DialogConfirmationItems,
        'dialog-alvs': DialogAlvs,
        'dialog-structural-request': DialogStructuralRequest,
        'dialog-electrical-drawing': DialogElectricalDrawing,
        'dialog-drawing-request': DialogDrawingRequest,
        'dialog-attachment-form': DialogAttachmentForm,
        'dialog-previous-attachment-form': PreviousDialogAttachmentForm,
        'dialog-site-layout': DialogSiteLayout,
        'dialog-pdr' : DialogPdr,
        // 'dialog-electrical-request' : DialogElectricalRequest,
        'dialog-elevation-request' : DialogElevationRequest,
        'dialog-stop' : DialogStop,
        'dialog-shio-request' : DialogShioRequest,
        'dialog-boss-list' : DialogBossList,
        'dialog-new-site-layout' : DialogNewSiteLayout,
        'dialog-boss-schedule' : DialogBossSchedule,
        'dialog-denki-request' : DialogDenkiRequest,
        'app-snackbar': Snackbar,
        'app-loader' : Loader,
        'home-view' : Home,
    },

    data(){
        return {
            envDB: process.env.MIX_DB_DATABASE,
            registeredBossCode: [],
            presentDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            loading: false,
            editColor : null,
            forProposal : null,
            closeMain : true,
            newExpressPlan: false,
            disableExpress: false,
            disableOtherExpress: false,
            disableReform: false,
            disableOtherSelections: false,
            register: false,
            bossTrial: true,
            // getRadioValue : [],
            userTimezone: null,
            copyFunction: false,
            homeView: false,
            fileColor : '',
            loader: false,
            cmLoader: false,
            overlay : false,
            saveStatus : null,
            editIndex : null,
            // editMode : false,
            activeBtn : '',
            btnSelection : '',
            isDragging: false,
            cursorPos: [0, 0],
            el: null,
            colorPers:false,
            housePresentation : false,

            verticalHeaders: [
                {header: 'CAD依頼送信者', subheaders: ''},
                {header: '図面番号', subheaders: ''},
                {header: '設計受託契約', subheaders: ''},
                {header: '最高高さ・見付面積・平均GL計算根拠', subheaders: ''},
                {header: 'カラー配置図', subheaders: ['配置図が必要な場合該当欄に○']},
                {header: 'スペック依頼', subheaders: ['全窓指示の時に○', '新規CAD依頼（手書き図面依頼）のみ使用','ハニカム指示の時に○ ','※GRAND SMART・i-smartはマスA選択不可']},
                {header: 'DXFデータ依頼', subheaders: ['配置図・立面図・平面図データ', '配置図作成後で上限2回まで依頼可']},
                {header: 'カラーパース', subheaders: ['依頼書添付 ：○', '仕様書通り：視点方向記入', '※着手準備後は仕様書に準ずる']},
                {header: 'ハウス プレゼンテーション', subheaders: ['依頼書添付/仕様書通り：〇', '※着手準備後は仕様書に準ずる']},
                {header: 'インテリアパース【トライアル】', subheaders: ['※枠組(iCAD)のみ依頼可能']},
                // {header: 'インテリアパース ', subheaders: ['※枠組(iCAD)のみ依頼可能']},
                // {header: 'インテリアパース依頼 (INT) ', subheaders: ['※枠組(iCAD)のみ依頼可能']},
                {header: '仕様検討ツール', subheaders: []},
                {header: 'WEB打ち合わせ用提案資料', subheaders: []},
                {header: 'カラー配置図 (測定点入)', subheaders: ['現況図・測定点位置図作成・', '仕様検討ツール作成後に依頼']},
                {header: 'ALVS検討依頼', subheaders: ['敷地調査報告書（写し）アップが条件', 'L:採光のみV:換気のみS:排煙のみ']},
                {header: '構造事前検討依頼', subheaders: ['区画図添付が必要 依頼時には等級指示', 'W：風 S：積雪']},
                // {header: '提案電気図面依頼', subheaders: ['原則間取り確定後１回だけ依頼可能']}, REMOVE NA
                // {header: '電気図面依頼', subheaders: ['あり：HRDで更新', 'なし：修正依頼必要']}, PAPALTAN
                {header: '電気図面依頼（提案電気図面依頼含む）', subheaders: ['※提案電気図面依頼は原則1回だけ依頼可能', '※電気図面依頼', 'あり：HRDで更新', 'なし：修正依頼必要']},
                {header: '断面図/申請用立面図依頼', subheaders: ['※枠組(iCAD)のみ依頼可能','両書類共、１回のみ依頼可能']},
                // {header: '断面図/申請用立面図依頼', subheaders: ['S:断面図 E：申請用立面図（共に上限1回）']},
                {header: 'STOP', subheaders: ['着手準備以前に１回だけ依頼可能', '施工連絡表・区画図添付が必要']},
                {header: '着手準備', subheaders: ['積算チェック依頼は①or②を記載']},
                {header: '即日依頼', subheaders: ['着手準備依頼以降のみ対応可能']},
                {header: '依頼書添付', subheaders: []},
                {header: 'actions', subheaders: []},
            ],

            siteLayouts: [ '新規データN', '前回ベースP', '手入力M' ], //NOTE : if ' 新規データ ' is selected need to attach DXF or JWW or DWG
            // siteLayouts: [ '新規データ', '前回ベース', '手入力' ], //NOTE : if ' 新規データ ' is selected need to attach DXF or JWW or DWG
            // sashTypes: [ 'J', 'F', 'Y' ],
            specs: [  'あり', 'なし' ],
            accessories: [  'マスA', '網戸' ],
            honeycomb: [ '断', '遮', 'レ', '断/遮'],

            siteLayoutAttachmentRequired: false,
            dataCount: 1,
            showMenu: false,
            tempCadRequest: {},
            toggleB5: null,
            toggleB6_1: null,
            toggleB6_2: null,
            toggleB6_3: [],
            toggleB6_4: null,
            
            editToggleB5: null,
            editToggleB6_1: null,
            editToggleB6_2: null,
            editToggleB6_3: [],
            editToggleB6_4: null,
            
            hrdProcessToggleB5: null,
            hrdProcessToggleB6_1: null,
            hrdProcessToggleB6_2: null,
            hrdProcessToggleB6_3: [],
            hrdProcessToggleB6_4: null,

		    dialogRevision: false,
            dialogColorPerspective: false,
            dialogHousePresentation: false,
            dialogHousePresentationInt: false,
            revision: null,
            dialogWebDocuments: false,
            dialogConfirmationItems: false,
            dialogAlvs: false,
            dialogStructuralRequest: false,
            dialogElectricalDrawing: false,
            dialogDrawingRequest: false,
            dialogAttachmentForm: false,
            dialogPreviousAttachmentForm: false,
            dialogSiteLayout: false,
            dialogPdr: false,
            // dialogElectricalRequest: false,
            dialogElevation : false,
            dialogStop: false,
            dialogNewSiteLayout: false,
            dialogBossSchedule: false,
            dialogShioRequest: false,
            dialogBossList: false,
            dialogDenkiRequest: false,

            // MISC

            isHighlighted: false,
            snackbar:{
                    text: '',
                    show: false,
            },

            files: [],
            mergedFilename : null,
            pathName : null,
            countPage: 0,
            countPageCadPira: 0,
            countPageCadPiraUpdate: 0,
            countPageUpdate: 0,
            bossSchedBtn : false,

            // BOSS CODE REGISTRATION AND UPLOADING
            env: {
				response : process.env.MIX_ENV == 'local' ? 'response-local' : 'response',
				request : process.env.MIX_ENV == 'local' ? 'request-local' : 'request',
			},
            plannerDetails: null,
            salesmanDetails: null,
            houseTypeFromSocket: null,
            dataFromCi: null,
            powerId: null,
            registerIndex: null,
            updateStatus: null,
            HRDID: null,
            hrdAcceptAfterEdit: false,
            newCadRequest: {},
            editBoss: [],
            xmlv3Id: null,
            boss_data:{
                HRD_ID: null,
                code_number: null,
                plan_number: null,
                shio_no: null,
                denki_no: null,
                plan_type_name: null,
                boss_code: null,
                hrdProcess: null,
                icad_plan: null,
                action_req: null,
                received_day: null,
                bracket_name: null,
                original_due_day: null,
                due_day: null,
                bundle: null,
                bundle_date: null,
                bundle_schedule: null,
                finish_day: null,
                cademaildate: null,
                cad_bundle: null,
                cad_bundle_date: null,
                cad_bundle_schedule: null,
                sender: null,
                doc_arrangement: null,
                remarks: null,
                pers_hp_code: null,
                house_type: null,
                created_at: null,
                date_updated: null,
                Department: null,
                Section: null,
                Team: null,
                shiyousho_receive: null,
                sekisan_receive: null,
                kurosu_receive: null,
                sqc_receive: null,
                fp: null,
                updated_at: null,
                updated_by: null,
                updated_by_code: null,
                updated_ip: null,
                change_at: null,
                change_by: null,
                change_ip: null,
                deleted_by: null,
                deleted_ip: null,
                deleted: null,
            },
            dataToDelete: [],
            deleteIndex: null,
            plannerIndex: null,

            jibanPlan : null,
            stopPlan : null,
            kakoStopPlan : null,
            XmlData : [],
            attachCadTrap : null,
            attachSiteTrap : null,
            attachStructuralTrap : null,
            attachDenkiTrap : null,
            masterTable : null,
            getPrevData : null,

            dialogStop2: false,
            stop2_selection: null,
        }
    },

    computed:{
        disabledSelectedShio() {
            // if (!this.$store.state.editMode) {
            //     console.log(this.$store.state.cadRequestRevisionContent.shio_selection, 'new')
            // } else {
            //     console.log(this.$store.state.editCadRequestRevisionContent.shio_selection, 'edit')
            // }

            if (this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '0' || !this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection) {
                return true;
            }

            return false;
        },

        ...mapState([
            'loggedInUser',
            'cadRequestData',
            'cadRequestLatestRevision',
            'cadRequestRevisionContent',
            'cadRequestTempRevisionContent',
            'cadRequestBasicInformation',
            'existingRevisions',
            'actualButton',
			'draftButton',
			'deleteButton',
            'cadRequestColorPers',
            'hideColorPersTable',
            'cad_request_house_presentation',
            'cad_request_house_presentation_int',
            'hideHpTable',
            'attachments',
            'editCadRequestRevisionContent',
            'cadRequestPdr',
            'intRadio',
            'beforeEditColorPers',
            'editCadRequestColorPers',
            'editMode',
            'beforeEditHP',
            'edit_cad_request_house_presentation',
            'edit_cad_request_house_presentation_int',
            'edit_webDocs',
            'structural_request',
            'electrical_request',
            'section_drawing',
            'editFinalPlan',
            'disableSelections',
            'disableApplyNextCad',
            'previousAttachmentFiles',
            'hrd_process_stamp',
            'SASH_TYPE',
            'SASH_ACCESSORIES',
            'editRevision',
            'hrdprocessMode',
            'storeRequestContents',
            'rePdfData',
            'copyPreviousAttachment',
            'additionalAtachments',
            'exisitngColorPers',
            'bossCode',
            'revisionSelection',
            'HOUSE_TYPES',
            'STOP_LIST',
            'structOrStop',
            'bossScheduleData',
            'alvsSelection',
            'forRegistration',
            'mainDialog',
            'sched_header',
            'bundle_sched ',
            'gravityBoss',
            'COLOR_PERS_OBJ_NAME',
            'HP_OBJ_NAME',
            'PH6Planners'
        ]),

        today(){
        //    return  new Date().toISOString().replace('-', '/').split('T')[0].replace('-', '/');
            const date = new Date();
            const formattedDate = (date.getMonth() + 1) + "/" + date.getDate()
            return formattedDate;
        }
    },
    sockets: {
        // NOTE : SOCKET 
        updateReceived: async function(socket) {
            this.plannerDetails = null;
            this.salesmanDetails = null;
            this.houseTypeFromSocket = null;
            this.dataFromCi = null;
            this.powerId = null;
            // if(this.$route.path == '/main'){
                if(socket && socket.dispatchType == this.env.response && socket.functionType == 'sendToBossDynamic' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                        console.log(socket, this.$route.path, 'sendToBossDynamic')
                    // if(socket.data.status != 'DELETE'){
                        if(socket.data.sentDataStat){
                            await updateBossCadRequest(socket.data.sentDataStat, socket.data.receivedData, this.updateStatus);
                            Swal.fire({
                                icon: 'success',
                                title: `Plan deleted successfully!`,
                            }).then(() => {
                            })
                            await this.getCadActualData();
                            this.loader = false;
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title: `Uploading to boss failed.`,
                                text: 'Kindly reupload data.',
                            }).then(async () => {
                                await removeHrdAccept(socket.data.receivedData);
                                await this.getCadActualData();
                                this.loader = false;
                            })

                        }
                        
                    // }
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'final_result' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    this.$store.state.finalPlanSiyo = socket.data.outputData.fpFlg
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'sendToBossDynamicRes' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                        this.registeredBossCode = socket.data.registeredData
                        this.Logger('info', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.registeredBossCode[0].customerCode} ${this.registeredBossCode[0].planNumber} ${JSON.stringify(this.registeredBossCode[0].registeredData)}) Registered data to boss`, 1);

                        if(socket.data.sentDataStat){
                            await updateBossCadRequest(socket.data.sentDataStat, socket.data.receivedData, this.updateStatus);
                            if(this.updateStatus != 'DELETE' && !this.isNewExpress){
                                console.log(this.register, 'this.register socket')

                                if(this.register) await this.saveToLocal();
                                else{
                                    Swal.fire({
                                        icon: 'success',
                                        title: `Successfully uploaded to boss`,
                                    }).then(() => {
                                        
                                    })
                                }
                            }else{
                                if(!this.isNewExpress){
                                    await this.deleteToLocal();
                                    Swal.fire({
                                        icon: 'success',
                                        title: `Plan deleted successfully!`,
                                    }).then(() => {
                                    })
                                }
                            }
                            await this.getCadActualData();
                            this.loader = false;
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title: `Uploading to boss failed.`,
                                text: 'Kindly reupload data.',
                            }).then(async () => {
                                await removeHrdAccept(socket.data.receivedData);
                                await this.getCadActualData();
                                this.loader = false;
                            })
                        }
                        
                    // }
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'srsLatestResponse' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    if(socket.data.outputData){
                        if(this.$store.state.editMode) this.$store.state.editCadRequestRevisionContent.SRS_request.shio_number = socket.data.outputData.shio_no
                        else this.$store.state.cadRequestRevisionContent.SRS_request.shio_number = socket.data.outputData.shio_no
                    }
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'bossScheduleResponse' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    await this.sendToBackend(socket.data);
                    this.plannerDetails = socket.data.plannerDetails;
                    this.salesmanDetails = socket.data.salesmanDetails;
                    this.houseTypeFromSocket = socket.data.houseType;
                    this.dataFromCi = socket.data.CIdata;
                    this.powerId = socket.data.power;
                    this.$store.state.sched_header = socket.data.outputData.bracket_name;
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'bossScheduleSavingResponse' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    // ? SAVE BRACKET TO CAD_REQUESTS DATABASE
                        axios({
                            method: 'post',
                            url: 'api/saveBracketToCad',
                            data: {
                                sched: socket.data.outputData,
                                cad: socket.data.latestData
                            }
                        }).then(({data}) => {
                            // if(data.revision_type == '10') {
                            //     this.getCadActualData();
                            // }
                            // this.getCadActualData();
                        })
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'saveToLocalResponse' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    // ? CHECK IF THE SAVING TO LOCAL IS SUCCESS
                        if(socket.data.result.xmlcad_v3_id || socket.data.result.xmlcad_v3_id == null){
                            Swal.fire({
                                icon: 'success',
                                title: `Successfully uploaded to boss`,
                            }).then(async () => {
                                try {
                                    await axios({
                                        method: "POST",
                                        url: "api/update_xml_cad",
                                        data: {
                                            xmlv3_id : socket.data.result.xmlcad_v3_id,
                                            local_status: true,
                                            cad: socket.data.latest,
                                        }
                                    })
                                    await this.getCadActualData();
                                    this.loader = false;
                                } catch (error) {
                                    await removeHrdAccept(socket.data.latest);
                                    await this.getCadActualData();
                                    this.loader = false;
                                }
                            })
                        }else{
                    // ? ELSE IF SAVING FAILED, REMOVE HRD ACCEPT
                            Swal.fire({
                                icon: 'error',
                                title: `Uploading to XRS failed. Kindly reupload data.`,
                                text: socket.data.result,
                            }).then(async () => {
                                await removeHrdAccept(socket.data.latest);
                                await this.getCadActualData();
                                this.loader = false;
                            })
                        }
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'deleteLocalResponse' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    // ? CHECK IF THE DELETING TO LOCAL IS SUCCESS
                        if(socket.data.result){
                            Swal.fire({
                                icon: 'success',
                                title: `Plan deleted successfully!`,
                            }).then(() => {
                                this.getCadActualData();
                                this.loader = false;
                            })
                        }else{
                    // ? ELSE IF DELETING FAILED, REMOVE HRD ACCEPT
                            Swal.fire({
                                icon: 'error',
                                title: `Deleting to XRS failed. Kindly reupload data.`,
                                text: socket.data.result,
                            }).then(async () => {
                                await this.getCadActualData();
                                this.loader = false;
                            })
                        }
                } else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'cadMasterTableV2' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    // EDIT BUTTON FOR PLANNER WITH RESTRICTIONS
                    this.masterTable = socket.data.cadMaster[0]
                    const timeString = this.getPrevData.time; // GET THE TIME
                    const timeFormat = 'HH:mm'; // WHAT THE TIME FORMAT WANTS TO BE
                    const originalTime = moment(timeString, timeFormat); // THE OUTCOME OF TIME FORMAT
                    const createdAtString = this.getPrevData.created_at; // GET THE CREATED_AT
                    const createdAtFormat = 'MM/DD'; // WHAT THE CREATED_AT FORMAT WANTS TO BE
                    const originalCreatedAt = moment(createdAtString, createdAtFormat)
                    const currentTime = moment();
                    //  !currentTime.isAfter(originalTime.clone().add(1, 'hours')) OLD
                    if((this.masterTable && this.masterTable.status == 'Unstarted' || this.masterTable == null || this.masterTable == undefined) && (this.getPrevData.gravity == 1 || this.getPrevData.gravity == 2 || this.getPrevData.gravity == 3)){
                        this.$store.state.editMode = true;
                        this.openBasicInfo();
                        this.cmLoader = false;
                    } 
                    // else if(this.masterTable && this.masterTable.status == 'Unstarted' && (this.getPrevData.gravity == 1 || this.getPrevData.gravity == 2 || this.getPrevData.gravity == 3) && 
                    //     (currentTime.isSame(originalCreatedAt, 'day') && currentTime.isAfter(originalTime.clone().add(1, 'hours'))) || !currentTime.isSame(originalCreatedAt, 'day')){
                    //     Swal.fire({
                    //         html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                    //             'CAD依頼は編集できません。<br>' +
                    //             'すでに HRD で処理中です。以下を検討してください。<br><br><br>' +
                    //             '<span style="color:blue;">CAD図面の変更がない場合、「CAD図面番号の変更なし」 にて再依頼。</span><br>' +
                    //             '<span style="color:blue;">CAD図面の変更がある場合、「新しい図面番号」にて再依頼。。</span>',
                    //         icon: 'warning',
                    //         width : 830,
                    //         allowOutsideClick: false,
                    //         allowEscapeKey: false,
                    //     });
                    //     this.cmLoader = false;
                    //     return
                    // } 
                    else if(this.masterTable && this.masterTable.status != 'Unstarted' && (this.getPrevData.gravity == 1 || this.getPrevData.gravity == 2 || this.getPrevData.gravity == 3)){
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                                'CAD依頼は編集できません。<br>' +
                                'すでに HRD で処理中です。以下を検討してください。<br><br><br>' +
                                '<span style="color:blue;">CAD図面の変更がない場合、「CAD図面番号の変更なし」 にて再依頼。</span><br>' +
                                '<span style="color:blue;">CAD図面の変更がある場合、「新しい図面番号」にて再依頼。</span>',
                            icon: 'warning',
                            width : 830,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        this.cmLoader = false;
                        return
                    } else if((this.masterTable == null || this.masterTable == undefined || this.masterTable != null) && this.getPrevData.gravity == 0 && (currentTime.isSame(originalCreatedAt, 'day') && !currentTime.isAfter(originalTime.clone().add(1, 'hours')))){
                        this.$store.state.editMode = true;
                        await this.openBasicInfo();
                        this.cmLoader = false;
                    }else if((this.masterTable == null || this.masterTable == undefined || this.masterTable != null) && this.getPrevData.gravity == 0 && 
                        (currentTime.isSame(originalCreatedAt, 'day') && currentTime.isAfter(originalTime.clone().add(1, 'hours'))) || !currentTime.isSame(originalCreatedAt, 'day')){
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                                'CAD依頼は編集できません。<br>' +
                                'すでに HRD で処理中です。以下を検討してください。<br><br><br>' +
                                '<span style="color:blue;">CAD図面の変更がない場合、「CAD図面番号の変更なし」 にて再依頼。</span><br>' +
                                '<span style="color:blue;">CAD図面の変更がある場合、「新しい図面番号」にて再依頼。</span>',
                            icon: 'warning',
                            width : 830,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        this.cmLoader = false;
                        return
                    } else if(this.masterTable == null || this.masterTable == undefined) {
                        this.$store.state.editMode = true;
                        await this.openBasicInfo();
                        this.cmLoader = false;
                    }
                } else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'cancelCadMasterTableV2' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    // CANCEL BUTTON FOR PLANNER WITH RESTRICTIONS
                    this.masterTable = socket.data.cancelCadMaster[0]
                    const timeString = this.deleteIndex.time; // GET THE TIME
                    const timeFormat = 'HH:mm'; // WHAT THE TIME FORMAT WANTS TO BE
                    const originalTime = moment(timeString, timeFormat); // THE OUTCOME OF TIME FORMAT
                    const createdAtString = this.deleteIndex.created_at; // GET THE CREATED_AT
                    const createdAtFormat = 'MM/DD'; // WHAT THE CREATED_AT FORMAT WANTS TO BE
                    const originalCreatedAt = moment(createdAtString, createdAtFormat)
                    const currentTime = moment();
                    //  !currentTime.isAfter(originalTime.clone().add(1, 'hours')) OLD
                    if((this.masterTable && this.masterTable.status == 'Unstarted' || this.masterTable == null || this.masterTable == undefined) && (this.deleteIndex.gravity == 1 || this.deleteIndex.gravity == 2 || this.deleteIndex.gravity == 3) ){ // SML if unstarted
                        this.cmLoader = false;
                        this.cancelRequest(this.plannerIndex);
                    } 
                    // else if(this.masterTable && this.masterTable.status == 'Unstarted' && (this.deleteIndex.gravity == 1 || this.deleteIndex.gravity == 2 || this.deleteIndex.gravity == 3) && 
                    //     (currentTime.isSame(originalCreatedAt, 'day') && currentTime.isAfter(originalTime.clone().add(1, 'hours'))) || !currentTime.isSame(originalCreatedAt, 'day')){ // SML
                    //     Swal.fire({
                    //         html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                    //             'CAD依頼はキャンセルできません。<br>' +
                    //             'すでに HRD で処理中です。以下を検討してください。<br><br><br>' +
                    //             '<span style="color:blue;">CAD図面の変更がない場合、「CAD図面番号の変更なし」 にて再依頼。</span><br>' +
                    //             '<span style="color:blue;">CAD図面の変更がある場合、「新しい図面番号」にて再依頼。。</span>',
                    //         icon: 'warning',
                    //         width : 830, 
                    //         allowOutsideClick: false,
                    //         allowEscapeKey: false,
                    //     });
                    //     this.cmLoader = false;
                    //     return
                    // }
                     else if(this.masterTable && this.masterTable.status != 'Unstarted' && (this.deleteIndex.gravity == 1 || this.deleteIndex.gravity == 2 || this.deleteIndex.gravity == 3)){ // NOT EQUAL TO UNSTARTED
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                                'CAD依頼はキャンセルできません。<br>' +
                                'すでに HRD で処理中です。以下を検討してください。<br><br><br>' +
                                '<span style="color:blue;">CAD図面の変更がない場合、「CAD図面番号の変更なし」 にて再依頼。</span><br>' +
                                '<span style="color:blue;">CAD図面の変更がある場合、「新しい図面番号」にて再依頼。</span>',
                            icon: 'warning',
                            width : 830, 
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        this.cmLoader = false;
                        return
                    } else if((this.masterTable == null || this.masterTable == undefined || this.masterTable != null) && this.deleteIndex.gravity == 0 && (currentTime.isSame(originalCreatedAt, 'day') && !currentTime.isAfter(originalTime.clone().add(1, 'hours')))){ // Gravity NC, less than 1 hour
                        this.cmLoader = false;
                        this.cancelRequest(this.plannerIndex);
                    } else if((this.masterTable == null || this.masterTable == undefined || this.masterTable != null) && this.deleteIndex.gravity == 0 && 
                        (currentTime.isSame(originalCreatedAt, 'day') && currentTime.isAfter(originalTime.clone().add(1, 'hours'))) || !currentTime.isSame(originalCreatedAt, 'day')){ // NC more than 1 hour
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                                'CAD依頼はキャンセルできません。<br>' +
                                'すでに HRD で処理中です。以下を検討してください。<br><br><br>' +
                                '<span style="color:blue;">CAD図面の変更がない場合、「CAD図面番号の変更なし」 にて再依頼。</span><br>' +
                                '<span style="color:blue;">CAD図面の変更がある場合、「新しい図面番号」にて再依頼。</span>',
                            icon: 'warning',
                            width : 830,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        this.cmLoader = false;
                        return
                    } else if(this.masterTable == null || this.masterTable == undefined) {
                        // console.log('walang laman bitch')
                        this.cmLoader = false;
                        this.cancelRequest(this.plannerIndex);
                    }
                } else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'xmlBundleV2' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                    this.$store.state.xmlTable = socket.data.xmlBundleData
                } 
            }
        // }
    },

    methods: {
        ...mapActions([
            '_getSashType',
            '_getSashAccessories',
            '_getHpRestrictionPerHouseType',
            '_getHpObjName',
            '_getColorPersRestriction',
            '_getColorPersObjName',
            '_getPlanner'
        ]),
    /*  ================================================================================================= 
            NOTE : FOR AUTO REGISTRATION, 
                Lagay niyo lang sa saveCadRequest() yung hrdAcceptFunction() and need niyo lang
                ilagay sa parameter yung mga needed data. Lalo na yung index. Para sa index, possible
                naman na kuning niyo nalang yung pinakalast na record after saving.

            NOTE : NEED ASYNC AWAIT,
                Kasi need muna matapos yung isang function bago yung susunod na function dahil nandon yung data na need nya
                hindi pwedeng sabay sabay yung function kasi mag error at hahanapin yung data na yun.
        =================================================================================================  */

        //NOTE - FUNCTION FOR CRS LOGS
        Logger(severity, user, component, data, isfrontend){
            try{
                let tmpVersion = ' #' + this.$store.state.cadRequestVersion.version;
                if(process.env.MIX_ALLOW_LOGS == 'false') return;
                axios.post('api/log', {'severity':severity, 'component':component, 'data':data + tmpVersion, 'user':user, 'isfrontend':isfrontend});
            }catch(e){
                alert('cannot log error')
                console.log(e)
            }
        },

        isJapanese(name) {
            const japaneseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
            return japaneseRegex.test(name);
        },


        // NOTE : GET LATEST REGISTER
        // getXmlAllData(){
        //     axios({
        //         method: "POST",
        //         url: "api/get_xml_bundle",
        //         data: {
        //             customerCode: this.$store.state.cadRequestBasicInformation.construction_code,
        //             loggedUser : this.loggedInUser,
        //         }
        //     }).then(({data}) => {
        //         if(data){
        //             this.XmlData = data.map((r) => {
        //                 r.created_at = moment(r.created_at).format('YYYY-MM-DD HH:mm:ss')
        //                 return r;
        //             })
        //         }
        //     })
        // },

        // NOTE : FOR CANCEL OF SRS BOSS SENDDATA ACTUAL
        async cancelSrsBossActual(shioData){
            const constructionCode = shioData.customer_code; // replace with actual construction code from latestData
            const revisionNumber = shioData.revision_number; // replace with actual revision number from latestData
            const shioCode = shioData.SRS_data; // replace with actual shio code
            const url = `https://srs.hrd-s.com/api/checkPlanIfExist?construction_code=${constructionCode}&plan_no=${revisionNumber}`;
            try {
                const response = await fetch(url);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                if(data.length !== 0){
                    const headers = {
                    'SRS-Key': process.env.MIX_SRS_API_KEY,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                    };

                    // const srsCancelRes = await axios.post(`http://10.169.141.136:4000/update-srs-sent-status`, {
                    // const srsCancelRes = await axios.post(`https://srs-test.ihs-w.com/api/update-srs-sent-status`, {
                    const srsCancelRes = await axios.post(`https://srs.hrd-s.com/api/update-srs-sent-status`, {
                        "construction_code": constructionCode,
                        "plan_no": revisionNumber,
                        "shio_no": shioCode,
                        "plan_status_code" : 0
                    },{ headers: headers });

                    if(srsCancelRes.status === 200){
                        const planLogsRes = await axios.post( `https://srs.hrd-s.com/api/update-sent-to-hrd-and-boss`, 
                        {
                            construction_code: constructionCode,
                            plan_no: revisionNumber,
                            shio_no: shioCode,
                            is_hrd_available : 0,
                            is_boss_available: 0,
                            deleted_at: moment().format('YYYY-MM-DD HH:mm:ss') // Using moment.js
                        }, { headers: headers });

                        if(planLogsRes.status === 200){
                            this.Logger('info', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${constructionCode} ${revisionNumber}) SRS data successfully cancelled in BOSS`, 1);
                            let tmpCRSObj = {
                                dispatchType: 'response',
                                functionType: 'SRSCancel',
                                constructionCode: constructionCode,
                                planNumber: revisionNumber,
                                shiyoNumber: shioCode,
                                email: this.$store.state.loggedInUser.email,
                                remarks: 'cancel boss and hrd data'
                            };
                                this.$socket.emit("newUpdate", tmpCRSObj);
                        }else{
                            this.Logger('error', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) Failed to cancel SRS data in BOSS`, 1);
                        }
                    }
                } else{
                    this.Logger('info', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${constructionCode} ${revisionNumber}) No SRS data to delete.`, 1);
                }

                
            } catch (error) {
                this.Logger('error', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) Failed to cancel`, 1);
                console.error("Error during SRS cancellation process:", error);
            }
                
        },

        // NOTE : FOR CANCEL OF SRS BOSS SENDDATA LOCAL
        async cancelSrsBossLocal(shioData){
            try {
                this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        uniqId: this.loggedInUser.uniqId,
                        allData : shioData,
                        date: this.presentDate
                    },
                    functionType: 'SRSCancel'
                });
            } catch (error) {
                console.log(error, 'socket error')
            }
        },

    // NOTE : CAD MASTER TABLE V2 DATA
        async cadMasterTable(data){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        uniqId: this.loggedInUser.uniqId,
                        cadData : data
                    },
                    functionType: 'cad_master_table'
                });
            } catch (error) {
                console.log(error, 'socket error')
            }
        },

        // NOTE - SRS DATA SEND TO BOSS - UARY
        async sendSrsToBoss(){
            const constructionCode = this.$store.state.cadRequestBasicInformation.customer_code;
            const revisionNumber = this.cadRequestRevisionContent.revision; 
            const shiyoNumber = this.$store.state.cadRequestRevisionContent.SRS_request.shio_number;
            console.log(this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection, 'sample')
            if(this.$store.state.cadRequestRevisionContent.shio_request){
                if(this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "1") {
                    try{
                        
                    
                        // const srsCancelRes = await axios.post(`http://10.169.141.136:4000/api/update-srs-sent-status`, {
                        // const srsCancelRes = await axios.post(`https://srs-test.ihs-w.com/api/update-srs-sent-status`, {
                        const srsCancelRes = await axios.post(`https://srs.hrd-s.com/api/update-srs-sent-status`, {
                            "construction_code": constructionCode,
                            "plan_no": revisionNumber,
                            "shio_no": shiyoNumber, //replace with shio code actual
                            "plan_status_code": 1 //fixed static
                        })

                        //For local, need to emit to trigger existing SRS function for sending BOss with PDF 
                        // if(srsCancelRes.status >= 200 && srsCancelRes.status < 300){
                        if (srsCancelRes.data.message === "Failed to update, plan do not exists.") {
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                                    'SRS data not yet available.<br>' +
                                    'Please create.<br><br>',
                                icon: 'warning',
                                width : 630,
                            });
                            return;
                        } else if (srsCancelRes.status === 200) {
                            let tmpCRSObj = {
                                dispatchType: 'request',
                                functionType: 'SRSSend',
                                constructionCode: constructionCode,
                                planNumber: revisionNumber,
                                shiyoNumber: shiyoNumber,
                                remarks: 'send boss and hrd data'
                            };
                            this.$socket.emit("newUpdate", tmpCRSObj);
                        }
                    } catch (error) {
                        console.error("API call failed:", error);
                    }
                }
            }
        },

        // NOTE : FOR CANCEL CAD MASTER
        async cancelCadMasterTable(data){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        uniqId: this.loggedInUser.uniqId,
                        cadData : data
                    },
                    functionType: 'cancel_cad_master_table'
                });
            } catch (error) {
                console.log(error, 'socket error')
            }
        },

    // NOTE : XML BUNDLE TABLE V2 DATA FOR FINAL PLAN
        // moved in dialogrevision
        // async xmlBundleTable(data){
        //     try {
        //         await this.$socket.emit('newUpdate', {
        //             dispatchType: this.env.request,
        //             data: {
        //                 uniqId: this.loggedInUser.uniqId,
        //                 xmlBundleData : data
        //             },
        //             functionType: 'xml_bundle_table'
        //         });
        //     } catch (error) {
        //         console.log(error, 'socket error')
        //     }
        // },

    // NOTE : DELETE LOCAL DATA
        async deleteToLocal(){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        saveData: this.dataToDelete,
                        uniqId: this.loggedInUser.uniqId,
                        latest : this.deleteIndex,
                        xmlv3Id : this.xmlv3Id,
                    },
                    functionType: 'delete_to_local'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }
        },
    // NOTE : SAVE TO HRDAPPS49(xml_bundle_schedule_v2)
        async saveToLocal(){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        saveData: this.sendToLocal,
                        uniqId: this.loggedInUser.uniqId,
                        latest: this.existingRevisions[this.registerIndex],
                        register_date : this.$store.state.registerDate,
                    },
                    functionType: 'save_to_local'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }
        },
    // NOTE : GET SCHEDULE AFTER SAVING
        async getScheduleAfterSave(data){
            try {
                await this.$socket.emit('newUpdate', {
                dispatchType: this.env.request,
                data: {
                    date: data.created_date,
                    latestData: data,
                    basic_info: this.$store.state.cadRequestBasicInformation,
                    uniqId: this.loggedInUser.uniqId
                },
                functionType: 'boss_schedule_for_saving'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }
        },
    // NOTE : SRS CONNECTION
    // NOTE - MODIFIED NOV242025
       async openSRS() {
            let responseData = null; // Stays local, initialized to null
            let key = process.env.MIX_API_KEY;
            const randomNum = Math.random() * 9000;
            const formattedRandomNum = Math.floor(randomNum);
            
            const srsUrl = `https://srs.hrd-s.com/acceptredirect/${this.loggedInUser.email}/${this.loggedInUser.name}/${this.cadRequestBasicInformation.customer_code}/${
                this.editMode ? this.editCadRequestRevisionContent.revision_number : this.cadRequestRevisionContent.revision
            }/${this.cadRequestBasicInformation.house_type_id}/${key}/${formattedRandomNum}`;

            window.open(srsUrl, 'blank');

            const pollingUrl = `https://srs.hrd-s.com/api/srs-interface-planinfo/${formattedRandomNum}`;
            
            do {
                await new Promise(r => setTimeout(r, 300));
                try {
                    const response = await axios.get(pollingUrl);
                    if (response.data) {
                        responseData = response.data; 
            
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_number = responseData.shio_no;
               
                    }
                } catch (err) {
                    console.warn('Polling failed, retrying...', err.message);
                }
            } while (!responseData)
            console.log('Polling successful! Final data:', responseData);
        },
    // NOTE : BOSS REGISTRATION AND UPLOADING FUNCTIONS
        async openDialogForRegistration(data, ii, reg){
            this.$store.state.getBossiCad = data
            this.$store.state.previousIcad = this.existingRevisions[ii-1] ? this.existingRevisions[ii-1] : null;
            this.loader = true;
            this.register = reg
            this.registerIndex = ii;
            
            const registeringRevision = this.existingRevisions[this.registerIndex];
            const matchedPlanner = this.PH6Planners.find(planner => {
                return Number(planner.iduser) === Number(registeringRevision?.created_by);
            });  

            this.$store.state.ph6User = matchedPlanner ? true : false;
            
            // this.$store.state.forHouseCategory = data.house_type_category;
            this.$store.state.revisionBossList = data.revision_number,
            this.$store.state.gravityBoss = {
                gravity : this.existingRevisions[ii].gravity,
                gravity_type : this.existingRevisions[ii].gravity_type,
                revision_number : this.existingRevisions[ii].revision_number,
                revision_type: this.existingRevisions[ii].revision_type
            }
            const created_date = this.formatDateTime(data.whole_date);
            // SOCKET FOR GETTING SCHEDULE IN HRDAPPS49
            try {
                await this.$socket.emit('newUpdate', {
                dispatchType: this.env.request,
                data: {
                    date: created_date,
                    basic_info : this.$store.state.cadRequestBasicInformation,
                    latestData: data,
                    uniqId: this.loggedInUser.uniqId
                },
                functionType: 'boss_schedule'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }

            // try {
            //     axios({
            //         method: "POST",
            //         url: "api/getBossData",
            //         data: {
            //             boss : bossCodes,
            //             json : json,
            //             zumen : zumenMulti,
            //             createdDate : created_date,
            //             latestData : data,
            //             basic : this.$store.state.cadRequestBasicInformation,
                        
            //         }
            //     }).then(async ({data}) => {
            //         if(data){
            //             this.$store.state.forRegistration = data.map((res) => {
            //                 const tempParts = [];

            //                 if (res.plan_type_name) {
            //                     tempParts.push(res.plan_type_name);
            //                 }

            //                 if (res.boss_code) {
            //                     tempParts.push(res.boss_code);
            //                 }

            //                 res.temp = tempParts.length > 0 ? tempParts.join(' (') + ')' : '';
            //                 res.due_day = res.due_day ? moment(res.due_day).format('YYYY-MM-DD HH:mm') : null;
            //                 res.checkBox = true;
            //                 return res;
            //             })
            //             this.toggleBossListDialog(true);
            //             this.loader = false;
            //         }
            //     })
            // } catch (error) {
            //     alert(error)
            // }

        },
    // NOTE : SEND THE DATA TO BACKET FOR GATHERING OF OTHER DETAILS FOR BOSS CODES
        async sendToBackend(data){
            this.$store.state.forHouseCategory = data.latestData.house_type_category;
            let tempArr = data.latestData
            this.$store.state.bundle_sched = data.isHoliday;
            this.loader = true;
            let bossCodes = await getAllBossCode(
                this.$store.state.revisionSelection,
                this.$store.state.cadRequestBasicInformation,
                tempArr,
                this.$store.state.previousIcad,
                this.$store.state.ph6User,
            );
            const json = await json_remarks(
                this.$store.state.cadRequestBasicInformation,
                tempArr,
                data,
                bossCodes
            );
            const created_date = this.formatDateTime(tempArr.whole_date);
            let zumenMulti = await getZumenTypeMultiple(bossCodes);
            
            if(tempArr.hrd_accept == 1){
                bossCodes = bossCodes.filter((r) => {
                    if(r.boss_code != '357'){
                        return r
                    }
                    return false;
                })
            }
            // return;
            try {
                axios({
                    method: "POST",
                    url: "api/getBossData",
                    data: {
                        boss : bossCodes,
                        json : json,
                        zumen : zumenMulti,
                        createdDate : created_date,
                        latestData : tempArr,
                        basic : this.$store.state.cadRequestBasicInformation,
                        schedule: data.outputData,
                        isHoliday: data.isHoliday,
                        user: this.loggedInUser,
                    }
                }).then(async ({data}) => {
                    
                    if(!data){
                        Swal.fire({
                            icon: "error",
                            title: data,
                        });
                        this.loader = false;
                        return false;
                    }else{
                        this.newExpressPlan = data.isNewExpress;
                        if(data.mergedData){
                            if(this.register){
                                this.$store.state.forRegistration = data.mergedData.map((res) => {
                                    const tempParts = [];
    
                                    if (res.plan_type_name) {
                                        tempParts.push(res.plan_type_name);
                                    }

                                    if (res.boss_code) {
                                        // if(tempArr.isBossChecked == 1) res.boss_code = res.boss_code + 'NB';
                                        tempParts.push(res.boss_code);
                                    }
                                    res.temp = tempParts.length > 0 ? tempParts.join(' (') + ')' : '';
                                    res.due_day = res.due_day ? moment(res.due_day).format('YYYY-MM-DD HH:mm') : null;
                                    res.checkBox = true;
                                    return res;
                                })
                                
                                this.toggleBossListDialog(true);
                                this.loader = false;
                            }else{
                                this.$store.state.forRegistration = data.mergedData.filter((res) => {
                                    if(res.boss_code == '357'){
                                        const tempParts = [];

                                        if (res.plan_type_name) {
                                            tempParts.push(res.plan_type_name);
                                        }

                                        if (res.boss_code) {
                                            // if(tempArr.isBossChecked == 1) res.boss_code = res.boss_code + 'NB';
                                            tempParts.push(res.boss_code);
                                        }

                                        res.temp = tempParts.length > 0 ? tempParts.join(' (') + ')' : '';
                                        res.due_day = res.due_day ? moment(res.due_day).format('YYYY-MM-DD HH:mm') : null;
                                        res.checkBox = true;
                                        return res;
                                    }
                                    return false;
                                })
                                this.confirmBoss(this.$store.state.forRegistration);
                            }
                        }

                    }

                })
            } catch (error) {
                alert(error)
            }
        },
    // NOTE : FOR CHECKING IF FINAL PLAN
        finalPlanSiyo(customerCode){
            try {
                this.$socket.emit('newUpdate', {
                dispatchType: this.env.request,
                data: {
                    customerCode: customerCode,
                    uniqId: this.loggedInUser.uniqId
                },
                functionType: 'final_plan'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }
        },

        addOneHour(received_day){
            // Assuming newdata.received_day contains the date you want to manipulate
            const originalDate = moment(received_day);

            // Add 1 hour to the original date
            const newDate = originalDate.add(1, 'hours');

            // Format the new date as 'YYYY/MM/DD HH:mm:ss'
            const formattedDate = newDate.format('YYYY/MM/DD HH:mm:ss');
            return formattedDate;
        },
    // NOTE : FUNCTION FOR CALLING THE SOCKET USED TO SEND THE DATA TO BOSS
        async triggerSocketBossSending(newdata, status){
            let sendToBossData = [];
            await newdata.forEach(element => {
                if (element.boss_code != '' && element.boss_code != null && 
                    element.boss_code != 'SITE' && element.boss_code != 'SITEM' && 
                    element.boss_code != 'HPSP' && element.boss_code != 'PD9' && element.boss_code != '128' && 
                    element.boss_code != 'S89' && element.boss_code != 'ZEH' && element.boss_code != 'GXS') {
                        let due_day = null;
                        // if(element.boss_code == '202'){
                        //     due_day = element.due_day_boss ? moment(element.due_day_boss).format('YYYY/MM/DD HH:mm:ss') : '';
                        // }else{
                        due_day = element.due_day ? moment(element.due_day).format('YYYY/MM/DD HH:mm:ss') : '';
                        // }
                    let data = {
                        hrdId: element.HRD_ID,
                        customerCode: element.code_number,
                        planType: element.boss_code,
                        receivedDay: element.received_day,
                        planNumber: element.plan_number,
                        finishPlanDay: due_day,
                        finishedDay: "",
                        remarks: element.remarks,
                        plannerCode: "",
                        file: element.file,
                        action: status,
                        cad_id: element.id
                    }
                    sendToBossData.push(data);
                }
            });
            // Try-catch block outside the forEach loop
            try {
                await this.$socket.emit('newUpdate', {
                dispatchType: this.env.request,
                data: {
                    bossdata: sendToBossData,
                    uniqId: this.loggedInUser.uniqId
                },
                functionType: 'sendToBossDynamic'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }
        },

    // ****************************************************************** //
    //                  Saving on XML table for SRS                       //
    // ****************************************************************** //

    // NOTE : GATHER ALL DATA then save (ONCE HRD ACCEPTED)
        formatDateTime(dateParam) {
            const date = new Date(dateParam);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        async saveToXmlTable(data, index){
            const bossCodes = await getAllBossCode(
                this.$store.state.revisionSelection,
                this.$store.state.cadRequestBasicInformation,
                data,
                this.$store.state.ph6User,
            );
            let zumenMulti = [];

            const json = await json_remarks(
                this.$store.state.cadRequestBasicInformation,
                data
            );


            if (bossCodes) {
                zumenMulti = await getZumenTypeMultiple(bossCodes);
            }

            const created_date = this.formatDateTime(data.created_at);

            if (this.editBoss && this.updateStatus === "EDIT") {
                await this.triggerSocketBossSending(this.editBoss, 'DELETE');
            }
            try {
                axios({
                    method: "POST",
                    url: "api/getBossData",
                    data: {
                        boss : bossCodes,
                        json : json,
                        zumen : zumenMulti,
                        createdDate : created_date,
                        latestData : data,
                        basic : this.$store.state.cadRequestBasicInformation,
                    }
                }).then(async ({data}) => {
                    if(data){
                        // this.toggleBossListDialog(true);
                        let savedData = await saveToXML(data);
                        if(savedData) await this.hrdAcceptFunction(index)
                    }
                })
            } catch (error) {
                alert(error)
            }
        },

        getDayOfWeek(dateString) {
            const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            const date = new Date(dateString);
            return daysOfWeek[date.getDay()];
        },

        async saveToXmlTable_357(data){
            let bossCodes = [
                        {
                            boss_code : '357',
                            boss_remarks : null,
                            pers_hp_code : null,
                            doc_arrangement : 'CADRequestForm', // CADRequestForm
                            sched_for : '357_',
                        }
            ]
            let created_date = moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')
            if(this.editBoss && this.updateStatus == "EDIT"){
                await this.triggerSocketBossSending(this.editBoss, 'DELETE')
            }
            try {
                let bossPromise = bossCodes.map(async (boss) => {
                    let zumen = {};
                    // let revision_type = null;
                    let plan_status = null;
                    // GET BRACKET AND SCHEDULE

                    // NOTE : boss code sendings
                    boss.HRD_ID = generateHRDID(boss.boss_code);


                    // CONDITION FOR FINAL PLAN
                        if(data.final_plan == '1'){
                            boss.fp = '003'
                        }else if(data.final_plan == '2'){
                            boss.fp = '001'
                        }else if(data.final_plan == '3'){
                            boss.fp = '002'
                        }else{
                            boss.fp = null
                        }

                        let rem = null;
                        if(data.hrdProcess == 1){
                            rem = 'HRDミスの訂正';
                        }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason != '' && this.$store.state.cadRequestBasicInformation.kakouirai_reason != null){
                            if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 1){
                                rem = '追加変更（TH)';
                            }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 2){
                                rem = '加工ストップ後追加変更申請で対応（TH)';
                            }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 3){
                                rem = '加工ストップ後再加工依頼で対応 (RE-ORDER)';
                            }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 4){
                                rem = '長期物件・再加工依頼（RE-ORDER)';
                            }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 5){
                                rem = '参考プラン作成（OTHERS）';
                            }
                        }else{
                            rem = null;
                        }

                        if(rem){
                            if(boss.boss_remarks){
                                boss.cad_remarks = `${boss.cad_remarks} / ${boss.boss_remarks}`
                            }else{
                                boss.cad_remarks = rem
                            }
                        }else{
                            boss.cad_remarks = boss.boss_remarks;
                        }

                        // BUNDLE SCHED
                        if(boss.boss_code != '357'){
                            let bundleSchedule = await getBundleSchedule(created_date);
                            let day = null;
                            let hr = null;
                            if(bundleSchedule){
                                // Given date and time
                                let orig_day = moment(created_date).format('YYYY-MM-DD HH:mm:ss');
                                if(boss.sched_for){
                                    day = boss.sched_for + 'day';
                                    hr = boss.sched_for + 'hr';
                                // Find the next Saturday
                                    while (moment(orig_day).format('ddd') !== bundleSchedule[day]) {
                                        orig_day = moment(orig_day).add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                                    }
                                    boss.bracket_name = bundleSchedule.bracket_name
                                    boss.original_due_day = moment(orig_day).format(`YYYY-MM-DD ${bundleSchedule[hr]}:00:00`); // CAD_DAY
                                    boss.due_day = boss.original_due_day;
                                }else{
                                    boss.bracket_name = null;
                                    boss.original_due_day = null;
                                    boss.due_day = null;
                                }

                            }
                        }else if(boss.boss_code == '357'){
                            boss.bracket_name = null;
                            boss.original_due_day = null;
                            boss.due_day = null;

                        }

                        
                    // CONDITION FOR PLAN STATUS
                    if(this.$store.state.cadRequestBasicInformation.expected_house_raising_date != null){
                        boss.plan_status = 'Already Kakouirai';
                    }else{
                        boss.plan_status = 'Before Kakouirai'
                    }
                    // NOTE : GATHER Master Zumen type (by boss code)
                        if(boss.boss_code){
                            zumen = await getZumenType(boss.boss_code);
                            if(zumen){
                                boss.plan_type_name = zumen.zumentype_name;
                                boss.boss_code = zumen.zumentype_id;
                            }
                        }else{
                            boss.plan_type_name = null;
                            boss.boss_code = null;
                        }
                            boss.request_type = data.request_type;
                            boss.cad_request_id = data.id;
                            boss.code_number = data.customer_code;
                            boss.plan_number = data.revision_number;
                            boss.shio_no = null;
                            boss.denki_no = null;
                            boss.hrdProcess = data.hrd_process ? data.hrd_process : null;
                            boss.icad_plan = 0;
                            boss.action_req = 'ADD';
                            boss.received_day = created_date;
                            boss.bundle = null;
                            boss.bundle_date = null;
                            boss.bundle_schedule = null;
                            boss.finish_day = null;
                            boss.cademaildate = null;
                            boss.cad_bundle = null;
                            boss.cad_bundle_date = null;
                            boss.cad_bundle_schedule = null;
                            boss.sender = data.hrd_accepted_user_id;
                            // boss.doc_arrangement = '357';
                            boss.remarks = null;
                            // boss.pers_hp_code = null;
                            boss.house_type = data.house_type_name;
                            boss.created_at = created_date;
                            boss.date_updated = created_date;
                            boss.Department = null;
                            boss.Section = null;
                            boss.Team = null;
                            boss.shiyousho_receive = null;
                            boss.sekisan_receive = null;
                            boss.kurosu_receive = null;
                            boss.sqc_receive = null;
                            boss.updated_at = data.updated_at ? moment(data.updated_at).format('YYYY-MM-DD HH:mm:ss') : null;
                            boss.updated_by = null;
                            boss.updated_by_code = null;
                            boss.updated_ip = null;
                            boss.change_at = null;
                            boss.change_by = null;
                            boss.change_ip = null;
                            boss.deleted_by = null;
                            boss.deleted_ip = null;
                            boss.deleted = null;
                            boss.cad_remarks = boss.boss_remarks;
                            return boss
                });
                let resolvedBoss = await Promise.all(bossPromise);
                await saveToXML(resolvedBoss);
            } catch (error) {
                alert(error);
            }


        },
  
    // ****************************************************************** //
    //                  UPDATING on XML table for SRS                       //
    // ****************************************************************** //

    // NOTE : if plan is edited
        async updateXMLTable(latestData, shioData){
            let dataToUpdate = latestData;
            if(this.updateStatus == "EDIT"){
                await updateXML(dataToUpdate, this.updateStatus).then(async (res) => {
                    this.editBoss = res.xml_bundle_arr;
                        if(this.loggedInUser.id == 1 || this.loggedInUser.id == 2 || this.loggedInUser.id == 15){
                            await this.saveToXmlTable(latestData)
                        }else{
                            await this.saveToXmlTable_357(latestData)
                        }
                    // await this.saveToXmlTable(latestData)

                })
            }else{
                
                // CONDITION FOR FINAL PLAN
                    if(latestData.final_plan == '1'){
                        dataToUpdate.final_plan = '003'
                    }else if(latestData.final_plan == '2'){
                        dataToUpdate.final_plan = '001'
                    }else if(latestData.final_plan == '3'){
                        dataToUpdate.final_plan = '002'
                    }else{
                        dataToUpdate.final_plan = null
                    }
                    
                // CONDITION FOR REVISION/REQUEST TYPE
                    if(latestData.revision_type == '1'){
                        dataToUpdate.revision_type = '新規(A)';
                    }else{
                        if(latestData.revision_type == '5'){
                            if(latestData.gravity_type == '5Z'){
                                dataToUpdate.revision_type = '新規(A)';
                            }
                        }else if(latestData.revision_type == '7'){
                            if(latestData.gravity_type == '5Cad'){
                                dataToUpdate.revision_type = '新規(A)';
                            }
                        }else{
                            // if(latestData.kakouirai_reason == 1 || latestData.kakouirai_reason == 2){
                            if(latestData.kakouirai_reason == 1 ){
                                dataToUpdate.revision_type = '追変(TH)';
                            } else if(latestData.kakouirai_reason == 2 || latestData.kakouirai_reason == 3  || latestData.kakouirai_reason == 4 || latestData.kakouirai_reason == 5 ){
                                if(latestData.revision_type == '5'){
                                    if(latestData.gravity_type == '5Z'){
                                        dataToUpdate.revision_type = '新規(A)';
                                    } else {
                                        dataToUpdate.revision_type = '変更(C)';
                                    }
                                }
                            } else{
                                dataToUpdate.revision_type = '変更(C)';
                            }

                        }
                    }
                
                // CONDITION FOR PLAN STATUS
                    if(this.$store.state.cadRequestBasicInformation.expected_house_raising_date){
                        dataToUpdate.plan_status = 'Already Kakouirai';
                    }else{
                        dataToUpdate.plan_status = 'Before Kakouirai'
                    }

                dataToUpdate.hrd_accepted_at =  moment(latestData.hrd_accepted_at).format('YYYY-MM-DD HH:mm:ss')
                dataToUpdate.updated_at =  moment(latestData.updated_at).format('YYYY-MM-DD HH:mm:ss')
                dataToUpdate.deleted_at = latestData.deleted_at ? moment(latestData.deleted_at).format('YYYY-MM-DD HH:mm:ss') : null;
                let sendToBossData = await updateXML(dataToUpdate, this.updateStatus);


                // NOTE - NEW CONDITION FOR DELETE STATUS
                if(this.updateStatus == 'DELETE'){
                    this.dataToDelete = sendToBossData.xml_bundle_arr;
                    this.xmlv3Id = sendToBossData.xmlv3;
                    this.cancelSrsBossActual(shioData);
                    this.cancelSrsBossLocal(shioData);
                    this.Logger('info', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${dataToUpdate.revision_number}) Data successfully deleted`, 1);
                }

                if(sendToBossData){
                    let cad_file = null;
                    let timezone = null;
                    if(sendToBossData.cad){
                        timezone = sendToBossData.cad.timezone;
                        sendToBossData.cad.attachments.filter((r) => {
                            if(r.att_column_name == 'CAD依頼書結合ファイル'){
                                cad_file = r.path;
                                return;
                            }
                        })
                    }
                    if(sendToBossData.xml_bundle_arr){
                        let newdata = []
                        sendToBossData.xml_bundle_arr.filter((res) => {
                            // ? GET 357 FILE
                            if(res.boss_code == '357'){
                                res.file = cad_file;
                            }else{
                                res.file = null;
                            }
                            // ? BOSS REMARKS
                            res.remarks = res.cad_remarks;

                            if(timezone == 'Asia/Singapore'){
                                res.received_day = this.addOneHour(res.received_day)
                            }else{
                                res.received_day = moment(res.received_day).format('YYYY/MM/DD HH:mm:ss')
                            }

                            res.finish_day = res.finish_day ? moment(res.finish_day).format('YYYY/MM/DD HH:mm:ss') : '',
                            res.plannerCode = "";
                            newdata.push(res)
                        })

                        if(this.updateStatus == 'HRD Accept'){
                            let tempdata = []
                            newdata.filter((res) => {
                                if(res.boss_code == '357'){
                                    tempdata.push(res)
                                }
                            })
                            newdata = tempdata;
                        }

                        // ? SEND DATA TO BOSS
                        if(latestData.isBossChecked == 1) {
                            await this.saveToLocal();
                        }
                        else await this.triggerSocketBossSending(newdata, this.updateStatus);
                        console.log(newdata, 'trigger')
                    }
                }
                
            }
        },

    // END OF BOSS REGISTER AND UPLOADING FUNCTIONS

    // NOTE : SAVING, UPDATING AND MERGING OF PDF FORMS AND CAD DATA
        copyPrevious(){

            // 確認
            // 前回の依内容頼をコピーしますか
            this.copyFunction = true;
            let previous = this.existingRevisions[this.existingRevisions.length - 1];
            // this.$store.state.cadRequestLatestRevision = previous.revision_number;
            this.$store.state.cadRequestRevisionContent = {...previous}
            this.$store.state.alvsSelection = previous.alvs
            this.$store.state.cadRequestRevisionContent.status = null;
            // this.$store.state.cadRequestRevisionContent.SRS_request = null; // for Confirmation

            //COMMENTED BY UARY - AUGUST 27, 2026
            // this.$store.state.cadRequestRevisionContent.SRS_request = {
            //                                                             shio_selection: null,
            //                                                             shio_number: null,
            //                                                         }
            // this.$store.state.cadRequestRevisionContent.shio_request = null; // for Confirmation+

            if (previous.srs_shio) {
                this.$store.state.cadRequestRevisionContent.SRS_request = { ...previous.srs_shio };
            } else {
                this.$store.state.cadRequestRevisionContent.SRS_request = {
                    shio_selection: null,
                    shio_number: null
                };
            }
            if (previous.shio_request) {
                this.$store.state.cadRequestRevisionContent.shio_request = typeof previous.shio_request === 'object' 
                    ? { ...previous.shio_request } 
                    : previous.shio_request;
            } else {
                this.$store.state.cadRequestRevisionContent.shio_request = null;
            }

            this.$store.state.cadRequestRevisionContent.isBossChecked = this.$store.state.isBossChecked;
            this.$store.state.cadRequestRevisionContent.express = null;
            this.$store.state.cadRequestRevisionContent.revision = this.$store.state.cadRequestLatestRevision;
            if(this.$store.state.hrdprocessMode) this.$store.state.cadRequestRevisionContent.hrd_process = 1;
            this.$store.state.cadRequestRevisionContent.revision_type = this.$store.state.getRadio;
            
            // FOR RESTRICTION IN EXPRESS
            if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                this.cadRequestRevisionContent.alvs || this.cadRequestRevisionContent.stop){
                    this.disableExpress = true;
            }else{
                this.disableExpress = false
            }
            // END OF RESTRICTION

            this.$store.state.cadRequestRevisionContent.cross_section = previous.cross_section
            this.$store.state.cadRequestRevisionContent.elevation_section = previous.elevation_section

            if(previous.stop_list.length > 0 && previous.stop_list != []){
                this.$store.state.cadRequestRevisionContent.stopListSelection = previous.stop_list.filter((res) => {
                                                                                        res.option1 = res.OPTION_1;
                                                                                        res.option2 = res.OPTION_2;
                                                                                        res.isChecked = res.isChecked;
                                                                                        res.selected = res.SELECTED;
                                                                                        res.category = res.category;
                                                                                        res.rowCount = res.rowCount;
                                                                                        return res;
                                                                                    })  
            }else{
                this.$store.state.cadRequestRevisionContent.stopListSelection = null
            }
            this.$store.state.attachments = [];
            this.$store.state.structural_request = {
                                            OPTION_ZEH : previous.SR_OPTION_ZEH,
                                            OPTION_GX : previous.SR_OPTION_GX,
                                            OPTION_1 : previous.SR_OPTION_1,
                                            OPTION_2 : previous.SR_OPTION_2,
                                            OPTION_W : previous.SR_OPTION_W,
                                            OPTION_S : previous.SR_OPTION_S,
                                        }
            this.$store.state.cadRequestRevisionContent.structural_request = this.$store.state.structural_request;
            this.$store.state.cadRequestRevisionContent.denki_gravity = previous.denki_plan_gravity
            let ed = []
            if(previous.ED_ELECTRICAL_REQUEST){
                ed = previous.ED_ELECTRICAL_REQUEST.split(', ');
            }

            if(previous.ED_DENKI_PLAN_TITLE == null && previous.ED_OPTION_1 == null){
                this.$store.state.electrical_request = {
                                                            pdr_title : null,
                                                            radioPdr : null,
                                                            denki_plan_title : null,
                                                            OPTION_1 : null,
                                                            OPTION_2 : null,
                                                            radioGravity : null,
                                                            selectedDrawing : [],
                                                        };
                this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            }
            
            if(previous.ED_DENKI_PLAN_TITLE != null && previous.ED_OPTION_1 != null && previous.ED_OPTION_2 != null){
                this.$store.state.electrical_request = {
                                                            pdr_title : null,
                                                            radioPdr : null,
                                                            denki_plan_title : previous.ED_DENKI_PLAN_TITLE,
                                                            OPTION_1 : previous.ED_OPTION_1,
                                                            OPTION_2 : previous.ED_OPTION_2,
                                                            radioGravity : previous.ED_DENKI_PLAN_GRAVITY,
                                                            selectedDrawing : ed,
                                                        };
                this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            } 

            if(previous.ED_DENKI_PLAN_TITLE != null && previous.ED_OPTION_1 && previous.ED_ELECTRICAL_REQUEST == null) {
                this.$store.state.electrical_request = {
                                                            pdr_title : null,
                                                            radioPdr : null,
                                                            denki_plan_title : previous.ED_DENKI_PLAN_TITLE,
                                                            OPTION_1 : previous.ED_OPTION_1,
                                                            OPTION_2 : previous.ED_OPTION_2,
                                                            radioGravity : previous.ED_DENKI_PLAN_GRAVITY,
                                                            selectedDrawing : [],
                                                        };
                this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            }

            if(previous.ED_PDR_TITLE != null && previous.ED_DENKI_PLAN_1 != 'なし') {
                this.$store.state.electrical_request = {
                                                            pdr_title : previous.ED_PDR_TITLE,
                                                            radioPdr : previous.ED_DENKI_PLAN_1,
                                                            denki_plan_title : null,
                                                            OPTION_1 : null,
                                                            OPTION_2 : null,
                                                            radioGravity : null,
                                                            selectedDrawing : ed,
                                                        };
                this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            }

            // if(previous.ED_PDR_TITLE != null && previous.ED_DENKI_PLAN_1 != null) {
            //     this.$store.state.electrical_request = {
            //                                                 pdr_title : previous.ED_PDR_TITLE,
            //                                                 radioPdr : previous.ED_DENKI_PLAN_1,
            //                                                 denki_plan_title : null,
            //                                                 OPTION_1 : '',
            //                                                 OPTION_2 : '',
            //                                                 radioGravity : '',
            //                                                 selectedDrawing : [],
            //                                             };
            //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            // }

            // if(previous.ED_DENKI_PLAN_TITLE != null && previous.ED_DENKI_PLAN_GRAVITY != null) {
            //     if(previous.ED_OPTION_1 == '' && previous.ED_OPTION_2 == ''){
            //         this.$store.state.electrical_request = {
            //                                                     pdr_title : null,
            //                                                     denki_plan_title : previous.ED_DENKI_PLAN_TITLE,
            //                                                     radioPdr: previous.ED_DENKI_PLAN_1,
            //                                                     OPTION_1 : '',
            //                                                     OPTION_2 : '',
            //                                                     radioGravity: previous.ED_DENKI_PLAN_GRAVITY,
            //                                                     selectedDrawing: ed,        
            //                                                 };
            //         this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            //     }

                // if(previous.ED_OPTION_1 == "あり" && previous.ED_OPTION_2 == "なし"){
                //     this.$store.state.electrical_request = {
                //                                                 radioPdr: previous.ED_DENKI_PLAN_1,
                //                                                 OPTION_1 : 'あり',
                //                                                 OPTION_2 : 'あり',
                //                                                 radioGravity: previous.ED_DENKI_PLAN_GRAVITY,
                //                                                 selectedDrawing: ed,        
                //                                             };
                //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                // } else if(previous.ED_OPTION_1 == "あり" && previous.ED_OPTION_2 == "あり") {
                //     this.$store.state.electrical_request = {
                //                                                 radioPdr: previous.ED_DENKI_PLAN_1,
                //                                                 OPTION_1 : 'あり',
                //                                                 OPTION_2 : 'あり',
                //                                                 radioGravity: previous.ED_DENKI_PLAN_GRAVITY,
                //                                                 selectedDrawing: ed,        
                //                                             };
                //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                // }
            // }

            // if(previous.ED_OPTION_1 == '' && previous.ED_OPTION_2 == ''){
            //     this.$store.state.electrical_request = {
            //                                                 radioPdr: previous.ED_DENKI_PLAN_1,
            //                                                 OPTION_1 : '',
            //                                                 OPTION_2 : '',
            //                                                 radioGravity: previous.ED_DENKI_PLAN_GRAVITY,
            //                                                 selectedDrawing: ed,        
            //                                             };
            //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            // }
            
            // if(previous.ED_OPTION_1 == "あり" && previous.ED_OPTION_2 == "なし"){
            //     this.$store.state.electrical_request = {
            //                                                 radioPdr: previous.ED_DENKI_PLAN_1,
            //                                                 OPTION_1 : 'あり',
            //                                                 OPTION_2 : 'あり',
            //                                                 radioGravity: previous.ED_DENKI_PLAN_GRAVITY,
            //                                                 selectedDrawing: ed,        
            //                                             };
            //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            // } else if(previous.ED_OPTION_1 == "あり" && previous.ED_OPTION_2 == "あり") {
            //     this.$store.state.electrical_request = {
            //                                                 radioPdr: previous.ED_DENKI_PLAN_1,
            //                                                 OPTION_1 : 'あり',
            //                                                 OPTION_2 : 'あり',
            //                                                 radioGravity: previous.ED_DENKI_PLAN_GRAVITY,
            //                                                 selectedDrawing: ed,        
            //                                             };
            //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            // }

            if(!previous.specs_irai){
                this.$store.state.cadRequestRevisionContent.specs_irai = { 
                    sash_type: null,  
                    specs: null,  
                    accessories: [],
                    honeycomb: null,  
                };
            }else{
                // this.cadRequestRevisionContent.specs_irai = {...previous.specs_irai}
                // this.toggleB6_1 = this.cadRequestRevisionContent.specs_irai ? this.cadRequestRevisionContent.specs_irai.sash_type : null; 
                // this.toggleB6_2 = this.cadRequestRevisionContent.specs_irai ? this.cadRequestRevisionContent.specs_irai.specs : null; 
                // this.toggleB6_3 = this.cadRequestRevisionContent.specs_irai.accessories.filter(r => {
                //                         return this.accessories.includes(r.value);
                //                     }).map(r => r.value);

                let specs = {       
                    sash_type: null,  
                    specs: null,  
                    accessories: [],
                    honeycomb: null,
                } 
                this.$store.state.cadRequestRevisionContent.specs_irai = previous.specs_irai == null ? specs : {...previous.specs_irai};

                this.toggleB6_1 = this.$store.state.cadRequestRevisionContent.specs_irai.sash_type;
                this.toggleB6_2 = this.$store.state.cadRequestRevisionContent.specs_irai.specs;
                if(previous.specs_irai){
                    this.$store.state.cadRequestRevisionContent.specs_irai.accessories = previous.specs_irai.accessories.map((r) => {
                        return r.value;
                    });
                }

                this.toggleB6_3 = this.$store.state.cadRequestRevisionContent.specs_irai.accessories
                this.toggleB6_4 = this.$store.state.cadRequestRevisionContent.specs_irai.honeycomb
            }

            // if(previous.shio_request == 1){
            //     this.$store.state.cadRequestRevisionContent.shio_request = 1;
            // }
            if(
                previous.final_plan == '2' || 
                previous.final_plan == '3'
            ){
                this.$store.state.cadRequestRevisionContent.final_plan = '1';
                this.$store.state.editFinalPlan = '1';
            }

            this.$store.state.cad_request_house_presentation = previous.hp ? previous.hp : null
            this.$store.state.cadRequestRevisionContent.house_presentation_int = previous.house_presentation_int;
            // this.$store.state.cad_request_house_presentation_int = previous.hp_int ? previous.hp_int : null

            if(previous.color_perspective){
                this.$store.state.cadRequestColorPers = []
                if(previous.color_perspective.length > 0){
                    previous.color_perspective.forEach(element => {
                        let color = {
                            is_request_color_info: element.is_request_color_info,
                            roof: {
                                    roofing_material: null,
                                    roof_color: element.roof != null ? element.roof : null,
                                },
                            spray_1f: {
                                exteriorRequestContent: element.spray_1f != null ? element.spray_1f : null,
                                },
                            spray_2f: {
                                exteriorRequestContent: element.spray_2f != null ? element.spray_2f : null,
                                },
                            spray_3f: {
                                exteriorRequestContent: element.spray_3f != null ? element.spray_3f : null,
                                },
                            exterior_wall_tile : {
                                color_construction: null,
                                exterior_wall_tile: element.exterior_wall_tile ? element.exterior_wall_tile : null,
                                accent_wall_color: element.accent_wall_color ? element.accent_wall_color : null,
                                },
                            external_wall_finish : element.external_wall_finish,
                            balcony_glass : element.balcony_glass,
                            design_louver : element.design_louver,
                            sash : element.sash,
                            front_door : {
                                    entrance_door_type: null,
                                    door_item: null,
                                    door_color: element.front_door ? element.front_door : null,
                                },
                            mall_and_arrowhead_decoration : element.mall_and_arrowhead_decoration,
                            balcony_belt : element.balcony_belt,
                            tile_band : element.tile_band,
                            decorative_belt_1f : element.decorative_belt_1f,
                            decorative_belt_2f : element.decorative_belt_2f,
                            eaves_of_a_house : element.eaves_of_a_house,
                            eaves_gutter : element.eaves_gutter,
                            breaking_wind : element.breaking_wind,
                            base_draining : element.base_draining,
                            porch_tile : {
                                porch_tile_item: null,
                                porch_tile_item_color: element.porch_tile ? element.porch_tile : null,
                            },
                            perspective_direction : element.perspective_direction,
                            viewpoint_height : element.viewpoint_height,
                            garden_number : element.garden_number,
                        }
                        this.$store.state.cadRequestColorPers.push(color)
                    });
                }
            }

            // if(previous.hp){
            //     if(previous.hp.length > 0){
            //         previous.hp.forEach(element => {
            //             let hp = {
            //                 is_request_color_info: element.is_request_color_info,
            //                 roof: {
            //                         roofing_material: null,
            //                         roof_color: element.roof ? element.roof : null,
            //                     },
            //                 spray_1f: {
            //                     exteriorRequestContent: element.spray_1f != null ? element.spray_1f : null,
            //                     },
            //                 spray_2f: {
            //                     exteriorRequestContent: element.spray_2f != null ? element.spray_2f : null,
            //                     },
            //                 spray_3f: {
            //                     exteriorRequestContent: element.spray_3f != null ? element.spray_3f : null,
            //                     },
            //                 exterior_wall_tile : {
            //                     color_construction: null,
            //                     exterior_wall_tile_color: element.exterior_wall_tile ? element.exterior_wall_tile : null,
            //                     accent_wall_color: element.accent_wall_color ? element.accent_wall_color : null,
            //                     },
            //                 balcony_glass : element.balcony_glass,
            //                 design_louver : element.design_louver,
            //                 sash : element.sash,
            //                 front_door : {
            //                         entrance_door_type: null,
            //                         door_item: null,
            //                         door_color: element.front_door ? element.front_door : null,
            //                     },
            //                 mall_and_arrowhead_decoration : element.mall_and_arrowhead_decoration,
            //                 balcony_belt : element.balcony_belt,
            //                 tile_band : element.tile_band,
            //                 decorative_belt_1f : element.decorative_belt_1f,
            //                 decorative_belt_2f : element.decorative_belt_2f,
            //                 eaves_of_a_house : element.eaves_of_a_house,
            //                 breaking_wind : element.breaking_wind,
            //                 base_draining : element.base_draining,
            //                 porch_tile : {
            //                     porch_tile_item: null,
            //                     porch_tile_item_color: element.porch_tile ? element.porch_tile : null,
            //                 },
            //                 perspective_direction : element.perspective_direction,
            //                 viewpoint_height : element.viewpoint_height,
            //                 garden_number : element.garden_number,
            //             }
            //             this.$store.state.cad_request_house_presentation.push(hp)
            //         });
                
            //     }
            // }

            // console.log(this.$store.state.cadRequestColorPers, "do not del") // don't delete

            if(previous.color_pers != '0' && previous.color_pers != null){
                this.$store.state.hideColorPersTable = this.$store.state.cadRequestColorPers ? this.$store.state.cadRequestColorPers[0].is_request_color_info : null;
            }

            if(previous.house_presentation != '0' && previous.house_presentation != null){
                this.$store.state.hideHpTable = this.$store.state.cad_request_house_presentation ? this.$store.state.cad_request_house_presentation[0].is_request_color_info : null;
            }
        },

    // NOTE : MERGING OF FORM AND ATTACHMENTS IN FRONT-END
        updateMergedCadPiraFile(blobUrl, id){
            fetch(blobUrl)
                .then(response => response.blob())
                .then(blob => {
                    const file = new File([blob], 'merged.pdf');

                    // Create a FormData object and append the file
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('pathName', this.pathName);
                        formData.append('fileName', this.mergedFilename);
                        formData.append('id', id);
                        formData.append('pages', this.countPageCadPira);

                        axios({
                            method : "POST",
                            url : "api/update-merge-cadpira",
                            data : formData
                        }).then(async response => {
                            await this.getCadActualData();
                            this.loader = false;
                            await this.emptyEdit();
                        })
                    })
        },

        // async updateMerging(item){
        //     this.countPageUpdate = 0;
        //     let downloadUrl = null;
        //     let id = item.id;

        //     await axios({
        //         method : 'GET',
        //         url : `update_merge/${id}`,
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     }).then(async ({data}) => {
        //         return new Promise(async(resolve)=>{
        //             // create a new PDF document
        //             const mergedPdf = await PDFDocument.create();
        //             // loop through the PDFs and add each one to the merged document
        //             for (const pdf of data.fileBuffer) {
        //             // decode the base64-encoded PDF
        //                 if(pdf){
        //                     const pdfBytes = Buffer.from(pdf, 'base64');
        //                     // create a PDFDocument object from the bytes
        //                     const pdfDoc = await PDFDocument.load(pdfBytes);
        //                     // loop through each page in the PDF and add it to the merged document
        //                     const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
        //                         pages.forEach((page) => {
        //                             mergedPdf.addPage(page);
        //                             this.countPageUpdate += 1;
        //                         });
        //                     }
                    
        //                     // save the merged PDF to a file
        //                     const mergedPdfBytes = await mergedPdf.save();
        //                     // Create a Blob object with the merged PDF data
        //                     const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
        //                     // Create a download URL for the Blob
        //                     downloadUrl = URL.createObjectURL(blob);
        //                     resolve(mergedPdfBytes)
        //                 }
        //                     await this.saveUpdatedMergedFile(downloadUrl, id)
        //                     await this.updateMergeCadPira(data.cadPira,id);
        //         })
        //     })
        // },

    async updateMerging(item) {
    this.countPageUpdate = 0;
    let downloadUrl = null;
    let id = item.id;

    try {
        const response = await axios({
            method: 'GET',
            url: `update_merge/${id}`,
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = response.data;

        if (data && data.fileBuffer && data.fileBuffer.length > 0) {
            const mergedPdf = await PDFDocument.create();

            // 1. Loop through all PDFs and add them to the document completely
            for (const pdf of data.fileBuffer) {
                if (pdf) {
                    const pdfBytes = Buffer.from(pdf, 'base64');
                    const pdfDoc = await PDFDocument.load(pdfBytes);
                    const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                    
                    pages.forEach((page) => {
                        mergedPdf.addPage(page);
                        this.countPageUpdate += 1;
                    });
                }
            }

            // 2. Save AFTER the loop has fully finished
            const mergedPdfBytes = await mergedPdf.save();
            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
            downloadUrl = URL.createObjectURL(blob);

            // 3. Trigger the file saving and PIRA updates sequentially
            await this.saveUpdatedMergedFile(downloadUrl, id);
            
            if (data.cadPira) {
                await this.updateMergeCadPira(data.cadPira, id);
            }
        } else {
            console.log("No file buffers found to merge.");
        }
    } catch (error) {
        console.error("Error in updateMerging:", error);
    }
},

    // NOTE : THIS IS FOR MERGING CAD AND PIRA FORM ONLY
        updateMergeCadPira(data, id){
            this.countPageCadPira = 0;
            // let id = this.existingRevisions[index].id;
            let downloadUrl = null;
                return new Promise(async(resolve)=>{
                    // create a new PDF document
                    const mergedPdf = await PDFDocument.create();
                    if(data){
                        // loop through the PDFs and add each one to the merged document
                        for (const pdf of data) {
                        // decode the base64-encoded PDF
                            if(pdf){
                                const pdfBytes = Buffer.from(pdf, 'base64');
                                // create a PDFDocument object from the bytes
                                const pdfDoc = await PDFDocument.load(pdfBytes);
                                // loop through each page in the PDF and add it to the merged document
                                const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                    pages.forEach((page) => {
                                        mergedPdf.addPage(page);
                                        this.countPageCadPira += 1;
                                    });
                                }
                        
                                // save the merged PDF to a file
                                const mergedPdfBytes = await mergedPdf.save();
                                // Create a Blob object with the merged PDF data
                                const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                                // Create a download URL for the Blob
                                downloadUrl = URL.createObjectURL(blob);
                                resolve(mergedPdfBytes)
                            }
                                await this.updateMergedCadPiraFile(downloadUrl, id)
                                
                    }else{
                        console.log(data, "no data")
                    }
                })
        },
    // NOTE : SAVING OF UPDATED MERGED PDF
        saveUpdatedMergedFile(blobUrl, id){
            
            fetch(blobUrl)
                .then(response => response.blob())
                .then(blob => {
                    const file = new File([blob], 'merged.pdf');

                    // Create a FormData object and append the file
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('pathName', this.pathName);
                        formData.append('fileName', this.mergedFilename);
                        formData.append('id', id);
                        formData.append('pages', this.countPageUpdate);
                        formData.append('basic', JSON.stringify(this.$store.state.cadRequestBasicInformation))
                        formData.append('cad', JSON.stringify(this.$store.state.editCadRequestRevisionContent))

                        axios({
                            method : "POST",
                            url : "api/update-merge",
                            data : formData
                        }).then(async ({data}) => {
                            window.open(`open_file/${data.FileAttachment.id}`,"_blank");
                            await this.getCadActualData();
                        })
                    })
        },

        cancelNewPlan(){
            this.$store.state.cadRequestRevisionContent = {
                revision: null,
                design_contract: false,
                calculation_basis: false,
                site_layout: null,
                gravity_type: null,
                gravity : null,
                isHrdCpn: null,
                kakouirai_reason : null,
                site_layout_option: null,
                site_diagram: null,
                new_site_diagram: null,
                specs_irai: { 
                    sash_type: null,  
                    specs: null,  
                    accessories: [],
                    honeycomb: null,  
                },
                dxf_data_request: null,
                color_pers: null,
                house_presentation: null,
                house_presentation_int : null,
                shio_request: null,
                SRS_request: {
                    shio_selection: null,
                    shio_number: null,
                },
                web_documents: null,
                jiban_plan: null,
                alvs: null,
                status: null,
                structural_request: null,
                pdr: null,
                denki_gravity: null,
                // electrical_drawing: null,
                electrical_drawing: {
                    OPTION_1: null,
                    OPTION_2: null,
                    denki_plan_title: null,
                    radioGravity: null,
                    radioPdr: null,
                    selectedDrawing: [],
                },
                cross_section: null,
                elevation_section: null,
                stop: null,
                final_plan: null,
                express: null,
                request_attach_from: null,
                stopListSelection: null,
            };
            this.$refs.dialogElectricalDrawing.closetoggleDialogElectricalDrawing();
            this.$store.state.cadRequestColorPers = [];
            this.$store.state.cad_request_house_presentation = [];
            // this.$store.state.cad_request_house_presentation_int = [];
            this.$store.state.attachments = [];
            this.$store.state.hideColorPersTable = null;
            this.$store.state.hideHpTable = null;
            
            this.$store.state.cadRequestLatestRevision = null;
            this.toggleB5 = null;
            this.toggleB6_1 = null;
            this.toggleB6_2 = null;
            this.toggleB6_3 = [];
            this.toggleB6_4 = null;
            this.disableExpress = false;

            for(let i = 0; i < 10; i++){
                this.$store.state.getFileAttachment[i] = [];
            }

            this.$store.state.additionalAtachments = [];
            // this.getCadActualData();
        },

        cancelUpdate(){
            this.$store.state.editMode = false;
            this.$store.state.editCadRequestRevisionContent = {};
            this.getCadActualData();
            // this.$store.state.mainDialog = false; Kung gusto lang na bawat edit mag bubukas to.
            // this.$store.state.cadRequestColorPers = {};
            // this.$store.state.cad_request_house_presentation = {}

        },

        async updateCadRequest(){ 

            // RESTRICTION IF FINAL PLAN
            // if(this.editCadRequestRevisionContent.final_plan && (this.editCadRequestRevisionContent.color_pers == null || this.editCadRequestRevisionContent.house_presentation == null || this.editCadRequestRevisionContent.color_pers == 0 || this.editCadRequestRevisionContent.house_presentation == 0) ){
                // Swal.fire({
                //     html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                //         '着手図面依頼以降は、カラーパースでの色上方<br>' +
                //         'を指示しての依頼は対応不可となります。<br><br>',
                //     icon: 'warning',
                //     width : 630,
                // });
            //     this.$store.state.radio = null;
            //     return;
            // }
            // START OF RESTRICTION FOR ATTACHMENT
            // CASE 2 IF CAD AND DENKI WITHOUT ATTACHMENT
            if((this.$store.state.revisionSelection == '1' || this.$store.state.revisionSelection == '2' || this.$store.state.revisionSelection == '3' || this.$store.state.revisionSelection == '4' || (this.$store.state.revisionSelection == '5'
                && (this.$store.state.subRevision == '5A' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5C'))) && this.$store.state.getFileAttachment[0].length === 0  // CAD WITHOUT
                && (this.editCadRequestRevisionContent.electrical_drawing.pdr_title != null || (this.editCadRequestRevisionContent.electrical_drawing.denki_plan_title == '電気図面依頼' && this.editCadRequestRevisionContent.electrical_drawing.OPTION_1 == 'あり' && this.editCadRequestRevisionContent.electrical_drawing.OPTION_2 == 'なし')) // DENKI WITHOUT
                && ((this.$store.state.getFileAttachment[0].length === 0 && this.attachCadTrap == null) && (this.$store.state.getFileAttachment[5].length === 0 && this.attachDenkiTrap == null))){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                            '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br>' +
                            '<b style="font-size:22px;">【CAD/配置図(PDF/iCAD DBデータ)】</b><br>' +
                            '<b style="font-size:22px;">【電気図面/提案電気図面依頼書(PDF)】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                return;
            }
            // CASE 1 FOR FILE ATTACHMENT -> NEED TO ATTACH CAD
            if((this.$store.state.revisionSelection == '1' || this.$store.state.revisionSelection == '2' || this.$store.state.revisionSelection == '3' || this.$store.state.revisionSelection == '4' 
                // || (this.$store.state.editCadRequestRevisionContent.isHrdCpn != 1 && (this.$store.state.revisionSelection == '8' || this.$store.state.revisionSelection == '9')) // HRD PROCESS AND CPN
                || (this.$store.state.revisionSelection == '5' && (this.$store.state.subRevision == '5A' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5C'))) 
                && (this.$store.state.getFileAttachment[0].length === 0 && this.attachCadTrap == null)){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の下記項目に資料が添付がされておりません。 <br>' +
                            '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br>' +
                            '<b style="font-size:22px;">【CAD/配置図(PDF/iCAD DBデータ)】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    return;
            }

            // CASE 2 FOR FILE ATTACHMENT
            if((this.attachDenkiTrap == null && this.$store.state.getFileAttachment[5].length === 0) && this.editCadRequestRevisionContent.electrical_drawing && (this.editCadRequestRevisionContent.electrical_drawing.pdr_title != null 
                || (this.editCadRequestRevisionContent.electrical_drawing.denki_plan_title == '電気図面依頼' && this.editCadRequestRevisionContent.electrical_drawing.OPTION_1 == 'あり' && this.editCadRequestRevisionContent.electrical_drawing.OPTION_2 == 'なし'))){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                            '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br>' +
                            '<b style="font-size:22px;">【電気図面/提案電気図面依頼書(PDF)】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                return;
            }
            // CASE 3 WITH DENKI ATTACHMENT BUT WITHOUT REQUEST
            if(this.attachDenkiTrap != null && this.editCadRequestRevisionContent.electrical_drawing.pdr_title == null && this.editCadRequestRevisionContent.electrical_drawing.denki_plan_title == null){
                Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の【電気図面/提案電気図面依<br>' +
                            '(PDF)】に資料が添付がされておりますが<br>' +
                            'CAD依頼入力欄にて指示がされておりません。<br><br>' +
                            '<b style="font-size:22px;">【電気図面依頼(提案電気図面依頼含む)】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                return;
            } else if((this.attachDenkiTrap == null && this.$store.state.getFileAttachment[5].length > 0) && this.editCadRequestRevisionContent.electrical_drawing.pdr_title == null && this.editCadRequestRevisionContent.electrical_drawing.denki_plan_title == null){
                Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の【電気図面/提案電気図面依<br>' +
                            '(PDF)】に資料が添付がされておりますが<br>' +
                            'CAD依頼入力欄にて指示がされておりません。<br><br>' +
                            '<b style="font-size:22px;">【電気図面依頼(提案電気図面依頼含む)】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                return;
            }

            // FOR DXF FILE ATTACHMENT RESTRICTION
            if(this.$store.state.editCadRequestRevisionContent.site_layout == '新規データN' && (this.$store.state.editCadRequestRevisionContent.site_layout_option == 'option2' || this.$store.state.editCadRequestRevisionContent.site_layout_option == 'option3') && (this.$store.state.getFileAttachment[1].length === 0 && this.attachSiteTrap == null)) {
                Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                            '所定の位置に資料を添付していただき、再度送信お願い致します。<br>' +
                            '<b style="font-size:22px;">【現況図（DXF）】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                return;
            } 
            if(this.$store.state.editCadRequestRevisionContent.site_layout != '新規データN' && this.$store.state.editCadRequestRevisionContent.site_layout_option == null && this.attachSiteTrap != null) {
                Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の【現況図（DXF）】に資料が添付がされておりますが<br>' +
                            'CAD依頼入力欄にて指示がされておりません。<br><br><br>' +
                            '<b style="font-size:22px;">【 添付ファイル参照（現況図のみ）】</b><br>' +
                            '<b style="font-size:22px;">または</b><br>' +
                            '<b style="font-size:22px;">【添付ファイル参照（現況図及び敷地断面図）】</b>',
                        icon: 'warning',
                        width : 690,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                return;
            }else if(this.$store.state.editCadRequestRevisionContent.site_layout != '新規データN' && this.$store.state.editCadRequestRevisionContent.site_layout_option == null && (this.$store.state.getFileAttachment[1].length > 0 && this.attachSiteTrap == null)) {
                Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の【現況図（DXF）】に資料が添付がされておりますが<br>' +
                            'CAD依頼入力欄にて指示がされておりません。<br><br><br>' +
                            '<b style="font-size:22px;">【 添付ファイル参照（現況図のみ）】</b><br>' +
                            '<b style="font-size:22px;">または</b><br>' +
                            '<b style="font-size:22px;">【添付ファイル参照（現況図及び敷地断面図）】</b>',
                        icon: 'warning',
                        width : 690,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                return;
            }

            // ATTACHMENT FOR STRUCTURAL REQUEST IF ARI
            if(this.editCadRequestRevisionContent.SR_OPTION_1 == 'あり') {
                if(this.editCadRequestRevisionContent.SR_OPTION_1 == 'あり' && (this.attachStructuralTrap == null && this.$store.state.getFileAttachment[3].length === 0 ) 
                    // && (this.$store.state.trapMasua != '3' && this.$store.state.trapMasua != '29' && this.$store.state.trapMasua != '22') && this.editCadRequestRevisionContent.house_type_category == 2 
                    && (this.cadRequestBasicInformation.house_type_id != '3' && this.cadRequestBasicInformation.house_type_id != '29' && this.cadRequestBasicInformation.house_type_id != '22' && this.cadRequestBasicInformation.house_type_id != '35' && this.cadRequestBasicInformation.house_type_id != '37' && this.cadRequestBasicInformation.house_type_id != '38' && this.cadRequestBasicInformation.house_type_id != '39') && this.editCadRequestRevisionContent.house_type_category == 2 
                    && (this.$store.state.revisionSelection != '8' && this.$store.state.revisionSelection != '9')){
                    Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                                'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                                '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br><br>' +
                                '<b style="font-size:22px;">【区画図(SWDI※iCADから出⼒)】</b>',
                            icon: 'warning',
                            width : 690,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                    return;
                }
                if((this.editCadRequestRevisionContent.SR_OPTION_1 == null || this.editCadRequestRevisionContent.SR_OPTION_1 == 'なし') && this.attachStructuralTrap != null
                    && (this.cadRequestBasicInformation.house_type_id != '3' && this.cadRequestBasicInformation.house_type_id != '29' && this.cadRequestBasicInformation.house_type_id != '22' && this.cadRequestBasicInformation.house_type_id != '35' && this.cadRequestBasicInformation.house_type_id != '37' && this.cadRequestBasicInformation.house_type_id != '38' && this.cadRequestBasicInformation.house_type_id != '39')) {
                    Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                                'CAD依頼添付資料の【区画図(SWDI※iCADから出⼒)】に資料が添付がされておりますが<br>' +
                                'CAD依頼入力欄にて指示がされておりません。<br><br><br>' +
                                '<b style="font-size:22px;">【 構造事前検討依頼】→あり</b>',
                            icon: 'warning',
                            width : 690,
                        });
                    return;
                } else if((this.editCadRequestRevisionContent.SR_OPTION_1 == null || this.editCadRequestRevisionContent.SR_OPTION_1 == 'なし') && (this.attachStructuralTrap == null && this.$store.state.getFileAttachment[3].length > 0)
                    && (this.cadRequestBasicInformation.house_type_id != '3' && this.cadRequestBasicInformation.house_type_id != '29' && this.cadRequestBasicInformation.house_type_id != '22' && this.cadRequestBasicInformation.house_type_id != '35' && this.cadRequestBasicInformation.house_type_id != '37' && this.cadRequestBasicInformation.house_type_id != '38' && this.cadRequestBasicInformation.house_type_id != '39')) {
                    Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                                'CAD依頼添付資料の【区画図(SWDI※iCADから出⼒)】に資料が添付がされておりますが<br>' +
                                'CAD依頼入力欄にて指示がされておりません。<br><br><br>' +
                                '<b style="font-size:22px;">【 構造事前検討依頼】→あり</b>',
                            icon: 'warning',
                            width : 690,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                    return;
                }
            } else { //  || this.$store.state.trapMasua != '22'
                if((this.editCadRequestRevisionContent.structural_request && this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'あり') && (this.attachStructuralTrap == null && this.$store.state.getFileAttachment[3].length === 0) 
                    // && (this.$store.state.trapMasua != '3' || this.$store.state.trapMasua != '29' || this.$store.state.trapMasua != '22') && this.editCadRequestRevisionContent.house_type_category == 2
                    && (this.cadRequestBasicInformation.house_type_id != '3' && this.cadRequestBasicInformation.house_type_id != '29' && this.cadRequestBasicInformation.house_type_id != '22' && this.cadRequestBasicInformation.house_type_id != '35' && this.cadRequestBasicInformation.house_type_id != '37' && this.cadRequestBasicInformation.house_type_id != '38' && this.cadRequestBasicInformation.house_type_id != '39') && this.editCadRequestRevisionContent.house_type_category == 2
                    && (this.$store.state.revisionSelection != '8' && this.$store.state.revisionSelection != '9')){
                    Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                                'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                                '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br><br>' +
                                '<b style="font-size:22px;">【区画図(SWDI※iCADから出⼒)】</b>',
                            icon: 'warning',
                            width : 690,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                    return;
                }
                if((this.editCadRequestRevisionContent.structural_request.OPTION_1 == null || this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'なし') && this.attachStructuralTrap != null
                    && (this.cadRequestBasicInformation.house_type_id != '3' && this.cadRequestBasicInformation.house_type_id != '29' && this.cadRequestBasicInformation.house_type_id != '22' && this.cadRequestBasicInformation.house_type_id != '35' && this.cadRequestBasicInformation.house_type_id != '37' && this.cadRequestBasicInformation.house_type_id != '38' && this.cadRequestBasicInformation.house_type_id != '39')) {
                    Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                                'CAD依頼添付資料の【区画図(SWDI※iCADから出⼒)】に資料が添付がされておりますが<br>' +
                                'CAD依頼入力欄にて指示がされておりません。<br><br><br>' +
                                '<b style="font-size:22px;">【 構造事前検討依頼】→あり</b>',
                            icon: 'warning',
                            width : 690,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                    return;
                } else if((this.editCadRequestRevisionContent.structural_request.OPTION_1 == null || this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'なし') && (this.attachStructuralTrap == null && this.$store.state.getFileAttachment[3].length > 0)
                    && (this.cadRequestBasicInformation.house_type_id != '3' && this.cadRequestBasicInformation.house_type_id != '29' && this.cadRequestBasicInformation.house_type_id != '22' && this.cadRequestBasicInformation.house_type_id != '35' && this.cadRequestBasicInformation.house_type_id != '37' && this.cadRequestBasicInformation.house_type_id != '38' && this.cadRequestBasicInformation.house_type_id != '39')) {
                    Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                                'CAD依頼添付資料の【区画図(SWDI※iCADから出⼒)】に資料が添付がされておりますが<br>' +
                                'CAD依頼入力欄にて指示がされておりません。<br><br><br>' +
                                '<b style="font-size:22px;">【 構造事前検討依頼】→あり</b>',
                            icon: 'warning',
                            width : 690,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                    return;
                }
            }
            
            // END OF RESTRICTION FOR ATTACHMENT

            // CONDITION FOR EXPRESS - NEW SSD25-0819783-2269
            await axios({
                method : 'post',
                url : 'api/getTodayExpressCount'
            }).then((r) => {
                if(r.data > 30 && this.editCadRequestRevisionContent.express == 1){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            '<span style="color:blue">本日または翌営業日完了予定の即日CAD依頼数が上限となりました。<span> <br>' +
                            '<span style="color:blue">翌営業日または翌々営業日以降の完了予定となります。<span> <br>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    return
                }
            })

            let item = this.$store.state.editCadRequestRevisionContent
            this.loader = true;
            this.$store.state.editCadRequestRevisionContent.color_perspective = this.$store.state.editCadRequestColorPers;
            this.$store.state.editCadRequestRevisionContent.hp = this.$store.state.edit_cad_request_house_presentation;
            // this.$store.state.editCadRequestRevisionContent.hp_int = this.$store.state.edit_cad_request_house_presentation_int;
            this.$store.state.editCadRequestRevisionContent.timezone = this.userTimezone;
            const data = {
                status: 'SAVED',
				updateRevision: this.$store.state.editCadRequestRevisionContent.revision_number,
				updateContent: this.$store.state.editCadRequestRevisionContent,
                basicInformation: this.$store.state.cadRequestBasicInformation,
			}

            // if(this.envDB == 'hrd_cad_request'){
            //     console.log('dito eh')
            //     let rev1 = null;
            //     let rev2 = null;
            //     let explodeRevision = this.$store.state.editCadRequestRevisionContent.revision_number.split("-")
            //     if(explodeRevision[0].length == 1){
            //         rev1 = `0${explodeRevision[0]}`;
            //     }else{
            //         rev1 = explodeRevision[0]
            //     }

            //     if(explodeRevision[1].length == 1){
            //         rev2 = `0${explodeRevision[1]}`;
            //     }else if(explodeRevision[1].length == 2){
            //         if(/[a-zA-Z]/.test(explodeRevision[1])){
            //             rev2 = `0${explodeRevision[1]}`;
            //         }else{
            //             rev2 = explodeRevision[1];
            //         }
            //     }else{
            //         rev2 = explodeRevision[1];
            //     }
            //     this.mergedFilename = `${this.$store.state.cadRequestBasicInformation.construction_code}-${rev1}${rev2}-`;
            // }else{
            //     console.log('mali, dito kasi nganiiii')
            //     this.mergedFilename = `${this.$store.state.cadRequestBasicInformation.construction_code}-${this.$store.state.editCadRequestRevisionContent.revision_number}-`;
            // }

            let rev1 = null;
            let rev2 = null;
            let explodeRevision = this.$store.state.editCadRequestRevisionContent.revision_number.split("-");

            if (this.envDB == 'hrd_cad_request' && explodeRevision.length >= 2) {
                // console.log('dito eh');
                
                if (explodeRevision[0].length == 1) {
                    rev1 = `0${explodeRevision[0]}`;
                } else {
                    rev1 = explodeRevision[0];
                }

                if (explodeRevision[1].length == 1) {
                    rev2 = `0${explodeRevision[1]}`;
                } else if (explodeRevision[1].length == 2) {
                    rev2 = /[a-zA-Z]/.test(explodeRevision[1]) ? `0${explodeRevision[1]}` : explodeRevision[1];
                } else {
                    rev2 = explodeRevision[1];
                }
                
                this.mergedFilename = `${this.$store.state.cadRequestBasicInformation.construction_code}-${rev1}${rev2}-`;
            } else {
                // console.log('mali, dito kasi nganiiii');
                this.mergedFilename = `${this.$store.state.cadRequestBasicInformation.construction_code}-${this.$store.state.editCadRequestRevisionContent.revision_number}-`;
            }
            

            this.pathName = this.$store.state.cadRequestBasicInformation.construction_code;
            var formdata = new FormData();
            formdata.append("files", JSON.stringify(this.$store.state.attachments));
            formdata.append('data', JSON.stringify(data))
            
                await axios({
                    method:'POST',
                    url: 'api/update-cad-revision',
                    data: formdata
                }).then(async ({ data }) => {
                    if(data.error){
                        Swal.fire({
                            icon: 'error',
                            title: `Error `,
                            text: `${data.error}`,
                        })
                        this.loader = false;
                        return false;
                    }
                    this.newCadRequest = data
                    this.updateStatus = "EDIT"
                    // this.updateStatus = "DRAFT"
                    await this.getScheduleAfterSave(data);
                        this.$store.state.editMode = false;
                        
                        await this.updateMerging(item);

                })
        },

        emptyEdit(){
            this.$store.state.editCadRequestRevisionContent = {
                            revision: null,
                            design_contract: false,
                            calculation_basis: false,
                            site_layout: null,
                            gravity_type: null,
                            gravity : null,
                            isHrdCpn: null,
                            kakouirai_reason : null,
                            // boss_sending: 0,
                            site_layout_option: null,
                            site_diagram: null,
                            new_site_diagram: null,
                            // site_boss: null,
                            specs_irai: { 
                                sash_type: null,  
                                specs: null,  
                                accessories: [],
                                honeycomb: null,  
                                },
                            dxf_data_request: null,
                            color_pers: null,
                            house_presentation: null,
                            house_presentation_int : null,
                            shio_request: null,
                            SRS_request: {
                                shio_selection: null,
                                shio_number: null,
                            },
                            web_documents: null,
                            jiban_plan: null,
                            alvs: null,
                            status: null,
                            structural_request: null,
                            pdr: null,
                            denki_gravity: null,
                            electrical_drawing: null,
                            cross_section: null,
                            elevation_section: null,
                            stop: null,
                            final_plan: null,
                            express: null,
                            request_attach_from: null,
                            stopListSelection: null,
                        };
                        this.$store.state.cadRequestRevisionContent = {
                            revision: null,
                            design_contract: false,
                            calculation_basis: false,
                            site_layout: null,
                            gravity_type: null,
                            isHrdCpn: null,
                            kakouirai_reason : null,
                            // boss_sending: 0,
                            site_layout_option: null,
                            site_diagram: null,
                            new_site_diagram: null,
                            // site_boss: null,
                            specs_irai: { 
                                sash_type: null,  
                                specs: null,  
                                accessories: [],
                                honeycomb: null,  
                                },
                            dxf_data_request: null,
                            color_pers: null,
                            house_presentation: null,
                            house_presentation_int : null,
                            shio_request: null,
                            SRS_request: {
                                shio_selection: null,
                                shio_number: null,
                            },
                            web_documents: null,
                            jiban_plan: null,
                            alvs: null,
                            status: null,
                            hrd_process: null,
                            structural_request: null,
                            pdr: null,
                            denki_gravity: null,
                            electrical_drawing: null,
                            cross_section: null,
                            elevation_section: null,
                            stop: null,
                            final_plan: null,
                            express: null,
                            request_attach_from: null,
                            stopListSelection: null,
                        };
                        this.$store.state.editCadRequestColorPers = [];
                        this.$store.state.cadRequestColorPers = [];
                        this.$store.state.edit_cad_request_house_presentation = [];
                        this.$store.state.cad_request_house_presentation = [];
                        // this.$store.state.cad_request_house_presentation_int = [];
                        // this.$store.state.edit_cad_request_house_presentation_int = [];
                        this.$store.state.attachments = [];
                        this.$store.state.editMode = false;
                        this.$store.state.hideColorPersTable = null;
                        this.$store.state.hideHpTable = null;
        },

        openBasicInfo(){
            this.$store.state.mainDialog = true;
        },


        async editCadRequest(data, index){
            this.$store.state.revisionSelection = data.revision_type
            this.editColor = data;
            this.getPrevData = data;
            // this.$store.state.disableApplyNextCad = true;
            // this.getALVSStopCheck(data.customer_code) // ----- FOR 3RD TIME AND MORE ALVS REQUEST (moved to dialogrevision) -----
            if(this.$store.state.loggedInUser.type == 'Planner') {
                this.cmLoader = true;
                await this.cadMasterTable(data);
            }
                this.$store.state.prevShio = this.existingRevisions[index - 1]
                data.attachments.map(element => {
                    if(element.att_column_name === 'CAD') {
                        return this.attachCadTrap = element.att_column_name;
                    }
                    if (element.att_column_name === '区画図') {
                        return this.attachStructuralTrap = element.att_column_name;
                    }
                    if(element.att_column_name === '電気図面/提案電気図面依頼書') {
                        return this.attachDenkiTrap = element.att_column_name;
                    }
                    if(element.att_column_name === '現況図（CADデータ）') {
                        return this.attachSiteTrap = element.att_column_name;
                    }
                    else {
                        return null; // or any default value if "区画図" is not found
                    }
                });
                this.$store.state.trapMasua = data.house_type_id
                // this.$store.state.editMode = true;
                if(this.loggedInUser.type == 'Admin' || this.loggedInUser.type == 'Plan Control') {
                    this.$store.state.editMode = true;
                }
                this.editIndex = index;
                this.$store.state.editRevision = data.revision_number
                this.$store.state.editCadRequestRevisionContent = {...data}
                this.$store.state.beforeEditColorPers = {...data}
                this.$store.state.editCadRequestRevisionContent.house_type_id = this.$store.state.cadRequestBasicInformation.house_type_id
                // this.$store.state.editCadRequestRevisionContent.house_type_id = data.house_type_id
                this.$store.state.editCadRequestRevisionContent.house_type_name = data.house_type_name;
                // this.$store.state.mainDialogHouse = data.house_type_id
                this.$store.state.editCadRequestRevisionContent.stopListSelection = data.stop_list.filter((res) => {
                                                                                        res.option1 = res.OPTION_1;
                                                                                        res.option2 = res.OPTION_2;
                                                                                        res.isChecked = res.isChecked;
                                                                                        res.selected = res.SELECTED;
                                                                                        res.category = res.category;
                                                                                        res.rowCount = res.rowCount;
                                                                                        return res;
                                                                                    })
                // this.$store.state.editCadRequestRevisionContent.stop = data.stop != "0" && data.stop != null ? true : null;
                this.$store.state.editCadRequestRevisionContent.stop = data.stop != "0" && data.stop != null ? data.stop : null;
                // this.$store.state.editCadRequestRevisionContent.house_type_id = +data.house_type_id;
                // this.$store.state.editCadRequestRevisionContent.isBossChecked = this.$store.state.isBossChecked;
                if(data.revision_type == '7') {
                    this.$store.state.disableSelections = true
                } else {
                    this.$store.state.disableSelections = false;
                }

                if(data.srs_shio){
                    this.$store.state.editCadRequestRevisionContent.SRS_request = {
                                                                                    shio_selection: data.srs_shio.shio_selection,
                                                                                    shio_number: data.srs_shio.SRS_data,
                                                                                }
                }else{
                    this.$store.state.editCadRequestRevisionContent.SRS_request = {
                                                                    shio_selection: null,
                                                                    shio_number: null,
                                                                }
                }

                let specs = {       
                            sash_type: null,  
                            specs: null,  
                            accessories: [],
                            honeycomb: null,
                        } 
                this.$store.state.editCadRequestRevisionContent.specs_irai = data.specs_irai == null ? specs : data.specs_irai 
                this.$store.state.alvsSelection = data.alvs != "" && data.alvs != null ? data.alvs : null;
                this.$store.state.editCadRequestRevisionContent.alvs = this.$store.state.alvsSelection 

                this.$store.state.editCadRequestRevisionContent.site_layout_option = data.site_layout_option
                // this.$store.state.editCadRequestRevisionContent.boss_sending = data.boss_sending
                this.$store.state.editCadRequestRevisionContent.site_diagram = data.site_diagram
                this.$store.state.editCadRequestRevisionContent.new_site_diagram = data.new_site_diagram

                this.editToggleB6_1 = this.$store.state.editCadRequestRevisionContent.specs_irai.sash_type;
                this.editToggleB6_2 = this.$store.state.editCadRequestRevisionContent.specs_irai.specs;
                if(data.specs_irai){
                    this.$store.state.editCadRequestRevisionContent.specs_irai.accessories = data.specs_irai.accessories.map((r) => {
                        return r.value;
                    });
                }

                this.editToggleB6_3 = this.$store.state.editCadRequestRevisionContent.specs_irai.accessories
                this.editToggleB6_4 = this.$store.state.editCadRequestRevisionContent.specs_irai.honeycomb
                // this.$store.state.editCadRequestColorPers = data.color_perspective
                if(data.color_perspective){
                    let tempEdit = [];
                    for (let i = 0; i < data.color_perspective.length; i++) {
                        // this.editCadRequestColorPers[i] = {...this.editCadRequestColorPers[i]}
                        let color = {
                            is_request_color_info: data.color_perspective[i].is_request_color_info,
                            roof: {
                                    roofing_material: null,
                                    roof_color: data.color_perspective[i].roof ? data.color_perspective[i].roof : null,
                                },
                            spray_1f: {
                                exteriorRequestContent: data.color_perspective[i].spray_1f != null ? data.color_perspective[i].spray_1f : null,
                                },
                            spray_2f: {
                                exteriorRequestContent: data.color_perspective[i].spray_2f != null ? data.color_perspective[i].spray_2f : null,
                                },
                            spray_3f: {
                                exteriorRequestContent: data.color_perspective[i].spray_3f != null ? data.color_perspective[i].spray_3f : null,
                                },
                            exterior_wall_tile : {
                                color_construction: null,
                                exterior_wall_tile: data.color_perspective[i].exterior_wall_tile ? data.color_perspective[i].exterior_wall_tile : null,
                                accent_wall_color: data.color_perspective[i].accent_wall_color ? data.color_perspective[i].accent_wall_color : null,
                                },
                            external_wall_finish : data.color_perspective[i].external_wall_finish,    
                            balcony_glass : data.color_perspective[i].balcony_glass,
                            design_louver : data.color_perspective[i].design_louver,
                            sash : data.color_perspective[i].sash,
                            front_door : {
                                    entrance_door_type: null,
                                    door_item: null,
                                    door_color: data.color_perspective[i].front_door ? data.color_perspective[i].front_door : null,
                                },
                            mall_and_arrowhead_decoration : data.color_perspective[i].mall_and_arrowhead_decoration,
                            balcony_belt : data.color_perspective[i].balcony_belt,
                            tile_band : data.color_perspective[i].tile_band,
                            decorative_belt_1f : data.color_perspective[i].decorative_belt_1f,
                            decorative_belt_2f : data.color_perspective[i].decorative_belt_2f,
                            eaves_of_a_house : data.color_perspective[i].eaves_of_a_house,
                            eaves_gutter : data.color_perspective[i].eaves_gutter,
                            breaking_wind : data.color_perspective[i].breaking_wind,
                            base_draining : data.color_perspective[i].base_draining,
                            porch_tile : {
                                porch_tile_item: null,
                                porch_tile_item_color: data.color_perspective[i].porch_tile ? data.color_perspective[i].porch_tile : null,
                            },
                            perspective_direction : data.color_perspective[i].perspective_direction,
                            viewpoint_height : data.color_perspective[i].viewpoint_height,
                            garden_number : data.color_perspective[i].garden_number,
                        }
                        tempEdit.push(color)
                    }

                    this.$store.state.editCadRequestColorPers = [];
                    this.$store.state.editCadRequestColorPers = tempEdit;
                    // this.$store.state.editCadRequestColorPers = this.$store.state.beforeEditColorPers.house_type_id != this.cadRequestBasicInformation.house_type_id ? [] : tempEdit;
                }
                this.$store.state.editCadRequestRevisionContent.house_presentation_int = data.house_presentation_int;
                this.$store.state.hideColorPersTable = this.editCadRequestColorPers[0] ? this.editCadRequestColorPers[0].is_request_color_info == 0 ? 0 : 1 : 1
                this.$store.state.edit_cad_request_house_presentation = data.hp
                this.$store.state.beforeEditHP = {...data}
                // this.$store.state.edit_cad_request_house_presentation_int = data.hp_int
                this.$store.state.hideHpTable = this.edit_cad_request_house_presentation[0] ? this.edit_cad_request_house_presentation[0].is_request_color_info == 0 ? 0 : 1 : 0
                this.$store.state.structural_request = {
                                                            OPTION_ZEH : data.SR_OPTION_ZEH,
                                                            OPTION_GX : data.SR_OPTION_GX,
                                                            OPTION_1 : data.SR_OPTION_1,
                                                            OPTION_2 : data.SR_OPTION_2,
                                                            OPTION_W : data.SR_OPTION_W,
                                                            OPTION_S : data.SR_OPTION_S,
                                                        }
                this.$store.state.editCadRequestRevisionContent.structural_request = this.$store.state.structural_request
                this.$store.state.editCadRequestRevisionContent.attachments = data.attachments
                this.$store.state.attachments = this.$store.state.editCadRequestRevisionContent.attachments
                this.$store.state.electrical_request = {
                                                        pdr_title : data.ED_PDR_TITLE,
                                                        radioPdr: data.ED_DENKI_PLAN_1,
                                                        denki_plan_title : data.ED_DENKI_PLAN_TITLE,
                                                        OPTION_1: data.ED_OPTION_1,
                                                        OPTION_2: data.ED_OPTION_2,
                                                        radioGravity: data.ED_DENKI_PLAN_GRAVITY,
                                                        selectedDrawing: data.ED_ELECTRICAL_REQUEST,
                                                    }
                this.$store.state.editCadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request
                this.$store.state.editCadRequestRevisionContent.denki_gravity = data.denki_plan_gravity
                
                this.$store.state.editCadRequestRevisionContent.cross_section = data.cross_section
                this.$store.state.editCadRequestRevisionContent.elevation_section = data.elevation_section
                // this.$store.state.editCadRequestRevisionContent.whole_date = data.created_at;
                this.$store.state.editFinalPlan = data.final_plan
               // await this.openBasicInfo();
                if(this.loggedInUser.type == 'Admin' || this.loggedInUser.type == 'Plan Control') {
                    await this.openBasicInfo();
                }
                
                // this.$store.state.edit_webDocs = data.web_documents
                if(data.web_documents.length > 0){
                    data.web_documents.filter((r) => {
                        this.$store.state.edit_webDocs.push({
                            value : r.value,
                            text : r.text
                        })
                    })
                }
                // this.$store.state.attachments = {...data.attachments}            
        },

        async hrdAcceptFunction(index, trial){
            this.loader = true;
            await axios({
				method: 'POST',
				url: 'api/accept-plan',
				data: {
                    existing : this.$store.state.existingRevisions[index],
                    loggedInUser : this.loggedInUser,
                    register_date : this.$store.state.registerDate,
                }
			}).then(async ({ data }) => {
                if(!this.register) { //accept
                    this.updateStatus = 'HRD Accept';
                } else {//register
                    this.updateStatus = 'Register';
                }
                    this.newCadRequest = data.latest;
                    this.newCadRequest.file = data.file;
                    this.newCadRequest.kakouirai = data.kakou;
                    await this.updateXMLTable(this.newCadRequest);
                    // this.updateXmlCad(data);
                // }
			})
        },

        convertB64(data){
            return new Promise(async(resolve)=>{
                // create a new PDF document
                let downloadUrl = null;
                const mergedPdf = await PDFDocument.create();
                // loop through the PDFs and add each one to the merged document
                for (const pdf of data.file) {

                // decode the base64-encoded PDF
                    if(pdf){
                        const pdfBytes = Buffer.from(pdf, 'base64');
                        // create a PDFDocument object from the bytes
                        const pdfDoc = await PDFDocument.load(pdfBytes);
                        // loop through each page in the PDF and add it to the merged document
                        const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                            pages.forEach((page) => {
                                mergedPdf.addPage(page);
                                // this.countPage += 1;
                            });
                        }

                        // save the merged PDF to a file
                        const mergedPdfBytes = await mergedPdf.save();
                        // Create a Blob object with the merged PDF data
                        const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                        // Create a download URL for the Blob
                        downloadUrl = URL.createObjectURL(blob);
                        resolve(mergedPdfBytes)
                    }
                        // window.open(downloadUrl, '_blank');
                        this.newCadRequest.blobUrl = downloadUrl;
                        await this.updateXMLTable()
                        await this.mergeCadPira(data.cadPira);
            })
        },

        cancelRequest(index){
            this.deleteIndex = this.existingRevisions[index];
            Swal.fire({
                title: "Are you sure you want to delete this plan?",
                showDenyButton: true,
                confirmButtonText: "Okay",
                denyButtonText: `Cancel`
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loader = true;
                    axios({
                        method: 'POST',
                        url: 'api/cancel-plan',
                        data: this.existingRevisions[index]
                    }).then( async ({ data }) => {
                        // this.newCadRequest = data.xml_bundle;
                        this.updateStatus = 'DELETE';
                        if(data.latest != null){
                            this.loader = true;
                            await this.updateXMLTable(data.latest, data.getShio);
                        }
                        this.$refs.dialogElectricalDrawing.closetoggleDialogElectricalDrawing();
                        await this.getCadActualData()
                        this.loader = false;
                    })
                }
            });
        },

        plannerCancelRequest(index){
            this.plannerIndex = index
            this.deleteIndex = this.existingRevisions[index];
            this.cmLoader = true;
            this.cancelCadMasterTable(this.deleteIndex)
        },

        async restorePlan(index){
            await axios({
				method: 'POST',
				url: 'api/restore-plan',
				data: this.existingRevisions[index]
			}).then(({ data }) => {
                // this.getCadDraftData()
                // this.getDeletedData()
                this.getCadActualData()

			})
        },

        async restoreDraft(data,index) {
            await axios({
                method : 'POST',
                url : 'api/restore-draft',
                data : this.$store.state.existingRevisions[index]
            }).then(({data}) => {
                this.getCadActualData()
            })
        },

        async getCadDraftData(){
            this.btnSelection = 'DRAFT';
            this.$store.state.existingRevisions = [];
			await axios({
				method: 'POST',
				url: 'api/existing-draft-revisions',
				data: {
                    customerCode: this.$store.state.cadRequestBasicInformation.construction_code,
                    loggedUser : this.loggedInUser,
                }
			}).then( async ({ data }) => {
				this.$store.state.existingRevisions = data.filter((rec) => {
                    // rec.time = new Date(rec.created_at).toLocaleTimeString("en-US", { hour12:false, hour: '2-digit', minute:'2-digit'});
					// rec.created_at =  new Date(rec.created_at).toLocaleDateString('en-US', { month:'2-digit', day:'2-digit'})
					// rec.updated_at =  new Date(rec.updated_at).toLocaleDateString('en-US', { month:'2-digit', day:'2-digit'})
					// return rec
                    rec.whole_date = rec.created_at;
                    rec.time = new Date(rec.created_at).toLocaleTimeString("en-US", { hour12:false, hour: '2-digit', minute:'2-digit'});
					rec.created_at =  new Date(rec.created_at).toLocaleDateString('en-US', { month:'2-digit', day:'2-digit'})
					rec.updated_at =  new Date(rec.updated_at).toLocaleDateString('en-US', { month:'2-digit', day:'2-digit'})
                    let rev1 = null;
                    let rev2 = null;
                    let explodeRevision = rec.revision_number.split("-")
                    if(explodeRevision[0].length == 1){
                        rev1 = `0${explodeRevision[0]}`;
                    }else{
                        rev1 = explodeRevision[0]
                    }

                    if(explodeRevision[1].length == 1){
                        rev2 = `0${explodeRevision[1]}`;
                    }else if(explodeRevision[1].length == 2){
                        if(/[a-zA-Z]/.test(explodeRevision[1])){
                            rev2 = `0${explodeRevision[1]}`;
                        }else{
                            rev2 = explodeRevision[1];
                        }
                    }else{
                        rev2 = explodeRevision[1];
                    }
                    if(rec.attachments){
                        rec.attachments = rec.attachments.filter(res => {
                            if(res.filename.includes(rec.customer_code+"-"+rev1+rev2) || res.filename.includes(rec.revision_number)){
                                return res
                            }
                        })
                    }
					return rec
				})
                this.loader = false;
                // this.activeBtn = 0;
                this.$store.state.draftButton = data.length > 0 ? true : false;
                
			})
		},


        //MODIFIED BY UARY20260424
        async getCadActualData() {
            this.btnSelection = 'ACTUAL';
            this.$store.state.existingRevisions = [];

            await axios({
                method: 'POST',
                url: 'api/existing-revisions',
                data: {
                    customerCode: this.$store.state.cadRequestBasicInformation.construction_code,
                    loggedUser: this.loggedInUser,
                }
            }).then(async ({ data }) => {
                this.$store.state.existingRevisions = data.filter((rec) => {
                    rec.whole_date = rec.created_at;
                    rec.time = new Date(rec.created_at).toLocaleTimeString("en-US", { hour12: false, hour: '2-digit', minute: '2-digit' });
                    rec.created_at = new Date(rec.created_at).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit' });
                    rec.updated_at = new Date(rec.updated_at).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit' });

                    let rev1 = '';
                    let rev2 = '';
                    let explodeRevision = rec.revision_number.split("-");

                    // --- REVISION LOGIC FIX ---
                    if (explodeRevision.length > 1) {
                        // Normal "Number-Number" or "Number-Letter" format
                        rev1 = explodeRevision[0].length === 1 ? `0${explodeRevision[0]}` : explodeRevision[0];
                        
                        let part2 = explodeRevision[1];
                        if (part2.length === 1) {
                            rev2 = `0${part2}`;
                        } else if (part2.length === 2 && /[a-zA-Z]/.test(part2)) {
                            rev2 = `0${part2}`;
                        } else {
                            rev2 = part2;
                        }
                    } else {
                        // Special case: Single string like 'TEST'
                        rev1 = rec.revision_number;
                        rev2 = ''; 
                    }
                    // ---------------------------

                    if (rec.attachments) {
                        if (this.envDB == 'hrd_cad_request') {
                            rec.attachments = rec.attachments.filter(res => {
                                // If it's 'TEST', rev1+rev2 becomes just 'TEST'
                                let combinedRev = rev1 + rev2; 
                                if (res.filename.includes(rec.customer_code + "-" + combinedRev) || res.filename.includes(rec.revision_number)) {
                                    return res;
                                }
                            });
                        } else {
                            rec.attachments = rec.attachments.filter(res => {
                                if (res.filename.includes(rec.revision_number)) {
                                    return res;
                                }
                            });
                        }
                    }
                    return rec;
                });

                this.activeBtn = 0;
            });
        },

        getDeletedData(){
            this.btnSelection = 'DELETED';
            this.$store.state.existingRevisions = [];
            axios({
				method: 'POST',
				url: 'api/existing-deleted-revisions',
				data: {
                    customerCode: this.$store.state.cadRequestBasicInformation.construction_code,
                    loggedUser : this.loggedInUser,
                }
			}).then(({ data }) => {
				this.$store.state.existingRevisions = data.filter((rec) => {
                    rec.whole_date = rec.created_at;
                    rec.time = new Date(rec.created_at).toLocaleTimeString("en-US", { hour12:false, hour: '2-digit', minute:'2-digit'});
					rec.created_at =  new Date(rec.created_at).toLocaleDateString('en-US', { month:'2-digit', day:'2-digit'})
                    rec.updated_at =  new Date(rec.updated_at).toLocaleDateString('en-US', { month:'2-digit', day:'2-digit'})
					return rec
				})
                this.$store.state.deleteButton = data.length > 0 ? true : false;

			})
        },

        emmitedColor(val){
        },

        emmitedHp(val){
        },

        closeDialog(val){
        },

        HRDAcceptCadRequest(){
            
            const data = {
                status: 'HRDAccept',
				basicInformation: this.$store.state.cadRequestBasicInformation,
				latestRevision: this.$store.state.cadRequestLatestRevision,
				revisionContent: this.$store.state.cadRequestRevisionContent,
			}
                axios({
                    method:'POST',
                    url: 'api/save-cad-revision',
                    data: data
                }).then( async ({ data }) => {
                    await this.getCadActualData();
                })
        },

        draftSaveCadRequest(){

            if(this.$store.state.cadRequestRevisionContent.shio_request){
                if((this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "1" || this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "3") && !this.$store.state.cadRequestRevisionContent.SRS_request.shio_number){
                    // if(this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "1" && !this.$store.state.cadRequestRevisionContent.SRS_request.shio_number){
                    Swal.fire({
                        icon: 'error',
                        title: `該当する仕様書依頼システム(SRS)が送信されいないため、CAD依頼を保存できません。`,
                        text: `It is not possible to save draft because the relevant SRS data has not been sent.`,
                    })
                    return;
                }
            }

            let rev1 = null;
            let rev2 = null;
            let explodeRevision = this.$store.state.cadRequestRevisionContent.revision.split("-")
            if(explodeRevision[0].length == 1){
                rev1 = `0${explodeRevision[0]}`;
            }else{
                rev1 = explodeRevision[0]
            }

            if(explodeRevision[1].length == 1){
                rev2 = `0${explodeRevision[1]}`;
            }else if(explodeRevision[1].length == 2){
                if(/[a-zA-Z]/.test(explodeRevision[1])){
                    rev2 = `0${explodeRevision[1]}`;
                }else{
                    rev2 = explodeRevision[1];
                }
            }else{
                rev2 = explodeRevision[1];
            }

            this.pathName = this.$store.state.cadRequestBasicInformation.construction_code;
            this.mergedFilename = `${this.$store.state.cadRequestBasicInformation.construction_code}-${rev1}${rev2}-`;
            this.$store.state.cadRequestRevisionContent.hrd_id = generateHRDID(357)
            this.$store.state.cadRequestRevisionContent.timezone = this.userTimezone;
            this.loader = true;

            
            const data = {
                status: 'DRAFT',
				basicInformation: this.$store.state.cadRequestBasicInformation,
				latestRevision: this.$store.state.cadRequestLatestRevision,
				revisionContent: this.$store.state.cadRequestRevisionContent,
                cadRequestColorPers : this.$store.state.cadRequestColorPers,
                cad_request_house_presentation : this.$store.state.cad_request_house_presentation,
                cad_request_pdr : this.$store.state.cadRequestPdr,
                // cad_request_house_presentation_int : this.$store.state.cad_request_house_presentation_int,
                additionalAttachments: this.$store.state.additionalAtachments,
			}
            var formdata = new FormData();
            formdata.append("files", JSON.stringify(this.$store.state.attachments));
            formdata.append("data", JSON.stringify(data))
            
                axios({
                    method:'POST',
                    url: 'api/save-cad-revision',
                    data: formdata
                }).then(({ data }) => {
                    if(data.status != 'success'){
                        Swal.fire({
                            icon: 'error',
                            title: `Error `,
                            text: `${data.error}`,
                        })
                        this.loader = false;
                        return false;
                    } else {
                    // this.getCadActualData();
                    this.getCadDraftData();
                    // this.getDeletedData();
                    this.$store.state.cadRequestRevisionContent = {
                        revision: null,
                        design_contract: false,
                        calculation_basis: false,
                        site_layout: null,
                        gravity_type: null,
                        gravity : null,
                        isHrdCpn: null,
                        kakouirai_reason : null,
                        // boss_sending: 0,
                        site_layout_option: null,
                        site_diagram: null,
                        new_site_diagram: null,
                        // site_boss: null,
                        specs_irai: { 
                            sash_type: null,  
                            specs: null,  
                            accessories: [],
                            honeycomb: null,  
                            },
                        dxf_data_request: null,
                        color_pers: null,
                        house_presentation: null,
                        house_presentation_int : null,
                        shio_request: null,
                        SRS_request: {
                            shio_selection: null,
                            shio_number: null,
                        },
                        web_documents: null,
                        jiban_plan: null,
                        alvs: null,
                        status: null,
                        structural_request: null,
                        pdr: null,
                        denki_gravity: null,
                        electrical_drawing: null,
                        cross_section: null,
                        elevation_section: null,
                        stop: null,
                        final_plan: null,
                        express: null,
                        request_attach_from: null,
                        stopListSelection: null,
                    };
                    this.$refs.dialogElectricalDrawing.closetoggleDialogElectricalDrawing();
                    // this.$store.state.cadRequestRevisionContent = [];
                    this.$store.state.cadRequestColorPers = [];
                    this.$store.state.cad_request_house_presentation = [];
                    // this.$store.state.cad_request_house_presentation_int = [];
                    this.$store.state.attachments = [];
                    this.$store.state.hideColorPersTable = null;
                    this.$store.state.hideHpTable = null;
                    this.$store.state.editCadRequestColorPers = [];
                    this.$store.state.edit_cad_request_house_presentation = [];
                    // this.$store.state.edit_cad_request_house_presentation_int = [];
                    
                    this.$store.state.cadRequestLatestRevision = null;
                    this.$store.state.hrd_process_stamp = false;
                    this.$store.state.hideColorPersTable = null;
                    this.$store.state.hideHpTable = null;
                    this.toggleB5 = null;
                    this.toggleB6_1 = null;
                    this.toggleB6_2 = null;
                    this.toggleB6_3 = [];
                    this.toggleB6_4 = null;

                    for(let i = 0; i < 10; i++){
                        this.$store.state.getFileAttachment[i] = [];
                    }

                    this.$store.state.additionalAtachments = [];
                }
                }).catch(error => {
                    alert(error , "save Draft Cad Request");
                });
        },

        async testMerging(){
            this.countPage = 0;
            let downloadUrl = null;
            let id = this.existingRevisions[this.existingRevisions.length-1].id;
            await axios({
                method : 'GET',
                url : `merge_pdf/${id}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(async ({data}) => {

                return new Promise(async(resolve)=>{
                    // create a new PDF document
                    const mergedPdf = await PDFDocument.create();
                    // loop through the PDFs and add each one to the merged document
                    for (const pdf of data.fileBuffer) {
                    // decode the base64-encoded PDF
                        if(pdf){
                            const pdfBytes = Buffer.from(pdf, 'base64');
                            // create a PDFDocument object from the bytes
                            const pdfDoc = await PDFDocument.load(pdfBytes);
                            // loop through each page in the PDF and add it to the merged document
                            const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                pages.forEach((page) => {
                                    mergedPdf.addPage(page);
                                    this.countPage += 1;
                                });
                            }
                            // save the merged PDF to a file
                            const mergedPdfBytes = await mergedPdf.save();
                            // Create a Blob object with the merged PDF data
                            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                            // Create a download URL for the Blob
                            downloadUrl = URL.createObjectURL(blob);
                            resolve(mergedPdfBytes)
                        }
                            // window.open(downloadUrl, '_blank');
                            await this.saveMergedFile(downloadUrl, id)
                            await this.mergeCadPira(data.cadPira);
                            // await this.saveMergedZipFile(downloadUrl, id)

                })
            })
        },

    // NOTE : JS
        getPathAndFilename(){
            let rev1 = null;
            let rev2 = null;
            let explodeRevision = this.$store.state.editCadRequestRevisionContent.revision_number.split("-")
            if(explodeRevision[0].length == 1){
                rev1 = `0${explodeRevision[0]}`;
            }else{
                rev1 = explodeRevision[0]
            }

            if(explodeRevision[1].length == 1){
                rev2 = `0${explodeRevision[1]}`;
            }else if(explodeRevision[1].length == 2){
                if(/[a-zA-Z]/.test(explodeRevision[1])){
                    rev2 = `0${explodeRevision[1]}`;
                }else{
                    rev2 = explodeRevision[1];
                }
            }else{
                rev2 = explodeRevision[1];
            }

            this.pathName = this.$store.state.cadRequestBasicInformation.construction_code;
            this.mergedFilename = `${this.$store.state.cadRequestBasicInformation.construction_code}-${rev1}${rev2}-`;
        },

        //NOTE : FOR ZIPFILE MERGE AND SAVING
        async saveMergedZipFile(blobUrl, id){
            await fetch(blobUrl)
                .then(response => response.blob())
                .then( async blob => {
                    const file = new File([blob], 'merged.zip');

                    // Create a FormData object and append the file
                     const formData = new FormData();
                     formData.append('file', file);
                     formData.append('pathName', this.pathName);
                     formData.append('fileName', this.mergedFilename);
                     formData.append('id', id);
                     formData.append('pages', this.countPage);
                     formData.append('basic', JSON.stringify(this.$store.state.cadRequestBasicInformation));
                     formData.append('cad', JSON.stringify(this.$store.state.cadRequestRevisionContent));

                     await axios({
                    method : "post",
                    url : 'api/save-merge-zip',
                    data : formData
                    }).then(async ({data}) => {
                        await this.getCadActualData();
                        window.open(`open_file/${data.FileAttachment.id}`,"_blank");
                        this.loader = false;
                    })
                }).catch(error => {
                    console.log(error, 'saveMergedZipFile')
                })
        },

    // NOTE : LARAVEL
        //NOTE - START OF CHANGES MADE BY UARY 2025/03/19
        async saveMergedFile(blobUrl, id) {
            // this.loader = true;
            await fetch(blobUrl)
            .then(response => response.blob())
            .then(async blob => {
                const file = new File([blob], 'merged.pdf');

                const chunkSize = 1024 * 1024 * 5; // 5MB
                const totalChunks = Math.ceil(file.size / chunkSize);
                const formData = new FormData();

                
                formData.append('pathName', this.pathName);
                formData.append('fileName', this.mergedFilename);
                formData.append('id', id);
                formData.append('pages', this.countPage);
                formData.append('basic', JSON.stringify(this.$store.state.cadRequestBasicInformation));
                formData.append('cad', JSON.stringify(this.$store.state.cadRequestRevisionContent));

                let finalData;
                let finalFilePath;
                let finalFilename;
                let user = this.$store.state.loggedInUser.email;
                let customerCode = this.$store.state.cadRequestBasicInformation.construction_code;
                let revisionNumber = this.cadRequestRevisionContent.revision;

                for (let i = 0; i < totalChunks; i++) {
                    const start = i * chunkSize;
                    const end = Math.min(start + chunkSize, file.size);
                    const chunk = file.slice(start, end); 

                
                    const chunkFormData = new FormData();
                
                    chunkFormData.append('pathName', this.pathName);
                    chunkFormData.append('fileName', this.mergedFilename);
                    chunkFormData.append('id', id);
                    chunkFormData.append('pages', this.countPage);
                    chunkFormData.append('basic', JSON.stringify(this.$store.state.cadRequestBasicInformation));
                    chunkFormData.append('cad', JSON.stringify(this.$store.state.cadRequestRevisionContent));
                    chunkFormData.append('file', chunk, `merged_part_${i + 1}.pdf`); // Append the chunk
                    chunkFormData.append('chunkIndex', i); // Append the chunk index
                    chunkFormData.append('totalChunks', totalChunks);

                    try {
                        await axios({
                        method: "POST",
                        url: "api/upload-chunk-mergedfiles",
                        data: chunkFormData
                        }).then(({ data }) => {
                            finalFilePath = data.finalFilePath;
                            finalFilename = data.finalFilename; 
                        }).catch(error => {
                            console.log(error, 'Error uploading chunk');
                            throw error;
                        });
                    } catch (error) {
                        console.error('Error uploading chunk:', error);
                        break;
                    }


                    const mergeFormData = new FormData();
                    mergeFormData.append('user', user);
                    mergeFormData.append('customerCode', customerCode);
                    mergeFormData.append('revisionNumber', revisionNumber);
                    mergeFormData.append('pathName', this.pathName);
                    mergeFormData.append('finalFilePath', finalFilePath);
                    mergeFormData.append('finalFilename', finalFilename);
                    mergeFormData.append('id', id);
                    mergeFormData.append('pages', this.countPage);

                    if (i == totalChunks - 1){
                        try{
                           await axios({
                            method: "POST",
                            url: "api/merge-chunk-mergedfiles",
                            data: mergeFormData
                           }).then((res) => {
                            finalData = res.data;
                            this.Logger('info', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) Files are merged and uploaded successfully`, 1);
                           })
                        } catch (error) {
                            console.error('Error merging chunk:', error);
                            this.Logger('error', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) Files did not merged successfully`, 1);
                        }
                    }
                    
                }

                    
                    await this.getCadActualData();
                if (finalData && finalData.FileAttachment) {
                    window.open(`open_file/${finalData.FileAttachment.id}`, "_blank");
                } 
                    this.loader = false;
            }).catch(error => {
                console.log(error, 'saveMergedFile');
            });
        },
        

        // IF WITHOUT DATA -> FONT IS THE PROBLEM, CHECK FONTS
        async mergeCadPira(data){
            this.countPageCadPira = 0;
            let id = this.existingRevisions[this.existingRevisions.length-1].id;
            let downloadUrl = null;
                return new Promise(async(resolve)=>{
                    // create a new PDF document
                    const mergedPdf = await PDFDocument.create();
                    if(data){
                        // loop through the PDFs and add each one to the merged document
                        for (const pdf of data) {
                        // decode the base64-encoded PDF
                            if(pdf){
                                const pdfBytes = Buffer.from(pdf, 'base64');
                                // create a PDFDocument object from the bytes
                                const pdfDoc = await PDFDocument.load(pdfBytes);
                                // loop through each page in the PDF and add it to the merged document
                                const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                    pages.forEach((page) => {
                                        mergedPdf.addPage(page);
                                        this.countPageCadPira += 1;
                                    });
                                }
                                const mergedPdfBytes = await mergedPdf.save();
                                const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                                downloadUrl = URL.createObjectURL(blob);
                                resolve(mergedPdfBytes)
                            }
                                await this.saveMergedCadPiraFile(downloadUrl, id)
                                
                    }else{
                        console.log(data, "no data")
                    }

                }).catch(error => {
                    console.log(error, "mergeCadPira")
                })
        },

        async saveMergedCadPiraFile(blobUrl, id){
            fetch(blobUrl)
                .then(response => response.blob())
                .then(blob => {
                    const file = new File([blob], 'merged.pdf');
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('pathName', this.pathName);
                        formData.append('fileName', this.mergedFilename);
                        formData.append('id', id);
                        formData.append('pages', this.countPageCadPira);
                        

                        axios({
                            method : "POST",
                            url : "api/save-merge-cadpira",
                            data : formData
                        }).then(async ({data}) => {
                            if(data.error){
                                Swal.fire({
                                    icon: 'error',
                                    title: `Error! Please re-PDF `,
                                    text: `${data.error}`,
                                })
                                this.loader = false;
                                return false;
                            }
                            this.newCadRequest = data
                            this.updateStatus = "ADD";
                            await this.getCadActualData();
                            await this.emptyAll();
                            this.loader = false;
                            

                        })
                    }).catch(error => {
                        console.log(error , 'saveMergedCadPiraFile')
                    })

        },

        // NOTE - MODIFIED ORIGINAL CODE 11-18-25 - IN USE
        async saveCadRequest(){

            // console.log(this.$store.state.cadRequestRevisionContent.dxf_data_request, "value ni dxf")
            // if(this.$store.state.revisionSelection == '6' || (this.$store.state.revisionSelection == '5' && this.$store.state.subRevision == '5D') || (this.$store.state.revisionSelection == '8' && this.$store.state.isHrdCpn == true) || (this.$store.state.revisionSelection == '9' && this.$store.state.isHrdCpn == true)){
            //     if(this.$store.state.cadRequestRevisionContent.dxf_data_request == true){
            //         console.log("proceed sa creation")
            //     }
            // }else{
            //     if(this.$store.state.cadRequestRevisionContent.dxf_data_request == true){
            //         console.log("need mo attachment atecoooo")
            //     }
            // }
            // return;

            // SRS SEND TO BOSS FUNCTION
            const constructionCode = this.$store.state.cadRequestBasicInformation.customer_code;
            const revisionNumber = this.cadRequestRevisionContent.revision; 
            const shiyoNumber = this.$store.state.cadRequestRevisionContent.SRS_request.shio_number;
            // const crsShioRequest = this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection;

            if(this.$store.state.cadRequestRevisionContent.shio_request){
                if(this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "1") {
                    try{
                        // await delay(500);
                        // const srsCancelRes = await axios.post(`http://10.169.141.136:4000/api/update-srs-sent-status`, {
                        // const srsCancelRes = await axios.post(`https://srs-test.ihs-w.com/api/update-srs-sent-status`, {
                        const srsCancelRes = await axios.post(`https://srs.hrd-s.com/api/update-srs-sent-status`, {
                            "construction_code": constructionCode,
                            "plan_no": revisionNumber,
                            "shio_no": shiyoNumber, //replace with shio code actual
                            "plan_status_code": 1, //fixed static
                        })
                        if(this.$store.state.cadRequestRevisionContent.SRS_request.shio_number === null){
                            //For local, need to emit to trigger existing SRS function for sending BOss with PDF 
                            // if(srsCancelRes.status >= 200 && srsCancelRes.status < 300){
                            if (srsCancelRes.data.message === "Failed to update, plan do not exists.") {
                                Swal.fire({
                                    html: '<div style="text-align: left;font-size:22px;font-weight:bold;">' +
                                        '仕様検討ツールが未作成・保存の為、CAD依頼送信ができません。.<br>' +
                                        'SRSにて作成保存してください。.<br><br>' +
                                        'CAD request cannot be sent because Shiyo request has not been created or saved. .<br><br>' +
                                        'Please create and save it in SRS.',
                                    icon: 'warning',
                                    width : 630,
                                });
                                this.Logger('warning', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) NO INPUT FROM THE PLANNER YET`, 1);
                                return;
                            }    
                        }else{
                            if (srsCancelRes.data.message === "Successfully updated"){
                                this.Logger('info', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) SRS Data successfully sent to boss`, 1);
                            }
                            let tmpCRSObj = {
                                dispatchType: 'request',
                                functionType: 'SRSSend',
                                constructionCode: constructionCode,
                                planNumber: revisionNumber,
                                shiyoNumber: shiyoNumber,
                                email: this.$store.state.loggedInUser.email,
                                CRSShiyoRequest: '1',
                                remarks: 'send boss and hrd data'
                            };
                            this.$socket.emit("newUpdate", tmpCRSObj);
                        }
                        
                    } catch (error) {
                        this.Logger('error', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) SRS DATA WAS NOT SENT TO BOSS`, 1);
                        console.error("API call failed:", error);
                    }
                } 
                else if (this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "3") {
                    try{
                        // await delay(500);
                        // const srsCancelRes = await axios.post(`http://10.169.141.136:4000/api/update-srs-sent-status`, {
                        // const srsCancelRes = await axios.post(`https://srs-test.ihs-w.com/api/update-srs-sent-status`, {
                        const srsCancelRes = await axios.post(`https://srs.hrd-s.com/api/update-srs-sent-status`, {
                            "construction_code": constructionCode,
                            "plan_no": revisionNumber,
                            "shio_no": shiyoNumber, //replace with shio code actual
                            "plan_status_code": 1, //fixed static
                        })
                        if(this.$store.state.cadRequestRevisionContent.SRS_request.shio_number === null){
                            //For local, need to emit to trigger existing SRS function for sending BOss with PDF 
                            // if(srsCancelRes.status >= 200 && srsCancelRes.status < 300){
                            if (srsCancelRes.data.message === "Failed to update, plan do not exists.") {
                                Swal.fire({
                                    html: '<div style="text-align: left;font-size:22px;font-weight:bold;">' +
                                        '仕様検討ツールが未作成・保存の為、CAD依頼送信ができません。.<br>' +
                                        'SRSにて作成保存してください。.<br><br>' +
                                        'CAD request cannot be sent because Shiyo request has not been created or saved. .<br><br>' +
                                        'Please create and save it in SRS.',
                                    icon: 'warning',
                                    width : 630,
                                });
                                this.Logger('warning', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) NO INPUT FROM THE PLANNER YET`, 1);
                                return;
                            }    
                        }else{
                            if (srsCancelRes.data.message === "Successfully updated"){
                                this.Logger('info', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) SRS Data successfully sent to boss`, 1);
                            }
                            let tmpCRSObj = {
                                dispatchType: 'request',
                                functionType: 'SRSSend',
                                constructionCode: constructionCode,
                                planNumber: revisionNumber,
                                shiyoNumber: shiyoNumber,
                                email: this.$store.state.loggedInUser.email,
                                CRSShiyoRequest: '2',
                                remarks: 'send boss and hrd data'
                            };
                            this.$socket.emit("newUpdate", tmpCRSObj);

                        }
                        
                    } catch (error) {
                        this.Logger('error', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) SRS DATA WAS NOT SENT TO BOSS`, 1);
                        console.error("API call failed:", error);
                    }
                }
            }


            // RESTRICTION IF FINAL PLAN
            // if(this.$store.state.cadRequestRevisionContent.final_plan && (this.$store.state.cadRequestRevisionContent.color_pers == null || this.$store.state.cadRequestRevisionContent.house_presentation == null || this.$store.state.cadRequestRevisionContent.color_pers == 0 || this.$store.state.cadRequestRevisionContent.house_presentation == 0) ){
            //     Swal.fire({
            //         html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
            //             '着手図面依頼以降は、カラーパースでの色上方<br>' +
            //             'を指示しての依頼は対応不可となります。<br><br>',
            //         icon: 'warning',
            //         width : 630,
            //     });
            //     this.$store.state.radio = null;
            //     return;
            // }

            //  NOTE : SRS DATA CONFIRMATION
            if(this.$store.state.cadRequestRevisionContent.shio_request){
                // const url = `http://10.169.141.136:4000/api/checkPlanIfExist?construction_code=${this.$store.state.cadRequestBasicInformation.construction_code}&plan_no=${this.cadRequestRevisionContent.revision}`;
                // const url = `https://srs-test.ihs-w.com/api/checkPlanIfExist?construction_code=${this.$store.state.cadRequestBasicInformation.construction_code}&plan_no=${this.cadRequestRevisionContent.revision}`;
                const url = `https://srs.hrd-s.com/api/checkPlanIfExist?construction_code=${this.$store.state.cadRequestBasicInformation.construction_code}&plan_no=${this.cadRequestRevisionContent.revision}`;
                // if(this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "1" && this.$store.state.cadRequestRevisionContent.SRS_request.shio_number == null){
                    try {
                        const response = await fetch(url);
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                            const data = await response.json();
                        
                        
                        if ((this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "1" || this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "3") && data.length !== 0 && data.plan_status_code === 0) {
                        // if (this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == "1" && data.length !== 0 && data.plan_status_code === 0) {
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                                'SRSが未送信のため、CAD依頼送信ができません。<br>' +
                                'SRSを送信してから、再度CAD依頼送信を行って下さい。<br><br>',
                            icon: 'warning',
                            width : 630,
                        });
                        return;
                        }else if(this.$store.state.cadRequestRevisionContent.SRS_request.shio_number && data.length === 0) {
                            Swal.fire({
                                html: '<div style="text-align: left;font-size:22px;font-weight:bold;">' +
                                    '仕様検討ツールが未作成・保存の為、CAD依頼送信ができません。.<br>' +
                                    'SRSにて作成保存してください。.<br><br>' +
                                    'CAD request cannot be sent because Shiyo request has not been created or saved. .<br><br>' +
                                    'Please create and save it in SRS.',
                                icon: 'warning',
                                width : 630,
                            });
                            this.Logger('warning', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) SRS was clicked, but no SRS data was created.`, 1);
                            return;
                        } 
                        
                    } catch (error) {
                        console.error("Error checking plan status:", error);
                        console.log('not yet sent');
                    }
                    

            }

            // START OF RESTRICTION FOR ATTACHMENT
            // CASE 2 IF CAD AND DENKI WITHOUT ATTACHMENT
            if((this.$store.state.revisionSelection == '1' || this.$store.state.revisionSelection == '2' || this.$store.state.revisionSelection == '3' || this.$store.state.revisionSelection == '4' || (this.$store.state.revisionSelection == '5'
                && (this.$store.state.subRevision == '5A' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5C'))) && this.$store.state.getFileAttachment[0].length === 0  // CAD WITHOUT
                && (this.cadRequestRevisionContent.electrical_drawing.pdr_title != null || (this.cadRequestRevisionContent.electrical_drawing.denki_plan_title == '電気図面依頼' && this.cadRequestRevisionContent.electrical_drawing.OPTION_1 == 'あり' && this.cadRequestRevisionContent.electrical_drawing.OPTION_2 == 'なし')) // DENKI WITHOUT
                && ((this.$store.state.getFileAttachment[0].length === 0 && ((this.$store.state.getPrevAttach.length === 0 || this.$store.state.getPrevAttach.length !== 0 ) && !this.$store.state.getPrevAttach.includes("CAD"))) 
                && (this.$store.state.getFileAttachment[5].length === 0 && ((this.$store.state.getPrevAttach.length === 0 || this.$store.state.getPrevAttach.length !== 0 ) && !this.$store.state.getPrevAttach.includes("電気図面/提案電気図面依頼書"))))){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                            '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br>' +
                            '<b style="font-size:22px;">【CAD/配置図(PDF/iCAD DBデータ)】</b><br>' +
                            '<b style="font-size:22px;">【電気図面/提案電気図面依頼書(PDF)】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    return;
            }

            // NOTE - MODIFIED DEC022025 - UARY - SSD25-0507783-2159
            // CASE 1 FOR FILE ATTACHMENT -> NEED TO ATTACH CAD
            if(this.$store.state.cadRequestRevisionContent.site_layout === '手入力M' && this.$store.state.getFileAttachment[0].length === 0 
                && ((this.$store.state.getPrevAttach.length === 0 || this.$store.state.getPrevAttach.length !== 0) && !this.$store.state.getPrevAttach.includes("CAD"))){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の下記項目に資料が添付がされておりません。 <br>' +
                            '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br>' +
                            '<b style="font-size:22px;">【CAD/配置図(PDF/iCAD DBデータ)】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    return;
            }

            
            // CASE 2 FOR FILE ATTACHMENT
            if((this.$store.state.getFileAttachment[5].length === 0 && (this.$store.state.getPrevAttach.length === 0 || this.$store.state.getPrevAttach.length !== 0) && !this.$store.state.getPrevAttach.includes("電気図面/提案電気図面依頼書")) 
                && this.cadRequestRevisionContent.electrical_drawing && (this.cadRequestRevisionContent.electrical_drawing.pdr_title != null 
                || (this.cadRequestRevisionContent.electrical_drawing.denki_plan_title == '電気図面依頼' && this.cadRequestRevisionContent.electrical_drawing.OPTION_1 == 'あり' && this.cadRequestRevisionContent.electrical_drawing.OPTION_2 == 'なし'))){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                            '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br>' +
                            '<b style="font-size:22px;">【電気図面/提案電気図面依頼書(PDF)】</b>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    return;
            }
            // CASE 3 WITH DENKI ATTACHMENT BUT WITHOUT DENKI INPUT
            if((this.$store.state.getFileAttachment[5].length > 0 || (this.$store.state.getPrevAttach.length > 0 && this.$store.state.getPrevAttach.includes("電気図面/提案電気図面依頼書"))) && this.cadRequestRevisionContent.electrical_drawing.pdr_title == null && this.cadRequestRevisionContent.electrical_drawing.denki_plan_title == null){
                Swal.fire({
                    html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                        'CAD依頼添付資料の【電気図面/提案電気図面依<br>' +
                        '(PDF)】に資料が添付がされておりますが<br>' +
                        'CAD依頼入力欄にて指示がされておりません。<br><br>' +
                        '<b style="font-size:22px;">【電気図面依頼(提案電気図面依頼含む)】</b>',
                    icon: 'warning',
                    width : 650,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return;
            }

            // FOR DXF FILE ATTACHMENT RESTRICTION
            if(this.$store.state.cadRequestRevisionContent.site_layout == '新規データN' && (this.$store.state.cadRequestRevisionContent.site_layout_option == 'option2' || this.$store.state.cadRequestRevisionContent.site_layout_option == 'option3') 
                && (this.$store.state.getFileAttachment[1].length === 0 && (this.$store.state.getPrevAttach.length === 0 || this.$store.state.getPrevAttach.length !== 0) && !this.$store.state.getPrevAttach.includes("現況図（CADデータ）"))) {
                Swal.fire({
                    html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                        'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                        '所定の位置に資料を添付していただき、再度送信お願い致します。<br>' +
                        '<b style="font-size:22px;">【現況図（DXF）】</b>',
                    icon: 'warning',
                    width : 650,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return;
            } 

            if(this.$store.state.cadRequestRevisionContent.site_layout != '新規データN' && this.$store.state.cadRequestRevisionContent.site_layout_option == null 
                && (this.$store.state.getFileAttachment[1].length > 0 || (this.$store.state.getPrevAttach.length > 0 && this.$store.state.getPrevAttach.includes("現況図（CADデータ）")))) {
                Swal.fire({
                    html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                        'CAD依頼添付資料の【現況図（DXF）】に資料が添付がされておりますが<br>' +
                        'CAD依頼入力欄にて指示がされておりません。<br><br><br>' +
                        '<b style="font-size:22px;">【 添付ファイル参照（現況図のみ）】</b><br>' +
                        '<b style="font-size:22px;">または</b><br>' +
                        '<b style="font-size:22px;">【添付ファイル参照（現況図及び敷地断面図）】</b>',
                    icon: 'warning',
                    width : 690,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return;
            }
            // ATTACHMENT FOR STRUCTURAL REQUEST IF ARI
            if((this.cadRequestRevisionContent.structural_request && this.cadRequestRevisionContent.structural_request.OPTION_1 == 'あり') 
                && (this.$store.state.getFileAttachment[3].length === 0  && ((this.$store.state.getPrevAttach.length === 0 || this.$store.state.getPrevAttach.length !== 0) && !this.$store.state.getPrevAttach.includes("区画図")))
                && (this.cadRequestBasicInformation.house_type_id != '3' && this.cadRequestBasicInformation.house_type_id != '29' && this.cadRequestBasicInformation.house_type_id != '22' && this.cadRequestBasicInformation.house_type_id != '35' && this.cadRequestBasicInformation.house_type_id != '37' && this.cadRequestBasicInformation.house_type_id != '38' && this.cadRequestBasicInformation.house_type_id != '39') // HUGme, HUGme Fam, I-Smile II, I-smile III, HUGme famW , I-Smile IIIW, I-Smile-IIIW+,
                && this.cadRequestBasicInformation.house_type_category == 2 && (this.$store.state.revisionSelection != '8' && this.$store.state.revisionSelection != '9')){
                Swal.fire({
                    html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                        'CAD依頼添付資料の下記項目に資料が添付がされておりません。<br>' +
                        '所定の位置に資料を添付していただき、再度送信お願い致します。<br><br><br>' +
                        '<b style="font-size:22px;">【区画図(SWDI※iCADから出⼒)】</b>',
                    icon: 'warning',
                    width : 690,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return;
            }
            if((this.cadRequestRevisionContent.structural_request == null || this.cadRequestRevisionContent.structural_request.OPTION_1 == 'なし') 
                && (this.cadRequestBasicInformation.house_type_id != '3' && this.cadRequestBasicInformation.house_type_id != '29' && this.cadRequestBasicInformation.house_type_id != '22' && this.cadRequestBasicInformation.house_type_id != '35' && this.cadRequestBasicInformation.house_type_id != '37' && this.cadRequestBasicInformation.house_type_id != '38' && this.cadRequestBasicInformation.house_type_id != '39') // HUGme, HUGme Fam, I-Smile II, I-smile III, HUGme famW , I-Smile IIIW, I-Smile-IIIW+,
                && (this.$store.state.getFileAttachment[3].length > 0 || (this.$store.state.getPrevAttach.length > 0 && this.$store.state.getPrevAttach.includes("区画図")))) {
                Swal.fire({
                    html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                        'CAD依頼添付資料の【区画図(SWDI※iCADから出⼒)】に資料が添付がされておりますが<br>' +
                        'CAD依頼入力欄にて指示がされておりません。<br><br><br>' +
                        '<b style="font-size:22px;">【 構造事前検討依頼】→あり</b>',
                    icon: 'warning',
                    width : 690,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return;
            }
            // HRD PROCESS AND CPN NEED ATTACHMENT
            if((this.$store.state.revisionSelection == '8' || this.$store.state.revisionSelection == '9') && this.$store.state.isHrdCpn == false && this.$store.state.getFileAttachment[0].length === 0) {
                Swal.fire({
                    html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                        'There is no detected attached file. Please attach a <br>' +
                        'document in the attachment field stated below.<br><br>' +
                        '<b style="font-size:22px;">【CAD/配置図(PDF/iCAD DBデータ)】</b>',
                    icon: 'warning',
                    width : 650,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return;
            }
            // END OF RESTRICTION FOR ATTACHMENT

            // CONDITION FOR EXPRESS - OLD
            // await axios({
            //     method : 'post',
            //     url : 'api/xml_bundle_express_tom'
            // }).then((r) => {
            //     if(r.data > 0 && this.$store.state.cadRequestRevisionContent.express == 1){
            //         Swal.fire({
            //             html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
            //                 '<span style="color:blue">本日または翌営業日完了予定の即日CAD依頼数が上限となりました。<span> <br>' +
            //                 '<span style="color:blue">翌営業日または翌々営業日以降の完了予定となります。<span> <br>',
            //             icon: 'warning',
            //             width : 650,
            //             allowOutsideClick: false,
            //             allowEscapeKey: false,
            //         });
            //         return
            //     }
            // })

            // CONDITION FOR EXPRESS - NEW SSD25-0819783-2269
            await axios({
                method : 'post',
                url : 'api/getTodayExpressCount'
            }).then((r) => {
                if(r.data > 30 && this.$store.state.cadRequestRevisionContent.express == 1){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                            '<span style="color:blue">本日または翌営業日完了予定の即日CAD依頼数が上限となりました。<span> <br>' +
                            '<span style="color:blue">翌営業日または翌々営業日以降の完了予定となります。<span> <br>',
                        icon: 'warning',
                        width : 650,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    return
                }
            })

            const files = this.$store.state.attachments;

            // NOTE -  RESTRICTION FOR ALLOWING OF ATTACHMENT - DEC022025 - SSD25-0507783-2159
            // if(files.length === 0){
            //     if(this.$store.state.revisionSelection === '1'){
            //         if(this.$store.state.cadRequestRevisionContent.site_layout === '新規データN' && (this.$store.state.cadRequestRevisionContent.site_layout_option == 'option2' || this.$store.state.cadRequestRevisionContent.site_layout_option == 'option3')
            //         && this.$store.state.getFileAttachment[1].length === 0){
            //             return;
            //         }
                    
            //     }else{
            //         console.log('ibang radio button');
            //         return;
            //     }
            // }
            
            // NOTE - COMMENTED DEC122025
            if (!files || files.length === 0) {
                const showWarning = () => {
                    Swal.fire({
                        html: '<div style="text-align: left;font-size:22px;font-weight:bold;">' +
                            'アップロードするファイルが選択されていません.<br>' +
                            'No file has been selected to upload.',
                        icon: 'warning',
                        width: 630,
                    });
                };

                const state = this.$store.state;
                const isRevision = 
                    state.revisionSelection == '6' || 
                    (state.revisionSelection == '5' && state.subRevision == '5D') || 
                    ((state.revisionSelection == '8' || state.revisionSelection == '9') && state.isHrdCpn);

                if (!isRevision) {
                    showWarning();
                    return;
                }

                const content = state.cadRequestRevisionContent;
                const opt1 = content.electrical_drawing?.OPTION_1;
                const opt2 = content.electrical_drawing?.OPTION_2;
                const isElectricalComplete = (opt1 === 'あり' && opt2 === 'あり');
                const isElectricalPartial = (opt1 === 'あり' || opt2 === 'あり') && !isElectricalComplete;

                if (isElectricalPartial || content.electrical_drawing?.radioPdr?.length || content.site_layout === '新規データN') {
                    showWarning();
                    return;
                }

                const hasValidContent = 
                    content.design_contract === false ||
                    content.site_layout === '前回ベースP' || 
                    content.dxf_data_request === true || 
                    content.calculation_basis === 1 || 
                    content.color_pers === '1' ||
                    Boolean(content.house_presentation_int) ||
                    isElectricalComplete ||
                    content.cross_section === 1 || 
                    content.elevation_section === 1 ||
                    content.alvs?.length > 0 ||
                    state.cad_request_house_presentation?.length > 0;

                if (!hasValidContent && !content.design_contract) {
                    showWarning();
                    return;
                }
            }

            if (this.envDB == 'hrd_cad_request'){

                let rev1 = null;
                let rev2 = null;
                let explodeRevision = this.$store.state.cadRequestRevisionContent.revision.split("-")
                if(explodeRevision[0].length == 1){
                    rev1 = `0${explodeRevision[0]}`;
                }else{
                    rev1 = explodeRevision[0]
                }

                if(explodeRevision[1].length == 1){
                    rev2 = `0${explodeRevision[1]}`;
                }else if(explodeRevision[1].length == 2){
                    if(/[a-zA-Z]/.test(explodeRevision[1])){
                        rev2 = `0${explodeRevision[1]}`;
                    }else{
                        rev2 = explodeRevision[1];
                    }
                }else{
                    rev2 = explodeRevision[1];
                }
                this.mergedFilename = `${this.$store.state.cadRequestBasicInformation.construction_code}-${rev1}${rev2}-`;
            } else {
                this.mergedFilename = `${this.$store.state.cadRequestBasicInformation.construction_code}-${this.$store.state.cadRequestRevisionContent.revision}-`;
            }
            

            this.pathName = this.$store.state.cadRequestBasicInformation.construction_code;
            
            // this.$store.state.cadRequestRevisionContent.hrd_id = generateHRDID(357)
            this.$store.state.cadRequestRevisionContent.timezone = this.userTimezone;
            this.loader = true;

            const main_data = {
                status: 'SAVED',
                basicInformation: this.$store.state.cadRequestBasicInformation,
                latestRevision: this.$store.state.cadRequestLatestRevision,
                revisionContent: this.$store.state.cadRequestRevisionContent,
                cadRequestColorPers : this.$store.state.cadRequestColorPers,
                cad_request_house_presentation : this.$store.state.cad_request_house_presentation,
                cad_request_pdr : this.$store.state.cadRequestPdr,
                additionalAttachments: this.$store.state.additionalAtachments,
            }

            var formdata = new FormData();
            formdata.append('data', JSON.stringify(main_data));
            
            await axios({
                method:'POST',
                url: 'api/save-cad-revision',
                data: formdata
            }).then( async ({ data }) => {
                if(data.status != 'success'){
                    Swal.fire({
                        icon: 'error',
                        title: `Error `,
                        text: `${data.error}`,
                    })
                    this.loader = false;
                    return false;
                }else{
                    await this.handleFileUpload(this.$store.state.attachments,data.cad_id,main_data,data.ext);
                    await this.getScheduleAfterSave(data.cad);
                    await this.$refs.dialogAttachmentForm.clearTest()
                    await this.getCadActualData();
                    await this.testMerging();
                    if(data.cad.revision_type != '10') {
                        // await this.testMerging();
                        this.loader = false;
                    } else if (data.cad.revision_type == '10') { // eto ay pag apply next cad request yung plano.
                        // await this.getCadActualData();
                        this.loader = false;
                        await this.emptyAll();
                    }
                    this.$refs.dialogElectricalDrawing.closetoggleDialogElectricalDrawing();
                }
            }).catch(error => {
                alert(error , "save Cad Request");
            });
            
        },

        //NOTE - START OF CHANGES MADE BY UARY 2025/03/19
        async handleFileUpload(files,cad_id,main,ext) {
            // NEWLY ADDED LINE - FEB232026
            
            const CHUNK_SIZE = 1024 * 1024 * 5; // 5MB
            const url = 'api/upload-chunk';
            let isFirstLoop = true; 

            for (const [index, file] of files.entries()) { // ADD 121325
                const base64Data = file.data.split(',')[1]; 
                const byteCharacters = atob(base64Data);
                const byteArrays = [];

                
                for (let offset = 0; offset < byteCharacters.length; offset += CHUNK_SIZE) {
                const slice = byteCharacters.slice(offset, offset + CHUNK_SIZE);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, { type: 'application/pdf' });
                const totalChunks = Math.ceil(blob.size / CHUNK_SIZE);
                let chunkNumber = 0;
                let final_path;
                let finalFilename;
                let user = this.$store.state.loggedInUser.email;

                
                while (chunkNumber < totalChunks) {
                    const start = chunkNumber * CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, blob.size);
                    const chunk = blob.slice(start, end);

                    const formData = new FormData();
                    formData.append('file', chunk, file.name);
                    formData.append('chunkNumber', chunkNumber);
                    formData.append('totalChunks', totalChunks);
                    formData.append('filename', file.name);
                    formData.append('column_name', file.column_name);
                    formData.append('page_count', file.page_count);
                    formData.append('cad_id', cad_id);
                    formData.append('data', JSON.stringify(main))
                    formData.append('ext', ext)
                    formData.append('fileIndex', index);
                    try {
                       const response = await axios.post(url, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round(
                                ((chunkNumber * CHUNK_SIZE + progressEvent.loaded) / blob.size) * 100
                                );
                                
                            },
                        });

                        final_path = response.data.finalPath;
                        finalFilename = response.data.finalFilename;
                        chunkNumber++;
                        
                    } catch (error) {
                        console.error('Error uploading chunk:', error);
                        break;
                    }

                    if(chunkNumber == totalChunks){
                        try {
                            const finalFormData = new FormData();
                            
                            finalFormData.append('user', user);
                            finalFormData.append('final_path', final_path);
                            finalFormData.append('finalFilename', finalFilename)
                            finalFormData.append('column_name', file.column_name);
                            finalFormData.append('page_count', file.page_count);
                            finalFormData.append('cad_id', cad_id);
                            finalFormData.append('fileIndex', index); // ADD 121325

                            if (!isFirstLoop) {
                                main.additionalAttachments = [];
                            }
                            finalFormData.append('data', JSON.stringify(main));
                            finalFormData.append('ext', ext);

                            const response2 = await axios.post('api/merge-chunk', finalFormData, {
                            headers: { 'Content-Type': 'multipart/form-data' }
                            });
                            this.Logger('info', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) File uploaded successfully`, 1);

                        } catch (error) {
                            console.error('Error merging chunk:', error);
                            this.Logger('error', this.$store.state.loggedInUser.email, 'PlannersTable.vue', `(${this.$store.state.cadRequestBasicInformation.construction_code} ${this.cadRequestRevisionContent.revision}) Error merging of chunk`, 1);
                        }
                    }
                    
                }
                isFirstLoop = false;
            }
        },


    // END OF SAVING, UPDATING AND MERGING OF PDF FORMS AND CAD DATA
        emptyAll(){
            this.$store.state.cadRequestRevisionContent = {
                revision: null,
                design_contract: false,
                calculation_basis: false,
                site_layout: null,
                gravity_type: null,
                gravity : null,
                isHrdCpn: null,
                kakouirai_reason : null,
                // boss_sending: 0,
                site_layout_option: null,
                site_diagram: null,
                new_site_diagram: null,
                // site_boss: null,
                specs_irai: { 
                    sash_type: null,  
                    specs: null,  
                    accessories: [],
                    honeycomb: null,  
                    },
                dxf_data_request: null,
                color_pers: null,
                house_presentation: null,
                house_presentation_int : null,
                shio_request: null,
                SRS_request: {
                    shio_selection: null,
                    shio_number: null,
                },
                web_documents: null,
                jiban_plan: null,
                alvs: null,
                status: null,
                structural_request: null,
                pdr: null,
                denki_gravity: null,
                electrical_drawing: null,
                cross_section: null,
                elevation_section: null,
                stop: null,
                final_plan: null,
                express: null,
                request_attach_from: null,
                stopListSelection: null,
            };
            // this.$store.state.cadRequestRevisionContent = [];
            this.$store.state.cadRequestColorPers = [];
            this.$store.state.cad_request_house_presentation = [];
            // this.$store.state.cad_request_house_presentation_int = [];
            this.$store.state.attachments = [];
            this.$store.state.hideColorPersTable = null;
            this.$store.state.hideHpTable = null;
            this.$store.state.editCadRequestColorPers = [];
            this.$store.state.edit_cad_request_house_presentation = [];
            // this.$store.state.edit_cad_request_house_presentation_int = [];
            
            this.$store.state.cadRequestLatestRevision = null;
            this.$store.state.hrd_process_stamp = false;
            this.$store.state.hideColorPersTable = null;
            this.$store.state.hideHpTable = null;
            this.toggleB5 = null;
            this.toggleB6_1 = null;
            this.toggleB6_2 = null;
            this.toggleB6_3 = [];
            this.toggleB6_4 = null;

            for(let i = 0; i < 10; i++){
                this.$store.state.getFileAttachment[i] = [];
            }

            this.$store.state.additionalAtachments = [];
        },
        confirmDrawingRequest(value){
            if(!value){
                if(this.editMode) this.$set(this.$store.state.editCadRequestRevisionContent, 'express', false)
                else this.$set(this.$store.state.cadRequestRevisionContent, 'express', false)
            }

            if(this.editMode) this.$set(this.$store.state.editCadRequestRevisionContent, 'final_plan', value)
            else this.$set(this.$store.state.cadRequestRevisionContent, 'final_plan', value)

            if(this.cadRequestRevisionContent.express) {
                this.disableOtherExpress = true;
            } else {
                this.disableOtherExpress = false;
            }

        },

    // NOTE : OPEN DIALOG FOR BOSS SCHEDULE THAT IS ALREADY REGISTERED
        async openBossSched(index){
            this.loader = true;
            let cadData = this.existingRevisions[index]
            let schedule = [];
            let XmlData = []
            // this.bossSchedDialog = true;
            await axios({
                method: "POST",
                url: "api/xml_bundle_cad_id",
                data: {
                    cad_id : cadData.id
                }
            }).then( async ({data}) => {
                if(data){
                    if(this.loggedInUser.is_admin != 1 && this.loggedInUser.plan_control != 1 && this.loggedInUser.is_hrd_requestor != 1){
                        data.filter((res) => {
                            let temp = null;
                            if(res.plan_type_name && res.boss_code){
                                temp = `${res.plan_type_name}(${res.boss_code})`
                            }else if (res.plan_type_name && !res.boss_code){
                                temp = `${res.plan_type_name}`
                            }else if (!res.plan_type_name && res.boss_code){
                                temp = `${res.boss_code}`
                            }
                            if(res.display == 1){
                                schedule.push({
                                    plan_type: temp,
                                    due_day: res.due_day ? moment(res.due_day).format('YYYY/MM/DD HH:mm') : null,
                                    due_day_boss: res.due_day_boss ? moment(res.due_day_boss).format('YYYY/MM/DD HH:mm') : null,
                                    cad_remarks: res.cad_remarks,
                                    boss_code: res.boss_code,
                                    hrd_id: res.HRD_ID,
                                    code_number: res.code_number,
                                    received_day: res.received_day,
                                    plan_number: res.plan_number,
                                    // due_day: res.due_day,
                                    remarks: res.cad_remarks,
                                    file: null,
                                    id: res.cad_request_id,
                                    xml_id: res.xml_id,
                                    cad_xml_id: res.id,
                                    code_arrangement: res.code_arrangement,
                                    HRD_ID: res.HRD_ID
                                })
                            }
                        })
                    }else{
                        data.filter((res) => {
                            let temp = null;
                            if(res.plan_type_name && res.boss_code){
                                temp = `${res.plan_type_name}(${res.boss_code})`
                            }else if (res.plan_type_name && !res.boss_code){
                                temp = `${res.plan_type_name}`
                            }else if (!res.plan_type_name && res.boss_code){
                                temp = `${res.boss_code}`
                            }
                            schedule.push({
                                plan_type: temp,
                                due_day: res.due_day ? moment(res.due_day).format('YYYY/MM/DD HH:mm') : null,
                                due_day_boss: res.due_day_boss ? moment(res.due_day_boss).format('YYYY/MM/DD HH:mm') : null,
                                cad_remarks: res.cad_remarks,
                                boss_code: res.boss_code,
                                HRD_ID: res.HRD_ID,
                                code_number: res.code_number,
                                received_day: res.received_day,
                                plan_number: res.plan_number,
                                // due_day: res.due_day,
                                remarks: res.cad_remarks,
                                file: null,
                                id: res.cad_request_id,
                                xml_id: res.xml_id,
                                cad_xml_id: res.id,
                                code_arrangement: res.code_arrangement,
                                HRD_ID: res.HRD_ID
                            })
                        })
                    }

                    // Sort the `schedule` array by the "plan_type" property
                    schedule.sort((a, b) => {
                        if (a.boss_code === 'B18' && b.boss_code === 'B18') {
                            return a.remarks.localeCompare(b.remarks);
                        }
                        if (a.boss_code === 'P65' && b.boss_code === 'P65') {
                            return a.remarks.localeCompare(b.remarks);
                        }
                        if ((a.boss_code === '832' && b.boss_code === '832') ||
                            (a.boss_code === 'S88' && b.boss_code === 'S88') || 
                            (a.boss_code === '606' && b.boss_code === '606')
                        ) {
                            return a.remarks.localeCompare(b.remarks);
                        }
                    });
                    // schedule.sort((a, b) => a.plan_type.localeCompare(b.plan_type));

                    // Assign the sorted array to your store state
                    this.$store.state.bossScheduleData = schedule;
                    this.loader = false;
                    this.toggleDialogBossSchedule(true)
                }
            })

        },
    // END

    // NOTE : PARENT - CHILD FUNCTIONS
        submitShioRequest(value){
            if(value){
                if(!this.editMode){
                    this.$set(this.$store.state.cadRequestRevisionContent, 'shio_request', true);
                    this.$set(this.$store.state.cadRequestRevisionContent, 'SRS_request', value);
                }else{
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'shio_request', true);
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'SRS_request', value);

                    console.log(this.$store.state.editCadRequestRevisionContent.shio_selection, 'edit shio')
                }
            }
        },
        submitElevation(value){
            if(value){
                if(value.crossSection != null){
                    this.$store.state.cadRequestRevisionContent.cross_section = value.crossSection
                } else {
                    this.$store.state.cadRequestRevisionContent.cross_section = null
                }

                if(value.elevationDrawing != null){
                    this.$store.state.cadRequestRevisionContent.elevation_section = value.elevationDrawing
                } else {
                    this.$store.state.cadRequestRevisionContent.elevation_section = null
                }

                if(value.crossSection == null && value.elevationDrawing == null) {
                    this.$store.state.cadRequestRevisionContent.cross_section = null
                    this.$store.state.cadRequestRevisionContent.elevation_section = null
                }
            }

            if(this.editMode){
                if(value.crossSection != null){
                    this.$store.state.editCadRequestRevisionContent.cross_section = value.crossSection
                } else {
                    this.$store.state.editCadRequestRevisionContent.cross_section = null
                }

                if(value.elevationDrawing != null){
                    this.$store.state.editCadRequestRevisionContent.elevation_section = value.elevationDrawing
                } else {
                    this.$store.state.editCadRequestRevisionContent.elevation_section = null
                }

                if(value.crossSection == null && value.elevationDrawing == null) {
                    this.$store.state.editCadRequestRevisionContent.cross_section = null
                    this.$store.state.editCadRequestRevisionContent.elevation_section = null
                }
            }
            
        },

        submitStop(value){  
            if(value){
                this.$store.state.structural_request = {
                        OPTION_ZEH : null,
                        OPTION_GX : null,
                        OPTION_1 : value[0].option1 == '1' ? 'あり' : value[0].option1 == '0' ? 'なし' : null,
                        OPTION_2 : value[0].option2 == '1' ? 'あり' : value[0].option2 == '0' ? 'なし' : null,
                        OPTION_W : null,
                        OPTION_S : null,
                    }
                if(this.editMode) {
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'structural_request', this.$store.state.structural_request)
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stopListSelection', value)
                    // this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', true);
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', this.stop2_selection);
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', '1'); 
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'design_contract', true); 
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'shio_request', true); 
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true); 
                }else{
                    this.$set(this.$store.state.cadRequestRevisionContent, 'structural_request', this.$store.state.structural_request)
                    this.$set(this.$store.state.cadRequestRevisionContent, 'stopListSelection', value)
                    this.$set(this.$store.state.cadRequestRevisionContent, 'stopListSelection', value)
                    // this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true);
                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', this.stop2_selection);
                    this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1'); 
                    this.$set(this.$store.state.cadRequestRevisionContent, 'design_contract', true); 
                    this.$set(this.$store.state.cadRequestRevisionContent, 'shio_request', true); 
                    this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true); 
                } 
            }
            
        },

        submitSiteLayout(value){
            if(value){
                this.toggleB5 = '新規データN'
                this.$set(this.$store.state.cadRequestRevisionContent, 'site_layout', '新規データN');
                this.$store.state.cadRequestRevisionContent.site_layout = '新規データN';

                if(this.$store.state.cadRequestRevisionContent.site_layout == '新規データN'){
                    // this.$store.state.cadRequestRevisionContent.boss_sending = value.bossSite;
                    this.$store.state.cadRequestRevisionContent.site_layout_option = value.siteLayoutOption;
                    this.$store.state.cadRequestRevisionContent.site_diagram = value.siteDiagram;
                    // this.$store.state.cadRequestRevisionContent.site_boss = value.bossRadio;
                } else {
                    // this.$store.state.cadRequestRevisionContent.boss_sending = 0;
                    this.$store.state.cadRequestRevisionContent.site_layout_option = null;
                    this.$store.state.cadRequestRevisionContent.site_diagram = 'なし';
                    // this.$store.state.cadRequestRevisionContent.site_boss = null;
                }
            }

            if(this.editMode){
                this.editToggleB5 = '新規データN'
                this.$set(this.$store.state.editCadRequestRevisionContent, 'site_layout', '新規データN');
                // this.$store.state.editCadRequestRevisionContent.site_layout = '新規データN';

                if(this.$store.state.editCadRequestRevisionContent.site_layout == '新規データN'){
                    // this.$store.state.editCadRequestRevisionContent.boss_sending = value.bossSite;
                    this.$store.state.editCadRequestRevisionContent.site_layout_option = value.siteLayoutOption;
                    this.$store.state.editCadRequestRevisionContent.site_diagram = value.siteDiagram;
                    // this.$store.state.editCadRequestRevisionContent.site_boss = value.bossRadio;
                } else {
                    // this.$store.state.editCadRequestRevisionContent.boss_sending = 0;
                    this.$store.state.cadRequestRevisionContent.site_layout_option = null;
                    this.$store.state.editCadRequestRevisionContent.site_diagram = 'なし';
                    // this.$store.state.editCadRequestRevisionContent.site_boss = null;
                }
            }
        },

        cancelSubmit(value){
            if(!value){
                this.toggleB5 = null;
                this.dialogSiteLayout = false;
                this.$store.state.cadRequestRevisionContent.site_layout = null;
                // this.$store.state.cadRequestRevisionContent.boss_sending = 0;
                this.$store.state.cadRequestRevisionContent.site_layout_option = null;
                this.$store.state.cadRequestRevisionContent.site_diagram = 'なし';
                // this.$store.state.cadRequestRevisionContent.site_boss = null;
            }
            // if(this.editMode) this.$set(this.$store.state.editCadRequestRevisionContent, 'final_plan', value)
            // else this.$set(this.$store.state.cadRequestRevisionContent, 'final_plan', value)
        },

        submitNewSiteLayout(value){
            if(value){
                this.toggleB5 = '前回ベースP';
                this.$set(this.$store.state.cadRequestRevisionContent, 'site_layout', '前回ベースP');
                this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';

                if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                    this.$store.state.cadRequestRevisionContent.new_site_diagram = value.newSiteDiagram;
                    // this.$store.state.cadRequestRevisionContent.new_site_boss = value.newBossRadio;
                } else {
                    this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし';
                    // this.$store.state.cadRequestRevisionContent.new_site_boss = null;
                }
            }

            if(this.editMode){
                this.toggleB5 = '前回ベースP';
                this.$set(this.$store.state.editCadRequestRevisionContent, 'site_layout', '前回ベースP');
                this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';

                if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                    this.$store.state.editCadRequestRevisionContent.new_site_diagram = value.newSiteDiagram;
                    // this.$store.state.editCadRequestRevisionContent.new_site_boss = value.newBossRadio;
                } else {
                    this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし';
                    // this.$store.state.editCadRequestRevisionContent.new_site_boss = null;
                }
            }
        },

        cancelNewSubmit(value){
            if(!value){
                this.toggleB5 = null;
                this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし';
                this.dialogNewSiteLayout = false;
            }
        },

        submitProposal(value){
            this.$store.state.cadRequestPdr = value
            
        },

        cancelProposal(value){
            this.dialogDenkiRequest = false;
        },

        submitPdr(value){
            if(this.editMode) this.$set(this.$store.state.editCadRequestRevisionContent, 'denki_gravity', '大きな変更 (L)')
            
            if(value == 1 || value == 2 || value == 3) {
                this.$store.state.cadRequestRevisionContent.denki_gravity = '大きな変更 (L)';
                this.$set(this.$store.state.cadRequestRevisionContent, 'pdr', '1') 
            } else {
                this.$store.state.cadRequestRevisionContent.denki_gravity = null;
                this.$set(this.$store.state.cadRequestRevisionContent, 'pdr', null)
            }

            // if(value == 4) {
            //     this.$store.state.cadRequestRevisionContent.denki_gravity = null;
            //     this.$set(this.$store.state.cadRequestRevisionContent, 'pdr', null)
            // }

            if(this.editMode){
                this.$store.state.editCadRequestRevisionContent.denki_gravity = value;
                this.$set(this.$store.state.editCadRequestRevisionContent, 'pdr', '1')
            } else {
                this.$store.state.editCadRequestRevisionContent.denki_gravity = null;
                this.$set(this.$store.state.editCadRequestRevisionContent, 'pdr', null)
            }
        },

        cancelElevation(value){
            if(!value){
                this.$store.state.cadRequestRevisionContent.cross_section = null;
                this.$store.state.cadRequestRevisionContent.elevation_section = null;
            }
        },

        cancelPdr(value){
            if(!value){
                this.$store.state.cadRequestRevisionContent.denki_gravity = null;
                this.$set(this.$store.state.cadRequestRevisionContent, 'pdr', null)
            }
        },

        storeInt(value){
                if(this.editMode) this.$set(this.$store.state.editCadRequestRevisionContent, 'house_presentation_int', value)
                else this.$set(this.$store.state.cadRequestRevisionContent, 'house_presentation_int', value)
        },

        closeInt(value){
            if(!value){
                this.$store.state.cadRequestRevisionContent.house_presentation_int = null;
                this.$set(this.$store.state.cadRequestRevisionContent, 'house_presentation_int', null)
                this.$set(this.$store.state.editCadRequestRevisionContent, 'house_presentation_int', null)
            }
        },

        async confirmBoss(value){
            if(value){
                this.sendToLocal = null;
                this.loader = true
                if(this.newExpressPlan){
                    // ! IF PREVIOUS IS NOT EXPRESS THEN NEW REGISTRATION IS EXPRESS, NEED TO DELETE PREVIOUS DATA
                    await axios({
                        method: "POST",
                        url: "api/deleteExisting",
                        data : this.existingRevisions[this.registerIndex]
                    }).then(async ({data}) => {
                        let finalData = data.xml.map((r) => {
                            r.file = data.file ? data.file : null;
                            return r;
                        });
                        // ! DELETE ALSO IN BOSS
                        if(data){
                            await this.triggerSocketBossSending(finalData, 'DELETE');
                        }else{
                            alert(data);
                            return;
                        }
                    })
                }
                // ! THEN SAVE NEW DATA
                    this.sendToLocal = await saveToXML(
                        value, 
                        this.newExpressPlan, 
                        this.existingRevisions[this.registerIndex], 
                        this.cadRequestBasicInformation,
                        this.plannerDetails,
                        this.salesmanDetails,
                        this.houseTypeFromSocket,
                        this.dataFromCi,
                        this.powerId,
                        this.loggedInUser,
                        this.$store.state.registerDate,
                        
                    );
                    await this.getCadActualData();
                    console.log(this.sendToLocal, 'saved')
                    // this.sendToLocal = savedData;
                    if(this.sendToLocal) await this.hrdAcceptFunction(this.registerIndex, 'dynamic')

            }
        },

        confirmElectricalDrawing(value){
            if(this.editMode) {
                this.$set(this.$store.state.editCadRequestRevisionContent,'electrical_drawing', value)
            } else {
                this.$set(this.$store.state.cadRequestRevisionContent,'electrical_drawing', value)
                // if(value.pdr_title == '提案電気図面依頼'){
                //     this.dialogDenkiRequest = true
                // } else {
                //     this.dialogDenkiRequest = false
                // }
            }
            
            // NOTE : FOR ATTACHMENT TRAPPING
            this.$store.state.getDrawingRequest = value.selectedDrawing;
        },

        confirmStructuralRequest(value){
            // GET STOP LENGTH
            const filteredStop = this.$store.state.existingRevisions.filter((res) => {
                return res.stop == 1;
            })
            let stopLength = filteredStop.length;

            // GET KAKO(3,4) AND STOP LENGTH
            const filteredKako = this.$store.state.existingRevisions.filter((kako) => {
                return kako.revision_number !== undefined && (kako.kakouirai_reason === 3 || kako.kakouirai_reason === 4) && kako.stop === '1';
            });
            const lengthOfFilteredRevisions = filteredKako.length;
            
            this.disableExpress = false
            if(value){
                if(this.$store.state.editMode){
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'structural_request', value);

                    if(this.$store.state.structOrStop == 'stop'){
                        if((this.$store.state.loggedInUser.plan_control == 1 || this.$store.state.loggedInUser.is_admin == 1) && this.$store.state.cadRequestBasicInformation.sent_process_request_date == null) {
                            this.stopPlan = stopLength + 1;
                            // FIRST TIME REQUEST ADMIN/PC
                            if(this.stopPlan > 0) {
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        // this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', true);
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false);
                                }
                            }
                        } else if((this.$store.state.loggedInUser.plan_control != 1 && this.$store.state.loggedInUser.is_admin != 1) && this.$store.state.cadRequestBasicInformation.sent_process_request_date == null) {
                            this.stopPlan = stopLength + 1;
                            // FIRST TIME REQUEST PLANNER
                            if(this.stopPlan < 2){
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false);
                                }
                            }
                            if(this.stopPlan >= 2 && this.stop2_selection == '1') {
                                if(value.OPTION_1 == 'あり'){
                                    Swal.fire({
                                        html: '<div style="text-align: center;font-size:20px;font-weight:bold;color:black;">' +
                                            '１物件に対して、STOPチェックは１回のみ依頼可能です。<br>' +
                                            '（長期物件または加工ストップ物件は除く）<br>' +
                                            'STOPチェックが複数回必要な場合は、設計部にご相談ください。<br>',
                                        icon: 'warning',
                                        width : 650,
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                    });
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'structural_request', null) 
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false) 
                                    return;
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false);
                                }
                            }else if(this.stopPlan >= 2 && this.stop2_selection == '2'){
                                if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false) 
                                }
                            }
                        }
                        // W/DATA OF KAKOUIRAI & REASON IS 3 OR 4
                        if(this.$store.state.cadRequestBasicInformation.sent_process_request_date != null && (this.$store.state.cadRequestBasicInformation.kakouirai_reason == 3 || this.$store.state.cadRequestBasicInformation.kakouirai_reason == 4)) {
                            this.kakoStopPlan = lengthOfFilteredRevisions + 1;
                            if(this.kakoStopPlan > 0 && (this.$store.state.loggedInUser.is_admin == 1 || this.$store.state.loggedInUser.plan_control == 1)){
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false);
                                } 
                            } else if(this.kakoStopPlan === 2 && (this.$store.state.loggedInUser.is_admin != 1 && this.$store.state.loggedInUser.plan_control != 1)) {
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false);
                                }
                            } else if (this.kakoStopPlan > 2 && (this.$store.state.loggedInUser.is_admin != 1 && this.$store.state.loggedInUser.plan_control != 1)) {
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:20px;font-weight:bold;color:black;">' +
                                        '１物件に対して、STOPチェックは１回のみ依頼可能です。<br>' +
                                        '（長期物件または加工ストップ物件は除く）<br>' +
                                        'STOPチェックが複数回必要な場合は、設計部にご相談ください。<br>',
                                    icon: 'warning',
                                    width : 650,
                                });
                                this.$set(this.$store.state.editCadRequestRevisionContent, 'structural_request', null) 
                                return; 
                            }
                        } 
                        // W/DATA OF KAKOUIRAI & REASON IS 1 OR 2
                        if(this.$store.state.cadRequestBasicInformation.sent_process_request_date != null && (this.$store.state.cadRequestBasicInformation.kakouirai_reason== 1 || this.$store.state.cadRequestBasicInformation.kakouirai_reason == 2)){
                            this.stopPlan = stopLength + 1;
                            if(this.stopPlan > 0 && (this.$store.state.loggedInUser.is_admin == 1 || this.$store.state.loggedInUser.plan_control == 1)) {
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false);
                                }
                            } else if (this.kakoStopPlan < 2 && (this.$store.state.loggedInUser.is_admin != 1 && this.$store.state.loggedInUser.plan_control != 1)) {
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:20px;font-weight:bold;color:black;">' +
                                        '１物件に対して、STOPチェックは１回のみ依頼可能です。<br>' +
                                        '（長期物件または加工ストップ物件は除く）<br>' +
                                        'STOPチェックが複数回必要な場合は、設計部にご相談ください。<br>',
                                    icon: 'warning',
                                    width : 650,
                                });
                                this.$set(this.$store.state.editCadRequestRevisionContent, 'structural_request', null) 
                                return; 
                            }
                        }

                        if((this.stop2_selection == '1' || this.stop2_selection == '2') &&
                            (this.$store.state.revisionSelection == '6' || this.$store.state.subRevision == '5D')) {
                            const isAdminOrPlanControl = this.$store.state.loggedInUser.is_admin == 1 || this.$store.state.loggedInUser.plan_control == 1;
                            const isNonAdminBlocked = this.stop2_selection == '1' && !isAdminOrPlanControl && this.stopPlan >= 2;
                            // radio 2: always warn for admin/plan_control and non-admin
                            // radio 1: warn for admin/plan_control, or non-admin when radio is enabled
                            if(this.stop2_selection == '2' || isAdminOrPlanControl || !isNonAdminBlocked) {
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:20px;font-weight:bold;">' +
                                        'STOPチェックはCAD変更に影響する可能性があります。<br>' +
                                        '図面番号入力で「CAD図面番号の変更なし」を選択しないでください。',
                                    icon: 'warning',
                                    width : 715,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                });
                                this.$set(this.$store.state.editCadRequestRevisionContent, 'structural_request', null);
                                this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false);
                                return;
                            }
                        }
                    }
                    
                        if(this.editCadRequestRevisionContent.calculation_basis || this.editCadRequestRevisionContent.jiban_plan ||
                            (this.editCadRequestRevisionContent.alvs && this.editCadRequestRevisionContent.alvs != "") ||
                            (this.editCadRequestRevisionContent.structural_request && this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.editCadRequestRevisionContent.stop){
                                this.disableExpress = true;
                                this.$store.state.editCadRequestRevisionContent.express = false
                        }else{
                                this.disableExpress = false;
                        }
                }else{
                    // NOT EDIT
                    this.$set(this.$store.state.cadRequestRevisionContent, 'structural_request', value) 
                    if(this.$store.state.structOrStop == 'stop'){

                        if((this.$store.state.loggedInUser.plan_control == 1 || this.$store.state.loggedInUser.is_admin == 1) && this.$store.state.cadRequestBasicInformation.sent_process_request_date == null) {
                            this.stopPlan = stopLength + 1;
                            if(this.stopPlan > 0) {
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        // this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true);
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false);
                                }
                            }
                        }
                        if((this.$store.state.loggedInUser.plan_control != 1 && this.$store.state.loggedInUser.is_admin != 1) && this.$store.state.cadRequestBasicInformation.sent_process_request_date == null) {
                            this.stopPlan = stopLength + 1;
                            if(this.stopPlan < 2){
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false);
                                }
                            }
                            if(this.stopPlan >= 2 && this.stop2_selection == '1') {
                                if(value.OPTION_1 == 'あり'){
                                    Swal.fire({
                                        html: '<div style="text-align: center;font-size:20px;font-weight:bold;color:black;">' +
                                            '１物件に対して、STOPチェックは１回のみ依頼可能です。<br>' +
                                            '（長期物件または加工ストップ物件は除く）<br>' +
                                            'STOPチェックが複数回必要な場合は、設計部にご相談ください。<br>',
                                        icon: 'warning',
                                        width : 650,
                                    });
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'structural_request', null) 
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false) 
                                    return;
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false) 
                                }
                            }else if(this.stopPlan >= 2 && this.stop2_selection == '2'){
                                if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false) 
                                }
                            }
                        }

                        // W/DATA OF KAKOUIRAI & REASON IS 3 OR 4
                        if(this.$store.state.cadRequestBasicInformation.sent_process_request_date != null && (this.$store.state.cadRequestBasicInformation.kakouirai_reason == 3 || this.$store.state.cadRequestBasicInformation.kakouirai_reason == 4)) {
                            this.kakoStopPlan = lengthOfFilteredRevisions + 1;
                            if(this.kakoStopPlan !== 0 && (this.$store.state.loggedInUser.is_admin == 1 || this.$store.state.loggedInUser.plan_control == 1)){
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false);
                                } 
                            }
                            if(this.kakoStopPlan < 2 && (this.$store.state.loggedInUser.is_admin != 1 && this.$store.state.loggedInUser.plan_control != 1)) {
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false);
                                }
                            }
                            if(this.kakoStopPlan === 2 && (this.$store.state.loggedInUser.is_admin != 1 && this.$store.state.loggedInUser.plan_control != 1)) {
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false);
                                }
                            } else if (this.kakoStopPlan > 2 && this.$store.state.loggedInUser.is_admin != 1 && this.$store.state.loggedInUser.plan_control != 1) {
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:20px;font-weight:bold;color:black;">' +
                                        '１物件に対して、STOPチェックは１回のみ依頼可能です。<br>' +
                                        '（長期物件または加工ストップ物件は除く）<br>' +
                                        'STOPチェックが複数回必要な場合は、設計部にご相談ください。<br>',
                                    icon: 'warning',
                                    width : 650,
                                });
                                this.$set(this.$store.state.cadRequestRevisionContent, 'structural_request', null) 
                                return; 
                            }
                        } 

                        // W/DATA OF KAKOUIRAI & REASON IS 1 OR 2
                        if(this.$store.state.cadRequestBasicInformation.sent_process_request_date != null && (this.$store.state.cadRequestBasicInformation.kakouirai_reason== 1 || this.$store.state.cadRequestBasicInformation.kakouirai_reason == 2)){
                            this.stopPlan = stopLength + 1;
                            if(this.stopPlan > 0 && (this.$store.state.loggedInUser.is_admin == 1 || this.$store.state.loggedInUser.plan_control == 1)) {
                                if(value.OPTION_1 == 'あり'){
                                    // this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true);
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', this.stop2_selection);
                                    if(value.OPTION_1 == 'あり' || (value.OPTION_S || value.OPTION_W)){
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1'); 
                                        this.$store.state.alvsSelection = true;
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'design_contract', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'shio_request', true); 
                                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true); 
                                    }
                                }else if(value.OPTION_1 == 'なし' || value.OPTION_1 == null){
                                    this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false);
                                }
                            } else if (this.kakoStopPlan < 2 && (this.$store.state.loggedInUser.is_admin != 1 && this.$store.state.loggedInUser.plan_control != 1)) {
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:20px;font-weight:bold;color:black;">' +
                                        '１物件に対して、STOPチェックは１回のみ依頼可能です。<br>' +
                                        '（長期物件または加工ストップ物件は除く）<br>' +
                                        'STOPチェックが複数回必要な場合は、設計部にご相談ください。<br>',
                                    icon: 'warning',
                                    width : 650,
                                });
                                this.$set(this.$store.state.cadRequestRevisionContent, 'structural_request', null) 
                                return; 
                            }
                        }

                        if((this.stop2_selection == '1' || this.stop2_selection == '2') &&
                            (this.$store.state.revisionSelection == '6' || this.$store.state.subRevision == '5D')) {
                            const isAdminOrPlanControl = this.$store.state.loggedInUser.is_admin == 1 || this.$store.state.loggedInUser.plan_control == 1;
                            const isNonAdminBlocked = this.stop2_selection == '1' && !isAdminOrPlanControl && this.stopPlan >= 2;
                            // radio 2: always warn for admin/plan_control and non-admin
                            // radio 1: warn for admin/plan_control, or non-admin when radio is enabled
                            if(this.stop2_selection == '2' || isAdminOrPlanControl || !isNonAdminBlocked) {
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:20px;font-weight:bold;">' +
                                        'STOPチェックはCAD変更に影響する可能性があります。<br>' +
                                        '図面番号入力で「CAD図面番号の変更なし」を選択しないでください。',
                                    icon: 'warning',
                                    width : 715,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                });
                                this.$set(this.$store.state.cadRequestRevisionContent, 'structural_request', null);
                                this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false);
                                return;
                            }
                        }
                    }
                    if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                        this.cadRequestRevisionContent.alvs || (this.cadRequestRevisionContent.structural_request && this.cadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.cadRequestRevisionContent.stop){
                            this.disableExpress = true;
                            this.$store.state.cadRequestRevisionContent.express = false
                    }else{
                            this.disableExpress = false;
                    }
                }
            }
        },

        confirmAlvs(value){

            if(this.editMode){
                if( typeof value == 'object'){  // > L,S,V,LS,LV,VS

                    if(value.includes('V') && value.includes('S')){     // > VS
                        this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', 'VS') 
                    }else{                                              // >  L,S,V,LS,LV
                        const joinedValue = value.sort().join('') 
                        this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', joinedValue) 
                    }

                }else{
                    this.$set(this.$store.state.editCadRequestRevisionContent, 'alvs', true) 
                }
                // NOTE : IF ALVS IS NOT NULL - DISABLE EXPRESS
                    if(this.editCadRequestRevisionContent.calculation_basis || this.editCadRequestRevisionContent.jiban_plan ||
                        this.editCadRequestRevisionContent.alvs || this.editCadRequestRevisionContent.stop){
                            this.disableExpress = true;
                            this.$store.state.editCadRequestRevisionContent.express = false
                    }else{
                        this.disableExpress = false
                    }
            }else{
                if( typeof value == 'object'){  // > L,S,V,LS,LV,VS

                    if(value.includes('V') && value.includes('S')){     // > VS
                        this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', 'VS') 
                    }else{                                              // >  L,S,V,LS,LV
                        const joinedValue = value.sort().join('') 
                        this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', joinedValue) 
                    }

                }else{
                    this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', true) 
                }

                // NOTE : IF ALVS IS NOT NULL - DISABLE EXPRESS
                    if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                        this.cadRequestRevisionContent.alvs || this.cadRequestRevisionContent.stop){
                            this.disableExpress = true;
                            this.$store.state.cadRequestRevisionContent.express = false
                    }else{
                        this.disableExpress = false
                    }
            }

            this.disableExpress = false
            if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                this.cadRequestRevisionContent.alvs || (this.cadRequestRevisionContent.structural_request && this.cadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.cadRequestRevisionContent.stop){
                    this.disableExpress = true;
                    this.$store.state.cadRequestRevisionContent.express = false
            }else{
                    this.disableExpress = false;
            }
        },

        proceedToNext(value){
        },

        color_perspective(value){
        },

        house_presentation(value){
        },
    
        confirmJibanPlan(){
            const filteredRevisions = this.$store.state.existingRevisions.filter((res) => {
                return res.jiban_plan !== null && res.jiban_plan !== undefined && res.jiban_plan !== 0; 
            });
            let totalFilteredLength = filteredRevisions.length; // Kukuhanin nito kung ilan na yung merong jiban plan
        
            if(this.editMode) {
                // RESTRICTION FOR JIBAN PLAN IF 3RD TIME REQUEST
                if (this.$store.state.loggedInUser.plan_control == 1 || this.$store.state.loggedInUser.is_admin == 1) {
                    // this.jibanPlan = totalFilteredLength + 1;
                    // if(this.jibanPlan > 0)  {
                    //     this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true)
                    // } 
                    if(this.$store.state.jibanData >= 3 && !this.editCadRequestRevisionContent.stop) {
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;color:black;">' +
                                'カラー配置図（測定点入）の３回以上(STOPチェック時は除く)<br>' +
                                'となる依頼は不可となります。<br>' +
                                '詳細は設計部へご確認お願い致します。<br>' +
                                '</div>',
                            icon: 'warning',
                            width : 650,
                        }).then((r) => {
                            this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true)
                        });
                    } else {
                        this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true)
                    }             
                } else if (this.$store.state.loggedInUser.plan_control != 1 && this.$store.state.loggedInUser.is_admin != 1) {
                    // this.jibanPlan = totalFilteredLength + 1;
                    if(this.$store.state.jibanData >= 3 && !this.editCadRequestRevisionContent.stop) {
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;color:black;">' +
                                'カラー配置図（測定点入）の３回以上(STOPチェック時は除く)<br>' +
                                'となる依頼は不可となります。<br>' +
                                '詳細は設計部へご確認お願い致します。<br>' +
                                '</div>',
                            icon: 'warning',
                            width : 650,
                        });
                        this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', false)
                    } else {
                        this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', true)
                    }
                }
                
                if(this.editCadRequestRevisionContent.calculation_basis || this.editCadRequestRevisionContent.jiban_plan ||
                    (this.editCadRequestRevisionContent.alvs && this.editCadRequestRevisionContent.alvs != "") ||
                    (this.editCadRequestRevisionContent.structural_request && this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.editCadRequestRevisionContent.stop){
                        this.disableExpress = true;
                        this.$store.state.editCadRequestRevisionContent.express = false
                }else{
                    this.disableExpress = false;
                }
            }else{
            // RESTRICTION FOR JIBAN PLAN IF 3RD TIME REQUEST
                if (this.$store.state.loggedInUser.plan_control == 1 || this.$store.state.loggedInUser.is_admin == 1) {
                    if(this.$store.state.jibanData >= 3 && !this.cadRequestRevisionContent.stop) {
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;color:black;">' +
                                'カラー配置図（測定点入）の３回以上(STOPチェック時は除く)<br>' +
                                'となる依頼は不可となります。<br>' +
                                '詳細は設計部へご確認お願い致します。<br>' +
                                '</div>',
                            icon: 'warning',
                            width : 650,
                        }).then((r) => {
                            this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true)
                        });
                    } else {
                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true)
                    }             
                } else if (this.$store.state.loggedInUser.plan_control != 1 && this.$store.state.loggedInUser.is_admin != 1) {
                    // this.jibanPlan = totalFilteredLength + 1;
                    if(this.$store.state.jibanData >= 3 && !this.cadRequestRevisionContent.stop) {
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:19px;font-weight:bold;color:black;">' +
                                'カラー配置図（測定点入）の３回以上(STOPチェック時は除く)<br>' +
                                'となる依頼は不可となります。<br>' +
                                '詳細は設計部へご確認お願い致します。<br>' +
                                '</div>',
                            icon: 'warning',
                            width : 650,
                        });
                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', false)
                    } else {
                        this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', true)
                    }
                }

                // EXPRESS RESTRICTION
                if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                    this.cadRequestRevisionContent.alvs || (this.cadRequestRevisionContent.structural_request && this.cadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.cadRequestRevisionContent.stop){
                        this.disableExpress = true;
                        this.$store.state.cadRequestRevisionContent.express = false
                }else{
                        this.disableExpress = false;
                }
            } 
        },

        submitWebDocumentSelection(value){
                // '①プラン提案資料' = 1
                // '②収納提案資料' = 2
                // '③住設提案資料' = 3
                // '④サッシ提案資料' = 4
                // '⑤内装資料' = 5
                // '⑥電気提案資料' = 6
                // '⑦照明提案資料' = 7
            // CONDITION FOR WEB DOCUMENT SELECTION
            if(value){
                if(this.editMode){
                    // NEW CONDITION - MODIFIED DEC062025 - UARY
                    if (this.$store.state.editCadRequestRevisionContent.SRS_request) {
                        this.$store.state.editCadRequestRevisionContent.shio_request = true;

                        // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                            // this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';

                            // console.log(this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection, 'edit');
                            // console.log(this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection), 'hindi';
                            
                            // if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                            //     this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                            // } 
                        }else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        }  else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '0'){
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                            
                        }
                        // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '1'){
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '1';
                            
                        }
                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '3'){
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '3';
                            
                        } 
                    } else {
                        this.$store.state.editCadRequestRevisionContent.shio_request = false;
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = null;
                    }
                } else {
                    // NOTE - NEW CONDITION - MODIFIED DEC062025 - UARY
                    if(this.$store.state.cadRequestRevisionContent.SRS_request){
                        this.$store.state.cadRequestRevisionContent.shio_request = true;

                        // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                            // NOTE - NEW CONDITION - JARED
                            if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                                this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                            } 
                        } else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        }  else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '0'){
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        }
                        // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '1'){
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '1';
                        }
                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '3'){
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '3';
                        }
                        
                    } else {
                        this.$store.state.cadRequestRevisionContent.shio_request = false;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = null;
                    }
                }

                let showElectric = value.filter((edd) => {
                    return edd.value === 6 || edd.value === 7;
                })

                if(showElectric.length > 0){
                    this.dialogElectricalDrawing = true; 
                } else {
                    this.dialogElectricalDrawing = false;
                }
            }


            this.$nextTick(() => {
                // Sorting for number - Old docu
                if(this.$store.state.editMode){
                    this.$store.state.editCadRequestRevisionContent.web_documents = [...value].sort((a,b) => a.value - b.value )
                }else{
                    this.$store.state.cadRequestRevisionContent.web_documents = [...value].sort((a,b) => a.value - b.value )
                }
            })
        },

        toggleSnackBar(){
            this.snackbar.show = false;
            this.snackbar.text = '';
        },

        backToTarget() {
            const target = document.querySelector('#design_contract');
            const targetPosition = target.offsetTop;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        },

        highlight(){
            this.isHighlighted = true;
            this.snackbar.text = 'Revision';
            this.snackbar.show = true;
            
            setTimeout(() => {
                this.isHighlighted = false;
            }, 3000);
        },

        toggleDialogDrawingRequest(value){
            if(value){
                this.dialogDrawingRequest = true;
            }else{
                this.dialogDrawingRequest = false;
            }
        },

        toggleDialogAttachmentForm(value){
            if(value){
                this.dialogAttachmentForm = true;
            }else{
                this.dialogAttachmentForm = false;
            }
            
        },

        toggleDialogPreviousAttachmentForm(value){
            if(value){
                this.dialogPreviousAttachmentForm = true;
            }else{
                this.dialogPreviousAttachmentForm = false;
            }
            
        },

        toggleDialogSiteLayout(value){
            if(value){
                this.dialogSiteLayout = true;
            }else{
                this.dialogSiteLayout = false;
            }
            
        },

        toggleDialogNewSiteLayout(value){
            if(value) {
                this.dialogNewSiteLayout = true;
            } else {
                this.dialogNewSiteLayout = false;
            }
        },

        toggleDialogPdr(value){
            if(value){
                this.dialogPdr = true;
            } else {
                this.dialogPdr= false;
            }
        },

        toggleDialogDenkiRequest(value){
            if(value){
                this.dialogDenkiRequest = true;
            } else {
                this.dialogDenkiRequest= false;
            }
        },

        toggleDialogElevationRequest(value){
            if(value){
                this.dialogElevation = true;
            } else {
                this.dialogElevation = false;
            }
        },

        toggleDialogStop(value){
            if(value){
                this.dialogStop = true;
            } else {
                this.dialogStop= false;
            }
        },

        toggleDialogShioRequest(value){
            if(value){
                this.dialogShioRequest = true;
            } else {
                this.dialogShioRequest= false;
            }
        },

        toggleBossListDialog(value){
            if(value){
                this.dialogBossList = true;
            } else {
                this.dialogBossList= false;
            }
        },

        toggleDialogBossSchedule(value){
            if(value){
                this.dialogBossSchedule = true;
            } else {
                this.dialogBossSchedule= false;
            }
        },

        toggleDialogElectricalDrawing(value){
            if(value){
                this.dialogElectricalDrawing = true;
            }else{
                this.dialogElectricalDrawing = false;
            }
        },

        toggleDialogStructuralRequest(value, from){
            if(value){
                this.dialogStructuralRequest = true;
            }else{
                this.dialogStructuralRequest = false;
            }
        },

        confirmStop2(){
            this.dialogStop2 = false; 
            if(!this.editMode){
                this.$set(this.$store.state.cadRequestRevisionContent, 'stop', this.stop2_selection)
                // console.log(this.$store.state.cadRequestRevisionContent, 'stop new content')
            }else{
                this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', this.stop2_selection);
                // console.log(this.$store.state.editCadRequestRevisionContent, 'stop  edit content')
            }
            this.toggleDialogStructuralRequest(true)
        },

        toggleDialogAlvs(value){
            if(value){
                this.dialogAlvs = true;
            }else{
                this.dialogAlvs = false;
            }
        },

        toggleDialogConfirmationItems(value){
            if(value){
                this.dialogConfirmationItems = true;
            }else{
                this.dialogConfirmationItems = false;
            }
        },

        toggleDialogWebDocuments(value){
            if(value){
                this.dialogWebDocuments = true;
            }else{
                this.dialogWebDocuments = false;
            }
        },

        toggleDialogHousePresentation(value){
            if(value){
                this.dialogHousePresentation = true;
                this._getHpRestrictionPerHouseType();
                this._getHpObjName()
                // this.finalPlanSiyo(this.$store.state.cadRequestBasicInformation.construction_code); // comment due to no tbl_final_plan found in HRDSQL2
            }else{
                this.dialogHousePresentation = false;
            }
            
            this.housePresentation = false
        },

        toggleDialogHousePresentationInt(value){
            if(value) {
                this.dialogHousePresentationInt = true;
            } else {
                this.dialogHousePresentationInt = false;
            }
        },

        toggleDialogColorPerspective(value){
            if(value){
				this.dialogColorPerspective = true;
                this._getColorPersRestriction();
                this._getColorPersObjName()
                // this.finalPlanSiyo(this.$store.state.cadRequestBasicInformation.construction_code); // comment due to no tbl_final_plan found in HRDSQL2
			}else{
				this.dialogColorPerspective = false;
			}
            this.colorPers = false
        },

        toggleCadRequest(header, object = {}){ // > object default value, kung may ipasa na value, yun yung value nya. kung wala empty object lang sya
            if(!this.editMode){
                if(!this.$store.state.cadRequestLatestRevision){
                    if(header != 'request_attach_form_previous'){
                        this.highlight()
                        return
                    }
                }
                // this.$refs.dialogAttachmentForm.clearTest()

                let value = null;
                switch (header) {
                    case 'design_contract':
                        value = this.$store.state.cadRequestRevisionContent[header];
                        this.$set(this.$store.state.cadRequestRevisionContent, header, !value) 	
                        break;
                    case 'calculation_basis':
                        value = this.$store.state.cadRequestRevisionContent[header];
                        this.$set(this.$store.state.cadRequestRevisionContent, header, !value) 
                        // this.disableExpress = !value ? true : false;
                        // this.disableExpress = true;
                        this.$store.state.cadRequestRevisionContent.express = false;
                        if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                            this.cadRequestRevisionContent.alvs || (this.cadRequestRevisionContent.structural_request && this.cadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.cadRequestRevisionContent.stop){
                                this.disableExpress = true;
                        }else{
                            this.disableExpress = false;
                        }
                        break;
                    case 'site_layout':
                        if(object.text == '新規データN'){
                            this.toggleDialogSiteLayout(true)
                            return;
                        }

                        if(object.text == '前回ベースP'){
                            this.toggleDialogNewSiteLayout(true)
                            return;
                        }

                        value = this.$store.state.cadRequestRevisionContent[header];
                        this.$set(this.$store.state.cadRequestRevisionContent, header, object.text)
                        break;
                    case 'specs_irai':
                        this.$nextTick(() => {
                            const allowedSpecsIrai = ['sash_type', 'specs', 'accessories', 'honeycomb'];
                            if(allowedSpecsIrai.includes(object.selection)){
                                if(object.selection == 'accessories'){
                                    this.$store.state.cadRequestRevisionContent[header][object.selection].splice(0)
                                    this.toggleB6_3.map(res => this.$store.state.cadRequestRevisionContent[header][object.selection].push(res))
                                }
                                // else{
                                //     this.$set(this.$store.state.cadRequestRevisionContent[header], object.selection, object.text)
                                // }

                                if(object.selection == 'specs') {
                                    if (this.$store.state.cadRequestRevisionContent[header].specs === object.text) {
                                        this.$store.state.cadRequestRevisionContent[header].specs = null;
                                    } else {
                                        this.$store.state.cadRequestRevisionContent[header].specs = object.text;
                                    }
                                } 

                                if(object.selection == 'sash_type') {
                                    if (this.$store.state.cadRequestRevisionContent[header].sash_type === object.text) {
                                        this.$store.state.cadRequestRevisionContent[header].sash_type = null;
                                    } else {
                                        this.$store.state.cadRequestRevisionContent[header].sash_type = object.text;
                                    }
                                } 

                                if(object.selection == 'honeycomb') {
                                    if (this.$store.state.cadRequestRevisionContent[header].honeycomb === object.text) {
                                        this.$store.state.cadRequestRevisionContent[header].honeycomb = null;
                                    } else {
                                        this.$store.state.cadRequestRevisionContent[header].honeycomb = object.text;
                                    }
                                }

                            }
                            this.cadRequestRevisionContent.specs_irai.accessories.filter((r) => {
                                if(r === 'マスA' && (this.cadRequestBasicInformation.house_type_id == '1' || this.cadRequestBasicInformation.house_type_id == '18' || this.cadRequestBasicInformation.house_type_id == '31'||
                                    this.cadRequestBasicInformation.house_type_id == '32' || this.cadRequestBasicInformation.house_type_id == '33')) {
                                    Swal.fire({
                                        html: '<div style="text-align: center;font-size:26px;font-weight:bold;">' +
                                            '※GRAND SMART・i-smartはマスA選択不可',
                                        icon: 'warning',
                                        width : 630,
                                    });
                                    // this.toggleB6_3 = [];
                                    this.toggleB6_3 = this.toggleB6_3.filter(item => item !== 'マスA');
                                    this.cadRequestRevisionContent.specs_irai.accessories = this.cadRequestRevisionContent.specs_irai.accessories.filter(item => item !== 'マスA');
                                    return;
                                }
                            })
                        })
                        break;
                    case 'dxf_data_request':
                        value = this.$store.state.cadRequestRevisionContent[header];
                        this.$set(this.$store.state.cadRequestRevisionContent, header, !value) 
                        break;
                    case 'color_pers':
                        this.toggleDialogColorPerspective(true)
                        this.colorPers = true
                        setTimeout(() => {
                            this.colorPers = false
                        }, 2000);
                        break;
                    case 'house_presentation':
                        this.toggleDialogHousePresentation(true)
                        this.housePresentation = true;
                        setTimeout(() => {
                            this.housePresentation = false
                        }, 2000);
                        break;
                    case 'house_presentation_int':
                        this.toggleDialogHousePresentationInt(true)
                        break;
                    case 'shio_request':
                        if(this.$store.state.cadRequestBasicInformation.provisional_contract_date == null && this.$store.state.cadRequestBasicInformation.contract_date == null){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                '仮契約⽇または本契約⽇が基本情報に反映されていないため<br>' +
                                '「仕様検討ツール」を依頼することができません。<br>' +
                                '契約済みの場合は、基本情報にて契約⽇を⼊⼒してください。',
                            icon: 'warning',
                            width : 730,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            })
                            return;
                        }
                        //  UNSELECTABLE shio IF WITH PDR  && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection != null
                        // if(this.$store.state.cadRequestRevisionContent.electrical_drawing && ["1", "2", "3"].includes(this.$store.state.cadRequestRevisionContent.electrical_drawing.radioPdr)){
                        
                        //new
                        if( this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                            if(this.$store.state.cadRequestRevisionContent.electrical_drawing && ["1", "2", "3"].includes(this.$store.state.cadRequestRevisionContent.electrical_drawing.radioPdr)){
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                    '提案電気図面時には以下の書類を作成する必要があります。<br>' +
                                    '<br><br><span style="color:blue;"> 仕様検討ツール </span>',
                                    icon: 'warning',
                                    width : 730,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                })
                                return;
                            }
                        }else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                            if(this.$store.state.cadRequestRevisionContent.electrical_drawing && ["1", "2", "3"].includes(this.$store.state.cadRequestRevisionContent.electrical_drawing.radioPdr)){
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                    '提案電気図面時には以下の書類を作成する必要があります。<br>' +
                                    '<br><br><span style="color:blue;"> 仕様検討ツール </span>',
                                    icon: 'warning',
                                    width : 730,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                })
                                return;
                            }
                        }
                        // HRD PROCESS AND CPN SHIO REQUEST WILL NOT BE ABLE TO REMOVE
    
                        // NOTE - COMMENTED 11-24-25 - UARY
                        // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        // NOTE - CODED - 20260624 - BY UARY
                        if( this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2')) && this.$store.state.loggedInUser.can_use_srs != 1){
                                if(this.existingRevisions.length > 0 && this.existingRevisions[this.existingRevisions.length-1].shio_request == 1 && this.$store.state.cadRequestRevisionContent.shio_request != null && (this.$store.state.revisionSelection == '1' || this.$store.state.revisionSelection == '2' || this.$store.state.revisionSelection == '3' || this.$store.state.revisionSelection == '4' 
                                || this.$store.state.subRevision == '5Z' || this.$store.state.subRevision == '5A' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5C') || 
                                (this.$store.state.revisionSelection == '8' && this.cadRequestRevisionContent.isHrdCpn != 1) || (this.$store.state.revisionSelection == '9' && this.cadRequestRevisionContent.isHrdCpn != 1)){
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                    '以前に「仕様検討ツール」依頼がありました。<br>' +
                                    '「仕様検討ツール」依頼の選択を解除できません。<br>' +
                                    '再度「仕様検討ツール」依頼を入力してください。',
                                icon: 'warning',
                                width : 730,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                })
                                return;
                            }
                        } else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                            if(this.existingRevisions.length > 0 && this.existingRevisions[this.existingRevisions.length-1].shio_request == 1 && this.$store.state.cadRequestRevisionContent.shio_request != null && (this.$store.state.revisionSelection == '1' || this.$store.state.revisionSelection == '2' || this.$store.state.revisionSelection == '3' || this.$store.state.revisionSelection == '4' 
                                || this.$store.state.subRevision == '5Z' || this.$store.state.subRevision == '5A' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5C') || 
                                (this.$store.state.revisionSelection == '8' && this.cadRequestRevisionContent.isHrdCpn != 1) || (this.$store.state.revisionSelection == '9' && this.cadRequestRevisionContent.isHrdCpn != 1)){
                                        Swal.fire({
                                            html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                            '以前に「仕様検討ツール」依頼がありました。<br>' +
                                            '「仕様検討ツール」依頼の選択を解除できません。<br>' +
                                            '再度「仕様検討ツール」依頼を入力してください。',
                                        icon: 'warning',
                                        width : 730,
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        })
                                       
                                        return;
                                }
                        }
                       
                        // value = this.$store.state.cadRequestRevisionContent[header];
                        // this.$set(this.$store.state.cadRequestRevisionContent, header, !value)
                        this.HOUSE_TYPES.filter((r) => {
                            if(this.cadRequestBasicInformation.house_type_id == r.id){
                                this.cadRequestBasicInformation.house_type_name = r.name;
                            }
                        });


                        if(this.$store.state.cadRequestRevisionContent.shio_request){
                            if(this.$store.state.loggedInUser.isHokkaidou_planner == 1){
                               this.toggleDialogShioRequest(true);
                            }else{
                                let shiyo = {
                                    shio_selection: null,
                                    shio_number: null,
                                };
                                this.$set(this.$store.state.cadRequestRevisionContent, header, false);
                                this.$set(this.$store.state.cadRequestRevisionContent, 'SRS_request', shiyo);
                            }
                            
                            
                        }else{
                            //  Swal.fire({
                            //     title: "Are you sure you want to make shio request?",
                            //     showDenyButton: true,
                            //     confirmButtonText: "Okay",
                            //     denyButtonText: `Cancel`
                            // }).then((result) => {
                            //     if (result.isConfirmed) {
                                    this.toggleDialogShioRequest(true);
                            //     }
                            // });
                            
                        }

                        break;
                    case 'web_documents':
                        this.toggleDialogWebDocuments(true)
                        break;
                    case 'jiban_plan':
                        if(this.cadRequestRevisionContent.jiban_plan && this.cadRequestRevisionContent.stop){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                'STOPチェック時には以下の書類を作成する必要があります。<br><br>' +
                                'カラー配置図 (測定点入)<br>' +
                                'ALVS検討',
                            icon: 'warning',
                            width : 730,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            })
                            return;
                        }
                        if(this.$store.state.cadRequestRevisionContent.jiban_plan){
                            this.$set(this.$store.state.cadRequestRevisionContent, 'jiban_plan', false)
                            // this.disableExpress = false;
                            if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                                this.cadRequestRevisionContent.alvs || (this.cadRequestRevisionContent.structural_request && this.cadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.cadRequestRevisionContent.stop){
                                    this.disableExpress = true;
                            }else{
                                    this.disableExpress = false;
                            }

                        }else{
                            this.toggleDialogConfirmationItems(true)
                            this.$store.state.cadRequestRevisionContent.express = false;
                            if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                                this.cadRequestRevisionContent.alvs || (this.cadRequestRevisionContent.structural_request && this.cadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.cadRequestRevisionContent.stop){
                                    this.disableExpress = true;
                                    
                            }else{
                                    this.disableExpress = false;
                            }
                        }
                        // if(this.disableOtherExpress == true){
                        //         Swal.fire({
                        //             title: '下記の依頼を即日依頼に含めることはできません。',
                        //             html: '<div style="text-align: left;">' +
                        //                 '・最高高さ・見付面積・平均GL計算根拠 <br>' +
                        //                 '・カラー配置図 (測定点入) <br>' +
                        //                 '・ALVS検討依頼 <br>' +
                        //                 '・構造事前検討依頼 <br>' +
                        //                 '・提案電気図面依頼 <br>' +
                        //                 '・STOP</div>',
                        //             icon: 'warning',
                        //         });
                        //     }

                        
                        break;
                    case 'alvs':
                        if(this.cadRequestRevisionContent.stop && this.cadRequestRevisionContent.alvs){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                'STOPチェック時には以下の書類を作成する必要があります。<br><br>' +
                                'カラー配置図 (測定点入)<br>' +
                                'ALVS検討',
                                icon: 'warning',
                                width : 730,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            })
                            return;
                        }

                        // FOR 3RD TIME AND MORE ALVS REQUEST
                        if (this.$store.state.countOfAlvsRequest && this.$store.state.countOfAlvsRequest >= 2) {
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                                'ALVSは２回までの依頼制限となる予定です。（近日中に対応予定）<br>' +
                                '依頼回数２回以内にできるように設計業務の見直しお願いします。',
                                icon: 'warning',
                                width: 730,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            });
                        }

                        this.toggleDialogAlvs(true)
                        break;
                    case 'structural_request':
                        if(this.$store.state.cadRequestRevisionContent.structural_request){
                            this.$store.state.structural_request = this.$store.state.cadRequestRevisionContent.structural_request;
                        }
                        this.$store.state.structOrStop = 'structural';
                        this.toggleDialogStructuralRequest(true)
                        break;
                    case 'elevation_request':
                        // this.toggleDialogElectricalDrawing(true) // ?? NOT SURE ABOUT THIS
                        // this.toggleDialogElevationRequest(true)

                        // ----- SSD24-1028783-1746 SECOND TIME DANMENZU REQUEST CONDITION -----
                        if (this.$store.state.cadRequestBasicInformation.kakouirai_reason != '' && this.$store.state.cadRequestBasicInformation.kakouirai_reason != null) {
                            this.toggleDialogElevationRequest(true)
                        } else {
                            if (this.loggedInUser.type != 'Admin' && this.loggedInUser.type != 'Plan Control') {
                                let count = this.existingRevisions.filter(item => item.elevation_section || item.cross_section)
                                if (count.length >= 1) {
                                    Swal.fire({
                                        html: '<div style="text-align: center;font-size:20px;font-weight:bold;">' +
                                            '１物件に対して、断面図/申請用立面図は１回のみ依頼可能です。<br>' +
                                            '（長期物件または加工ストップ物件は除く）<br>' +
                                            '断面図/申請用立面図が複数回必要な場合は、設計部にご相談ください。',
                                        icon: 'warning',
                                        width : 715,
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                    });
                                } else {
                                    this.toggleDialogElevationRequest(true)
                                }
                            } else {
                                this.toggleDialogElevationRequest(true)
                            }
                        }

                        break;
                    case 'stop':
                        // this.toggleDialogStructuralRequest(true)
                        // if(this.$store.state.cadRequestRevisionContent.stop){
                        //     this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false) 
                        //     this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1');
                        //     // if (this.$store.state.cadRequestRevisionContent.stop) {
                        //     // }
                        // }else{
                        //     this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true) 
                        //     this.$set(this.$store.state.cadRequestRevisionContent, 'alvs', '1');
                        //     this.toggleDialogStructuralRequest(true)
                        // }
                        // RESTRICTION FOR CAD NASHI
                        // if(this.$store.state.revisionSelection == '6' || this.$store.state.subRevision == '5D'){
                        //     Swal.fire({
                        //             html: '<div style="text-align: center;font-size:20px;font-weight:bold;">' +
                        //                 'STOPチェックはCAD変更に影響する可能性があります。<br>' +
                        //                 '図面番号入力で「CAD図面番号の変更なし」を選択しないでください。',
                        //             icon: 'warning',
                        //             width : 715,
                        //             allowOutsideClick: false,
                        //             allowEscapeKey: false,
                        //         });
                        //     return;
                        // }
                        
                        let code = /^(0009999)/;
                        if(code.test(this.cadRequestBasicInformation.construction_code)){
                            this.toggleDialogStop(true);
                        }else{
                            if(this.$store.state.cadRequestRevisionContent.stop){
                                this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false) 

                            if(this.cadRequestRevisionContent.calculation_basis || this.cadRequestRevisionContent.jiban_plan ||
                                this.cadRequestRevisionContent.alvs || (this.cadRequestRevisionContent.structural_request && this.cadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.cadRequestRevisionContent.stop){
                                    this.disableExpress = true;
                            }else{
                                    this.disableExpress = false;
                            }
                            }else{
                                // this.toggleDialogStructuralRequest(true)
                                const filteredStop = this.$store.state.existingRevisions.filter((res) => {
                                    return res.stop == 1;
                                })
                                this.stopPlan = filteredStop.length + 1;
                                this.dialogStop2 = true
                                this.$store.state.structOrStop = 'stop';
                                // if(this.$store.state.structural_request){
                                //     if(this.$store.state.structural_request.OPTION_1 == 'あり' && this.$store.state.structural_request.OPTION_1 != null){
                                //         this.$set(this.$store.state.cadRequestRevisionContent, 'stop', true) 
                                //     }else{
                                //         this.$set(this.$store.state.cadRequestRevisionContent, 'stop', false) 
                                //     }
                                }
                                
                            }
                        break;
                    case 'pdr':
                        // this.toggleDialogPdr(true)
                        // if(this.$store.state.cadRequestRevisionContent.denki_gravity) {
                        //     value = this.$store.state.cadRequestRevisionContent[header];
                        //     this.$set(this.$store.state.cadRequestRevisionContent, header, !value) 
                        // }
                        break;
                    case 'electrical_drawing':
                        this.toggleDialogElectricalDrawing(true)
                        break;
                    // case 'drawing_request':
                    case 'final_plan':
                        if(this.$store.state.revisionSelection == '6' || this.$store.state.subRevision == '5D'){
                            if (this.$store.state.xmlTable.length === 0) {
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                                        '初回 着手準備依頼はCAD変更に影響する可能性があります。<br>' +
                                        `図面番号入力で<span style="color:blue;">「CAD図面番号の変更なし」</span>を選択しないでください。<br>`,
                                    icon: 'warning',
                                    width : 670,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                });
                                // .then((resulta) => {
                                //     if(resulta.isConfirmed) {
                                //         this.radio = null;
                                //         this.radio3 = null;
                                //         return false;
                                //     }
                                // })
                            }  else {
                                this.toggleDialogDrawingRequest(true)
                            }
                        } else {
                            this.toggleDialogDrawingRequest(true)
                        }
                        break;
                    case 'express':
                        value = this.$store.state.cadRequestRevisionContent[header];
                        if(this.disableExpress == true){
                            Swal.fire({
                                title: '下記の依頼を即日依頼に含めることはできません。',
                                html: '<div style="text-align: left;">' +
                                    '・最高高さ・見付面積・平均GL計算根拠 <br>' +
                                    '・カラー配置図 (測定点入) <br>' +
                                    '・ALVS検討依頼 <br>' +
                                    '・構造事前検討依頼 <br>' +
                                    '・提案電気図面依頼 <br>' +
                                    '・STOP</div>',
                                icon: 'warning',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            });
                        
                        }
                        // FIRST TIME FP FOR EXPRESS PLAN
                        if (this.$store.state.cadRequestRevisionContent.final_plan != null) 
                            if (this.$store.state.xmlTable.length == 0){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                '初回 着手準備依頼はCAD変更に影響する可能性があります。 <br>' +
                                '「<span style="color:red;">即日依頼</span>」としてリクエストすることはできません',
                            icon: 'warning',
                            width : 730,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            })
                            this.$set(this.$store.state.cadRequestRevisionContent, header, !value) 
                        } else {
                            this.$set(this.$store.state.cadRequestRevisionContent, header, !value) 
                        }

                        if(this.cadRequestRevisionContent.express) {
                            this.disableOtherExpress = true;
                        } else {
                            this.disableOtherExpress = false;
                        }
                        break;
                    case 'request_attach_form_previous':
                        this.$store.state.siteBoss = object.existing.site_layout_option
                        this.$store.state.editCadRequestRevisionContent = object.existing;
                        if(object.attachments){
                            object.attachments.forEach((el, ii) => {
                                if(el.att_column_name == 'CAD依頼書結合ファイル'){
                                    let arr = object.attachments.splice(ii, 1)[0];
                                    object.attachments.splice(0, 0, arr)
                                }

                                if(el.att_column_name == 'CAD依頼書'){
                                    let arr = object.attachments.splice(ii, 1)[0];
                                    object.attachments.splice(1, 0, arr)
                                }
                            })
                        this.$store.state.previousAttachmentFiles = object.attachments.filter((r) => {
                                    let type = r.filename.split('.')
                                    r.fileType = type[type.length - 1];

                                return r
                            });
                        }

                        this.toggleDialogPreviousAttachmentForm(true)
                        break;
                    case 'value':
                        break;
                    case 'value':
                        
                        break;
                    case 'request_attach_from':
                            this.$store.state.copyPreviousAttachment = [];
                            if(this.existingRevisions[this.existingRevisions.length - 1]){
                                if(this.existingRevisions[this.existingRevisions.length - 1].attachments){
                                    this.$store.state.copyPreviousAttachment = this.existingRevisions[this.existingRevisions.length - 1].attachments.filter((r) => {
                                        if(r.att_column_name != 'CAD依頼書結合ファイル' && r.att_column_name != 'CAD依頼書'){
                                            return r
                                        }
                                    }) 
                                }
                            }
                        this.toggleDialogAttachmentForm(true)
                        break;
                }
                this.$nextTick(()=> {
                })
            }else{
                let value = null;
                switch (header) {
                    case 'design_contract':
                        value = this.$store.state.editCadRequestRevisionContent[header];
                        this.$set(this.$store.state.editCadRequestRevisionContent, header, !value) 
                        break;
                    case 'calculation_basis':
                        value = this.$store.state.editCadRequestRevisionContent[header];
                        this.$set(this.$store.state.editCadRequestRevisionContent, header, !value) 
                        // this.disableExpress = !value ? true : false;

                        if(this.editCadRequestRevisionContent.calculation_basis || this.editCadRequestRevisionContent.jiban_plan ||
                            this.editCadRequestRevisionContent.alvs || (this.editCadRequestRevisionContent.structural_request && this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.editCadRequestRevisionContent.stop){
                                this.disableExpress = true;
                                this.$store.state.editCadRequestRevisionContent.express = false
                            
                        }else{
                                this.disableExpress = false;
                        }
                        break;
                    case 'site_layout':
                        if(object.text == '新規データN'){
                            this.toggleDialogSiteLayout(true)
                            return;
                        } 
                        if(object.text == '前回ベースP'){
                            this.toggleDialogNewSiteLayout(true)
                            return;
                        } 

                        value = this.$store.state.editCadRequestRevisionContent[header];
                        this.$set(this.$store.state.editCadRequestRevisionContent, header, object.text) 
                        break;
                    case 'specs_irai':

                        this.$nextTick(() => {
                            const allowedSpecsIrai = ['sash_type', 'specs', 'accessories', 'honeycomb'];
                            if(allowedSpecsIrai.includes(object.selection)){
                                if(object.selection == 'accessories'){
                                    this.$store.state.editCadRequestRevisionContent[header][object.selection].splice(0)
                                    this.editToggleB6_3.map(res => this.$store.state.editCadRequestRevisionContent[header][object.selection].push(res))
                                } 

                                if(object.selection == 'specs') {
                                    if (this.$store.state.editCadRequestRevisionContent[header].specs === object.text) {
                                        this.$store.state.editCadRequestRevisionContent[header].specs = null;
                                    } else {
                                        this.$store.state.editCadRequestRevisionContent[header].specs = object.text;
                                    }
                                } 

                                if(object.selection == 'sash_type') {
                                    if (this.$store.state.editCadRequestRevisionContent[header].sash_type === object.text) {
                                        this.$store.state.editCadRequestRevisionContent[header].sash_type = null;
                                    } else {
                                        this.$store.state.editCadRequestRevisionContent[header].sash_type = object.text;
                                    }
                                } 

                                if(object.selection == 'honeycomb') {
                                    if (this.$store.state.editCadRequestRevisionContent[header].honeycomb === object.text) {
                                        this.$store.state.editCadRequestRevisionContent[header].honeycomb = null;
                                    } else {
                                        this.$store.state.editCadRequestRevisionContent[header].honeycomb = object.text;
                                    }
                                }
                                
                            }

                            this.editCadRequestRevisionContent.specs_irai.accessories.filter((r) => {
                                if(r === 'マスA' && (this.$store.state.trapMasua == '1' || this.$store.state.trapMasua == '18' || this.$store.state.trapMasua == '31'||
                                    this.$store.state.trapMasua == '32' || this.$store.state.trapMasua == '33')) {
                                    Swal.fire({
                                        html: '<div style="text-align: center;font-size:26px;font-weight:bold;">' +
                                            '※GRAND SMART・i-smartはマスA選択不可',
                                        icon: 'warning',
                                        width : 630,
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                    });
                                    this.editToggleB6_3 = this.editToggleB6_3.filter(item => item !== 'マスA');
                                    this.editCadRequestRevisionContent.specs_irai.accessories = this.editCadRequestRevisionContent.specs_irai.accessories.filter(item => item !== 'マスA');
                                }
                            })
                        })
                        break;
                    case 'dxf_data_request':
                        value = this.$store.state.editCadRequestRevisionContent[header];
                        this.$set(this.$store.state.editCadRequestRevisionContent, header, !value) 
                        break;
                    case 'color_pers':
                        if(this.beforeEditColorPers.house_type_id != this.editCadRequestRevisionContent.house_type_id) {
                            this.$store.state.editCadRequestColorPers = []
                        }
                        this.toggleDialogColorPerspective(true)
                        this.colorPers = true
                        setTimeout(() => {
                            this.colorPers = false
                        }, 2000);
                        break;
                    case 'house_presentation':
                        if(this.beforeEditHP.house_type_id != this.editCadRequestRevisionContent.house_type_id) {
                            this.$store.state.edit_cad_request_house_presentation = []
                        }
                        this.toggleDialogHousePresentation(true)
                        this.housePresentation = true;
                        setTimeout(() => {
                            this.housePresentation = false
                        }, 2000);
                        break;
                    case 'house_presentation_int':
                        this.toggleDialogHousePresentationInt(true)
                        break;
                    case 'shio_request':
                        // OTHER REVISION AND HRD PROCESS AND CPN SHIO REQUEST WILL NOT BE ABLE TO REMOVE
                        if(this.$store.state.prevShio && this.$store.state.prevShio.shio_request != null && this.$store.state.editCadRequestRevisionContent.shio_request != null && 
                            (this.$store.state.revisionSelection == '1' || this.editCadRequestRevisionContent.gravity == '1' || this.$store.state.revisionSelection == '2' || this.editCadRequestRevisionContent.gravity == '2' || this.$store.state.revisionSelection == '3' || this.editCadRequestRevisionContent.gravity == '3' || this.$store.state.revisionSelection == '4' || this.editCadRequestRevisionContent.gravity == '4'
                            || this.$store.state.subRevision == '5Z' || this.$store.state.subRevision == '5A' || this.$store.state.subRevision == '5B' || this.$store.state.subRevision == '5C'
                            || this.$store.state.editCadRequestRevisionContent.gravity_type == '5Z' || this.$store.state.editCadRequestRevisionContent.gravity_type == '5A' || this.$store.state.editCadRequestRevisionContent.gravity_type == '5B' || this.$store.state.editCadRequestRevisionContent.gravity_type == '5C') || 
                            ((this.$store.state.revisionSelection == '8' || this.editCadRequestRevisionContent.gravity == '8') && this.editCadRequestRevisionContent.isHrdCpn != 1) || ((this.$store.state.revisionSelection == '9' || this.editCadRequestRevisionContent.gravity == '9') && this.editCadRequestRevisionContent.isHrdCpn != 1)){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                '以前に「仕様検討ツール」依頼がありました。<br>' +
                                '「仕様検討ツール」依頼の選択を解除できません。<br>' +
                                '再度「仕様検討ツール」依頼を入力してください。',
                            icon: 'warning',
                            width : 730,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            })
                            return;
                        }
                           //  UNSELECTABLE shio IF WITH PDR
                        // new
                        if( this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                            if(this.$store.state.editCadRequestRevisionContent.electrical_drawing && ["1", "2", "3"].includes(this.$store.state.editCadRequestRevisionContent.electrical_drawing.radioPdr)){
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                    '提案電気図面時には以下の書類を作成する必要があります。<br>' +
                                    '<br><br><span style="color:blue;"> 仕様検討ツール </span>',
                                    icon: 'warning',
                                    width : 730,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                })
                                return;
                            }
                        }else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                            if(this.$store.state.editCadRequestRevisionContent.electrical_drawing && ["1", "2", "3"].includes(this.$store.state.editCadRequestRevisionContent.electrical_drawing.radioPdr)){
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                    '提案電気図面時には以下の書類を作成する必要があります。<br>' +
                                    '<br><br><span style="color:blue;"> 仕様検討ツール </span>',
                                    icon: 'warning',
                                    width : 730,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                })
                                return;
                            }
                        }
                        
                        if(this.$store.state.cadRequestBasicInformation.provisional_contract_date == null && this.$store.state.cadRequestBasicInformation.contract_date == null){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                '仮契約⽇または本契約⽇が基本情報に反映されていないため<br>' +
                                '「仕様検討ツール」を依頼することができません。<br>' +
                                '契約済みの場合は、基本情報にて契約⽇を⼊⼒してください。',
                            icon: 'warning',
                            width : 730,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            })
                            return;
                        }
                        // value = this.$store.state.editCadRequestRevisionContent[header];
                        // this.$set(this.$store.state.editCadRequestRevisionContent, header, !value) 
                        if(this.$store.state.editCadRequestRevisionContent.shio_request){
                            let shiyo = {
                                shio_selection: null,
                                shio_number: null,
                            };
                            this.$set(this.$store.state.editCadRequestRevisionContent, header, false);
                            this.$set(this.$store.state.editCadRequestRevisionContent, 'SRS_request', shiyo);
                        }else{
                            this.toggleDialogShioRequest(true);
                        }
                        break;
                    case 'web_documents':
                        this.toggleDialogWebDocuments(true)
                        break;
                    case 'jiban_plan':
                        if(this.editCadRequestRevisionContent.jiban_plan && this.editCadRequestRevisionContent.stop){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                'STOPチェック時には以下の書類を作成する必要があります。<br><br>' +
                                'カラー配置図 (測定点入)<br>' +
                                'ALVS検討',
                            icon: 'warning',
                            width : 730,
                            })
                            return;
                        }
                        if(this.$store.state.editCadRequestRevisionContent.jiban_plan){
                            this.$set(this.$store.state.editCadRequestRevisionContent, 'jiban_plan', false)
                            if(this.editCadRequestRevisionContent.calculation_basis || this.editCadRequestRevisionContent.jiban_plan ||
                                this.editCadRequestRevisionContent.alvs || (this.editCadRequestRevisionContent.structural_request && this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.editCadRequestRevisionContent.stop){
                                    this.disableExpress = true;
                            }else{
                                    this.disableExpress = false;
                            }
                            // this.disableExpress = false; 
                        }else{
                            this.toggleDialogConfirmationItems(true)
                            this.$store.state.editCadRequestRevisionContent.express = false
                            if(this.editCadRequestRevisionContent.calculation_basis || this.editCadRequestRevisionContent.jiban_plan ||
                                this.editCadRequestRevisionContent.alvs || (this.editCadRequestRevisionContent.structural_request && this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.editCadRequestRevisionContent.stop){
                                    this.disableExpress = true;
                            }else{
                                    this.disableExpress = false;
                            }
                        }
                        
                        break;
                    case 'alvs':
                        if(this.editCadRequestRevisionContent.stop && this.editCadRequestRevisionContent.alvs){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                'STOPチェック時には以下の書類を作成する必要があります。<br><br>' +
                                'カラー配置図 (測定点入)<br>' +
                                'ALVS検討',
                            icon: 'warning',
                            width : 730,
                            })
                            return;
                        }

                        // FOR 3RD TIME AND MORE ALVS REQUEST
                        if (this.$store.state.countOfAlvsRequest && this.$store.state.countOfAlvsRequest >= 2) {
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                                'ALVSは２回までの依頼制限となる予定です。（近日中に対応予定）<br>' +
                                '依頼回数２回以内にできるように設計業務の見直しお願いします。',
                                icon: 'warning',
                                width: 730,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            });
                        }

                        this.toggleDialogAlvs(true)
                        break;
                    case 'structural_request':
                        this.$store.state.structOrStop = 'structural';
                        this.toggleDialogStructuralRequest(true)
                        break;
                    case 'elevation_request':
                        // this.toggleDialogElectricalDrawing(true) // ?? NOT SURE ABOUT THIS
                        // this.toggleDialogElevationRequest(true)

                        // ----- SSD24-1028783-1746 SECOND TIME DANMENZU REQUEST CONDITION -----
                        if (this.$store.state.cadRequestBasicInformation.kakouirai_reason != '' && this.$store.state.cadRequestBasicInformation.kakouirai_reason != null) {
                            this.toggleDialogElevationRequest(true)
                        } else {
                            if (this.loggedInUser.type != 'Admin' && this.loggedInUser.type != 'Plan Control') {
                                let count = this.existingRevisions.filter(item => item.elevation_section || item.cross_section)
                                if (count.length >= 1) {
                                    Swal.fire({
                                        html: '<div style="text-align: center;font-size:20px;font-weight:bold;">' +
                                            '１物件に対して、断面図/申請用立面図は１回のみ依頼可能です。<br>' +
                                            '（長期物件または加工ストップ物件は除く）<br>' +
                                            '断面図/申請用立面図が複数回必要な場合は、設計部にご相談ください。',
                                        icon: 'warning',
                                        width : 715,
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                    });
                                } else {
                                    this.toggleDialogElevationRequest(true)
                                }
                            } else {
                                this.toggleDialogElevationRequest(true)
                            }
                        }

                        break;
                    case 'stop':
                        // RESTRICTION FOR CAD NASHI
                        // if(this.$store.state.revisionSelection == '6' || this.$store.state.subRevision == '5D'){
                        //     Swal.fire({
                        //             html: '<div style="text-align: center;font-size:20px;font-weight:bold;">' +
                        //                 'STOPチェックはCAD変更に影響する可能性があります。<br>' +
                        //                 '図面番号入力で「CAD図面番号の変更なし」を選択しないでください。',
                        //             icon: 'warning',
                        //             width : 715,
                        //         });
                        //     return;
                        // }

                        let code = /^(0009999)/;
                        if(code.test(this.cadRequestBasicInformation.construction_code)){
                            this.toggleDialogStop(true);
                            
                            if(this.editCadRequestRevisionContent.calculation_basis || this.editCadRequestRevisionContent.jiban_plan ||
                                this.editCadRequestRevisionContent.alvs || (this.editCadRequestRevisionContent.structural_request && this.editCadRequestRevisionContent.structural_request.OPTION_1 == 'あり') || this.editCadRequestRevisionContent.stop){
                                    this.disableExpress = true;
                            }else{
                                    this.disableExpress = false;
                            }

                        }else{
                            if(this.$store.state.editCadRequestRevisionContent.stop){
                                this.$set(this.$store.state.editCadRequestRevisionContent, 'stop', false) 
                            }else{
                                this.$store.state.structOrStop = 'stop';
                                // this.toggleDialogStructuralRequest(true)
                                const filteredStop = this.$store.state.existingRevisions.filter((res) => {
                                    return res.stop == 1;
                                })
                                this.stopPlan = filteredStop.length + 1;
                                this.dialogStop2 = true
                            }
                        }

                        break;
                    case 'pdr':
                        // this.toggleDialogPdr(true)
                        // value = this.$store.state.editCadRequestRevisionContent[header];
                        // this.$set(this.$store.state.editCadRequestRevisionContent, header, !value) 
                        break;
                    case 'electrical_drawing':
                        this.toggleDialogElectricalDrawing(true)
                        break;
                    // case 'drawing_request':
                    case 'final_plan':
                        if(this.$store.state.revisionSelection == '6' || this.$store.state.subRevision == '5D'){
                            if (this.$store.state.xmlTable.length === 0) {
                                Swal.fire({
                                    html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
                                        '初回 着手準備依頼はCAD変更に影響する可能性があります。<br>' +
                                        `図面番号入力で<span style="color:blue;">「CAD図面番号の変更なし」</span>を選択しないでください。<br>`,
                                    icon: 'warning',
                                    width : 670,
                                });
                                // .then((resulta) => {
                                //     if(resulta.isConfirmed) {
                                //         this.radio = null;
                                //         this.radio3 = null;
                                //         return false;
                                //     }
                                // })
                            }  else {
                                this.toggleDialogDrawingRequest(true)
                            }
                        } else {
                            this.toggleDialogDrawingRequest(true)
                        }
                        break;
                    case 'express':
                        value = this.$store.state.editCadRequestRevisionContent[header];
                        if(this.disableExpress == true){
                            Swal.fire({
                                title: '下記の依頼を即日依頼に含めることはできません。',
                                html: '<div style="text-align: left;">' +
                                    '・最高高さ・見付面積・平均GL計算根拠 <br>' +
                                    '・カラー配置図 (測定点入) <br>' +
                                    '・ALVS検討依頼 <br>' +
                                    '・構造事前検討依頼 <br>' +
                                    '・提案電気図面依頼 <br>' +
                                    '・STOP</div>',
                                icon: 'warning',
                            });
                        }
                        // FIRST TIME FP FOR EXPRESS PLAN FOR UPDATE/EDIT
                        if (this.$store.state.editCadRequestRevisionContent.final_plan != null) 
                            if (this.$store.state.xmlTable.length == 0){
                            Swal.fire({
                                html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                                '初回 着手準備依頼はCAD変更に影響する可能性があります。 <br>' +
                                '「<span style="color:red;">即日依頼</span>」としてリクエストすることはできません',
                            icon: 'warning',
                            width : 730,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            })
                        } else{
                            this.$set(this.$store.state.editCadRequestRevisionContent, header, !value)
                        }
                        break;
                    case 'value':
                        
                        break;
                    case 'value':
                        break;
                    case 'value':
                        
                        break;
                    case 'request_attach_from':
                        if(object.attachments){
                            this.$store.state.previousAttachmentFiles = object.attachments.filter((r) => {
                                r.fileType = r.filename.split('.')[1]
                                return r
                            })
                        }
                        this.toggleDialogAttachmentForm(true)
                        break;
                }
                this.$nextTick(()=> {
                })  
            }
        },
 

        toggleDialogRevision(value){
			if(value){
				this.dialogRevision = true;
			}else{
				this.dialogRevision = false;
			}
		},

        GetDialogRevisionData(data){
            this.$store.state.forMounHp = data;
                this.$set(this.$store.state.cadRequestRevisionContent, 'revision', data)
                this.$store.state.cadRequestLatestRevision = data;	
        },

        checkHeader(header){
            if(header == 'CAD依頼送信者'){
                return 'second-top-left-sticky ' 
            }else if(header == '図面番号'){
                return 'third-top-left-sticky ' 
            }

            return 'left-sticky '
        },
    
    // END

        save(){},
        open(){},
        cancel(){},
        close(){},

         /** @param {MouseEvent} ev */
        onMouseDown(ev) {
            // this.$nextTick(() => {
                this.cursorPos = [ev.pageX, ev.pageY];
                this.isDragging = true;

                window.addEventListener("mousemove", this.onMouseHold);
            // })
        },

        /** @param {MouseEvent} ev */
        onMouseUp(ev) {
            window.removeEventListener("mousemove", this.onMouseHold);
            this.isDragging = false;
        },

        /** @param {MouseEvent} ev */
        onMouseHold(ev) {
            ev.preventDefault();
                requestAnimationFrame(() => {
                    const delta = [
                        ev.pageX - this.cursorPos[0],
                        ev.pageY - this.cursorPos[1],
                    ];

                    this.cursorPos = [ev.pageX, ev.pageY];

                    if (!this.$refs.el) return;
                    this.$refs.el.scrollBy({
                    left: -delta[0],
                    top: -delta[1],
                    });
                });
            // })
        },

        // AUTOMATIC SCROLL TO LEFT
        scrollToBottom() {
            const table = this.$refs.myTable;
            if (table) {
                const container = table.$el.querySelector('.v-data-table__wrapper');
                if (container) {
                    container.scrollLeft = container.scrollWidth;
                }
            }
        },
    },

    updated() {
        this.$nextTick(() => {
        this.scrollToBottom();
        });
    },

     mounted() {
        // Auto disabled when load
        // window.addEventListener('keydown', this.handleKeyDown);
        // AUTOMATIC SCROLL TO LEFT
        this.$nextTick(() => {
            this.scrollToBottom();
        });
        this._getSashType();
        this._getSashAccessories();
        this.activeBtn = 0;
        window.addEventListener("mouseup", this.onMouseUp);
        this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        axios({
            method : 'get',
            url : 'api/getHokkaidou'
        }).then((res) => {
            this.$store.state.hokkaidou = res.data
        })

       this._getPlanner()
    },

    // DISABLED F12 AND RIGHT CLICK
    beforeDestroy() {
        // Remove the keydown event listener when the component is destroyed
        // window.removeEventListener('keydown', this.handleKeyDown);
    },

    destroyed() {
        window.removeEventListener("mouseup", this.onMouseUp);
    },

    watch: {  
        overlayPlanner(val){
            this.loader = val;
        },

        "$store.state.cadRequestRevisionContent"(val){
            if(!this.copyFunction){
                this.$store.state.cadRequestColorPers = val.color_perspective ? val.color_perspective : null
                this.$store.state.cad_request_house_presentation = val.hp ? val.hp : null

                if(val.color_pers != '0' && val.color_pers != null){
                    this.$store.state.hideColorPersTable = this.$store.state.cadRequestColorPers ? this.$store.state.cadRequestColorPers[0].is_request_color_info : null;
                }

                if(val.house_presentation != '0' && val.house_presentation != null){
                    this.$store.state.hideHpTable = this.$store.state.cad_request_house_presentation ? this.$store.state.cad_request_house_presentation[0].is_request_color_info : null;
                }

                    if(val.specs_irai != null){

                        this.toggleB6_1 = val.specs_irai.sash_type != null ? val.specs_irai.sash_type : null; 
                        this.toggleB6_2 = val.specs_irai.specs != null ? val.specs_irai.specs : null; 
                        this.toggleB6_3 = val.specs_irai.accessories.map((r) => {
                            return r.value
                        })
                        this.toggleB6_4 = val.specs_irai.honeycomb != null ? val.specs_irai.honeycomb : null;
                    }else{
                        this.toggleB6_1 = null; 
                        this.toggleB6_2 = null; 
                        this.toggleB6_3 = [];
                        this.toggelB6_4 = null;
                    }  
            }
            
            // PAG HRD PROCESS YUNG PLANO MO TAPOS PAG MAY MGA FIELDS NA HINDI NA-COPY CHECK MO RITO. EYY KA MUNA
            if(this.$store.state.hrdprocessMode){
                this.$store.state.cadRequestRevisionContent.status = '';
                let tempEdit = [];
                if(this.$store.state.cadRequestColorPers != null){
                    for (let i = 0; i < this.$store.state.cadRequestColorPers.length; i++) {
                        // this.cadRequestColorPers[i] = {...this.cadRequestColorPers[i]}

                        let data = {
                            is_request_color_info: this.cadRequestColorPers[i].is_request_color_info,
                            roof: {
                                    roofing_material: null,
                                    roof_color: this.cadRequestColorPers[i].roof.roof_color,
                                },
                            spray_1f: this.cadRequestColorPers[i].spray_1f,
                            spray_2f: this.cadRequestColorPers[i].spray_2f,
                            spray_3f: this.cadRequestColorPers[i].spray_3f,
                            exterior_wall_tile : this.cadRequestColorPers[i].exterior_wall_tile,
                            external_wall_finish : this.cadRequestColorPers[i].external_wall_finish,
                            // exterior_wall_tile : {
                            //     color_construction: null,
                            //     exterior_wall_tile_color: this.cadRequestColorPers[i].exterior_wall_tile,
                            //     accent_wall_color: this.cadRequestColorPers[i].accent_wall_color,
                            //     },
                            balcony_glass : this.cadRequestColorPers[i].balcony_glass,
                            design_louver : this.cadRequestColorPers[i].design_louver,
                            sash : this.cadRequestColorPers[i].sash,
                            front_door : {
                                entrance_door_type: null,
                                door_item: null,
                                door_color: this.cadRequestColorPers[i].front_door.door_color,
                                },
                            mall_and_arrowhead_decoration : this.cadRequestColorPers[i].mall_and_arrowhead_decoration,
                            balcony_belt : this.cadRequestColorPers[i].balcony_belt,
                            tile_band : this.cadRequestColorPers[i].tile_band,
                            decorative_belt_1f : this.cadRequestColorPers[i].decorative_belt_1f,
                            decorative_belt_2f : this.cadRequestColorPers[i].decorative_belt_2f,
                            eaves_of_a_house : this.cadRequestColorPers[i].eaves_of_a_house,
                            eaves_gutter : this.cadRequestColorPers[i].eaves_gutter,
                            breaking_wind : this.cadRequestColorPers[i].breaking_wind,
                            base_draining : this.cadRequestColorPers[i].base_draining,
                            porch_tile : {
                                porch_tile_item: null,
                                porch_tile_item_color: this.cadRequestColorPers[i].porch_tile.porch_tile_item_color,
                            },
                            perspective_direction : this.cadRequestColorPers[i].perspective_direction,
                            viewpoint_height : this.cadRequestColorPers[i].viewpoint_height,
                            garden_number : this.cadRequestColorPers[i].garden_number,
                        }
                        tempEdit.push(data)

                    }
                    this.$store.state.cadRequestColorPers = [];
                    this.$store.state.cadRequestColorPers = tempEdit;

                }
                if(val.web_documents != null && val.web_documents.length > 0){
                    val.web_documents.filter((r) => {
                        this.$store.state.edit_webDocs.push({
                            value : r.value,
                            text : r.text
                        })
                    })
                }

                if(val.calculation_basis || val.jiban_plan ||
                    val.alvs || (val.structural_request && val.structural_request.OPTION_1 == 'あり') || val.stop){
                        this.disableExpress = true;
                    
                }else{
                        this.disableExpress = false;
                }

            }else{
                this.$store.state.cadRequestRevisionContent.hrd_process = 0;
            }

        },
        '$store.state.cadRequestRevisionContent.design_contract'(val){
        },
        editMode(val){
        },
        "$store.state.cadRequestBasicInformation"(val){
        
        // this.getALVSStopCheck(this.cadRequestBasicInformation.construction_code) // ----- FOR 3RD TIME AND MORE ALVS REQUEST (moved to dialogrevision)-----

            this.disableReform = false;
            this.disableOtherSelections = false;
            if(val.customer_name){
                if(val.customer_name.includes(" ")){
                    val.customer_name = val.customer_name.split(" ")[0];
                }else if(val.customer_name.includes("　")){
                    val.customer_name = val.customer_name.split("　")[0];
                }
            }
            if(val.construction_code){
                this.getCadActualData();
            }

            if(val.kakouirai_reason == 5){
                this.disableReform = true;
            }

            if(val.kakouirai_reason == 1){
                this.disableOtherSelections = true;
            }
        },
        "$store.state.cadRequestPdr"(val){
        },
        "$store.state.disableSelections"(val){
        },
        "$store.state.editCadRequestRevisionContent.web_documents"(val){
            if(val){
                let values = [];
                let hpItems = [];
                let success = false;

                let docs = [2,3,4,5];
                if(val.length > 0){
                    val.forEach(web => {
                        values.push(web.value)
                    });
                for (let index = 0; index < values.length; index++) {
                    if (docs.includes(values[index])) {
                        success = true;
                        break;
                    }
                }
               
                    if(success){
                        if(this.editCadRequestRevisionContent.house_presentation != '1'){
                            this.$store.state.hideHpTable = 0;
                            this.editCadRequestRevisionContent.house_presentation = 1;
                            this.edit_cad_request_house_presentation.push(
                                {
                                    cad_request_id : null,
                                    revision : null,
                                    house_type_id : null,
                                    is_request_color_info : 0,
                                    drawing_number : null,
                                    building_type : null,
                                    artificial_color : null,
                                    fittings_color : null,
                                    flooring_1f : null,
                                    flooring_2f : null,
                                    flooring_3f : null,
                                    staircase_color : null,
                                    kitchen_set : null,
                                    kitchen_counter : null,
                                    slit_slider : null,
                                    stone_patterned_floor : null,
                                    hanging_closure_unit : null,
                                    grid_sliding_door : null,
                                    perspective_direction : '5',
                                    viewpoint_height : null
                                }
                            )
                        }else if(this.editCadRequestRevisionContent.house_presentation == '1'){
                            this.edit_cad_request_house_presentation.forEach(item => {
                                hpItems.push(item.perspective_direction)
                            });
                            if(hpItems.includes('5') == false && hpItems.includes('7') == false){
                                this.edit_cad_request_house_presentation.push(
                                    {
                                        cad_request_id : null,
                                        revision : null,
                                        house_type_id : null,
                                        is_request_color_info : 0,
                                        drawing_number : null,
                                        building_type : null,
                                        artificial_color : null,
                                        fittings_color : null,
                                        flooring_1f : null,
                                        flooring_2f : null,
                                        flooring_3f : null,
                                        staircase_color : null,
                                        kitchen_set : null,
                                        kitchen_counter : null,
                                        slit_slider : null,
                                        stone_patterned_floor : null,
                                        hanging_closure_unit : null,
                                        grid_sliding_door : null,
                                        perspective_direction : '5',
                                        viewpoint_height : null
                                    }
                                )
                            }
                        }
                    }
            }
        
            }
        },
        "$store.state.edit_cad_request_house_presentation"(val){
        },
        "$store.state.cadRequestRevisionContent.web_documents"(val){
            let values = [];
            let hpItems = [];
            let success = false;

            let docs = [2,3,4,5];
            if(val){
                if(val.length > 0){
                    val.forEach(web => {
                        values.push(web.value)
                    });
                    for (let index = 0; index < values.length; index++) {
                        if (docs.includes(values[index])) {
                            success = true;
                            break;
                        }
                    }
                    

                    if(success){
                        if(this.cadRequestRevisionContent.house_presentation != '1'){
                            this.$store.state.hideHpTable = 0;
                            this.cadRequestRevisionContent.house_presentation = 1;
                            this.cad_request_house_presentation.push(
                                {
                                    cad_request_id : null,
                                    revision : null,
                                    house_type_id : null,
                                    is_request_color_info : 0,
                                    drawing_number : null,
                                    building_type : null,
                                    artificial_color : null,
                                    fittings_color : null,
                                    flooring_1f : null,
                                    flooring_2f : null,
                                    flooring_3f : null,
                                    staircase_color : null,
                                    kitchen_set : null,
                                    kitchen_counter : null,
                                    slit_slider : null,
                                    stone_patterned_floor : null,
                                    hanging_closure_unit : null,
                                    grid_sliding_door : null,
                                    perspective_direction : 5,
                                    viewpoint_height : null
                                }
                            )
                        }else if(this.cadRequestRevisionContent.house_presentation == '1'){
                            this.cad_request_house_presentation.forEach(item => {
                                hpItems.push(item.perspective_direction)
                            });
                            if(this.hideHpTable == 0) {
                                if((hpItems.includes('5') == false && hpItems.includes(5) == false) && (hpItems.includes('7') == false && hpItems.includes(7) == false)){
                                    this.cad_request_house_presentation.push(
                                        {
                                            cad_request_id : null,
                                            revision : null,
                                            house_type_id : null,
                                            is_request_color_info : 0,
                                            drawing_number : null,
                                            building_type : null,
                                            artificial_color : null,
                                            fittings_color : null,
                                            flooring_1f : null,
                                            flooring_2f : null,
                                            flooring_3f : null,
                                            staircase_color : null,
                                            kitchen_set : null,
                                            kitchen_counter : null,
                                            slit_slider : null,
                                            stone_patterned_floor : null,
                                            hanging_closure_unit : null,
                                            grid_sliding_door : null,
                                            perspective_direction : 5,
                                            viewpoint_height : null
                                        }
                                    )
                                }
                            }
                        }
                    }
                    else{
                        if(this.cadRequestRevisionContent.house_presentation == '1'){
                            this.cad_request_house_presentation.forEach(item => {
                                hpItems.push(item.perspective_direction)
                            });
                            if(hpItems.includes('5') == false && hpItems.includes('7') == false){
                                this.cad_request_house_presentation.push(
                                    {
                                        cad_request_id : null,
                                        revision : null,
                                        house_type_id : null,
                                        is_request_color_info : 0,
                                        drawing_number : null,
                                        building_type : null,
                                        artificial_color : null,
                                        fittings_color : null,
                                        flooring_1f : null,
                                        flooring_2f : null,
                                        flooring_3f : null,
                                        staircase_color : null,
                                        kitchen_set : null,
                                        kitchen_counter : null,
                                        slit_slider : null,
                                        stone_patterned_floor : null,
                                        hanging_closure_unit : null,
                                        grid_sliding_door : null,
                                        perspective_direction : 5,
                                        viewpoint_height : null
                                    }
                                )
                            }
                        }
                    }
                }
            }
        },

        "$store.state.cadRequestRevisionContent.site_layout"(val){
            if(val){
                this.toggleB5 = val;
            } else {
                this.toggleB5 = null;
            }      
        }
    },

}
</script>

<style scoped>
    .black-tab {
        color: black !important; 
    }

    .gray-tab {
        color: gray !important;
    }

    .blue-tab {
        color: #1976d2 !important;
        /* color: blue !important; */
    }

    :target {
        color: blue;
        background-color: none !important;
    }
    .v-data-table.plannersTable th {
        background: #d1d4d1!important;
        color: black!important;
        border: 1px solid black;
        border-left: 1px solid black !important;
        border-right: 1px solid black !important;
    }

     .v-data-table.plannersTable td {
        border: 1px solid black;
    }

    .top-sticky {
        position: sticky;
        top: 0;
        z-index: 1;
    }

    .left-sticky {
        position: sticky;
        left: 0;
        z-index: 1;
    }

    .top-left-sticky {
        position: sticky;
        top: 0 !important;
        left: 0;
        z-index: 3 !important;    
    }

    .second-top-left-sticky{
        position: sticky;
        top: 71px !important;
        bottom: auto;
        left: 0;
        z-index: 3 !important;  
    }

    .second2-top-left-sticky{
        position: sticky;
        top: 71px !important;
        bottom: auto;
        left: 0;
        z-index: 1 !important;  
        text-align: center; 
        background: #d1d4d1;
     
    

    }

    .third-top-left-sticky{
        position: sticky;
        top: 111px !important;
        bottom: auto;
        left: 0;
        z-index: 3 !important;  

    }

    .third2-top-left-sticky{
        position: sticky;
        top: 111px !important;
        bottom: auto;
        left: 0;
        z-index: 1 !important; 
        text-align: center; 
        background: #d1d4d1;
    }

    .selected{
        border: 2px solid red !important;
    }

    .specific-toggle > .v-btn {
        padding: 0 2px;
    }

    .btn-toggle {
        flex-direction: column;
    }

    .fillCell{
        height: 75px;
    }

    .custom-cell{
        height: 60px !important;
        cursor: pointer;
    }
    
    .disabled-cell{
        background-color: #424242;
        cursor: not-allowed;
        pointer-events: none;
    }

    .highlight-bg {
        background-color: red;
        animation: highlight-blink 1s linear infinite;
    }

    @keyframes highlight-blink {
        0% {
        background-color: red;
        }
        50% {
        background-color: transparent;
        }
        100% {
        background-color: red;
        }
    }

</style>
